export default [
  {
    id: 2,
    regionCode: "110000",
    regionName: "北京",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3,
        regionCode: "110100",
        regionName: "北京市",
        parentCode: "110000",
        level: 2,
        children: [
          {
            id: 4,
            regionCode: "110101",
            regionName: "东城区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 5,
            regionCode: "110102",
            regionName: "西城区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 6,
            regionCode: "110105",
            regionName: "朝阳区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 7,
            regionCode: "110106",
            regionName: "丰台区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 8,
            regionCode: "110107",
            regionName: "石景山区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 9,
            regionCode: "110108",
            regionName: "海淀区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 10,
            regionCode: "110109",
            regionName: "门头沟区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 11,
            regionCode: "110111",
            regionName: "房山区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 12,
            regionCode: "110112",
            regionName: "通州区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 13,
            regionCode: "110113",
            regionName: "顺义区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 14,
            regionCode: "110114",
            regionName: "昌平区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 15,
            regionCode: "110115",
            regionName: "大兴区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 16,
            regionCode: "110116",
            regionName: "怀柔区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 17,
            regionCode: "110117",
            regionName: "平谷区",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 18,
            regionCode: "110228",
            regionName: "密云县",
            parentCode: "110100",
            level: 3,
          },
          {
            id: 19,
            regionCode: "110229",
            regionName: "延庆县",
            parentCode: "110100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 20,
    regionCode: "120000",
    regionName: "天津",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 21,
        regionCode: "120100",
        regionName: "天津市",
        parentCode: "120000",
        level: 2,
        children: [
          {
            id: 22,
            regionCode: "120101",
            regionName: "和平区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 23,
            regionCode: "120102",
            regionName: "河东区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 24,
            regionCode: "120103",
            regionName: "河西区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 25,
            regionCode: "120104",
            regionName: "南开区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 26,
            regionCode: "120105",
            regionName: "河北区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 27,
            regionCode: "120106",
            regionName: "红桥区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 28,
            regionCode: "120110",
            regionName: "东丽区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 29,
            regionCode: "120111",
            regionName: "西青区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 30,
            regionCode: "120112",
            regionName: "津南区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 31,
            regionCode: "120113",
            regionName: "北辰区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 32,
            regionCode: "120114",
            regionName: "武清区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 33,
            regionCode: "120115",
            regionName: "宝坻区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 34,
            regionCode: "120116",
            regionName: "滨海新区",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 35,
            regionCode: "120221",
            regionName: "宁河县",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 36,
            regionCode: "120223",
            regionName: "静海县",
            parentCode: "120100",
            level: 3,
          },
          {
            id: 37,
            regionCode: "120225",
            regionName: "蓟县",
            parentCode: "120100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 38,
    regionCode: "130000",
    regionName: "河北省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 39,
        regionCode: "130100",
        regionName: "石家庄市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 40,
            regionCode: "130102",
            regionName: "长安区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 41,
            regionCode: "130104",
            regionName: "桥西区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 42,
            regionCode: "130105",
            regionName: "新华区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 43,
            regionCode: "130107",
            regionName: "井陉矿区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 44,
            regionCode: "130108",
            regionName: "裕华区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 45,
            regionCode: "130109",
            regionName: "藁城区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 46,
            regionCode: "130110",
            regionName: "鹿泉区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 47,
            regionCode: "130111",
            regionName: "栾城区",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 48,
            regionCode: "130121",
            regionName: "井陉县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 49,
            regionCode: "130123",
            regionName: "正定县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 50,
            regionCode: "130125",
            regionName: "行唐县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 51,
            regionCode: "130126",
            regionName: "灵寿县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 52,
            regionCode: "130127",
            regionName: "高邑县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 53,
            regionCode: "130128",
            regionName: "深泽县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 54,
            regionCode: "130129",
            regionName: "赞皇县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 55,
            regionCode: "130130",
            regionName: "无极县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 56,
            regionCode: "130131",
            regionName: "平山县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 57,
            regionCode: "130132",
            regionName: "元氏县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 58,
            regionCode: "130133",
            regionName: "赵县",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 59,
            regionCode: "130181",
            regionName: "辛集市",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 60,
            regionCode: "130183",
            regionName: "晋州市",
            parentCode: "130100",
            level: 3,
          },
          {
            id: 61,
            regionCode: "130184",
            regionName: "新乐市",
            parentCode: "130100",
            level: 3,
          },
        ],
      },
      {
        id: 62,
        regionCode: "130200",
        regionName: "唐山市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 63,
            regionCode: "130202",
            regionName: "路南区",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 64,
            regionCode: "130203",
            regionName: "路北区",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 65,
            regionCode: "130204",
            regionName: "古冶区",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 66,
            regionCode: "130205",
            regionName: "开平区",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 67,
            regionCode: "130207",
            regionName: "丰南区",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 68,
            regionCode: "130208",
            regionName: "丰润区",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 69,
            regionCode: "130209",
            regionName: "曹妃甸区",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 70,
            regionCode: "130223",
            regionName: "滦县",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 71,
            regionCode: "130224",
            regionName: "滦南县",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 72,
            regionCode: "130225",
            regionName: "乐亭县",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 73,
            regionCode: "130227",
            regionName: "迁西县",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 74,
            regionCode: "130229",
            regionName: "玉田县",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 75,
            regionCode: "130281",
            regionName: "遵化市",
            parentCode: "130200",
            level: 3,
          },
          {
            id: 76,
            regionCode: "130283",
            regionName: "迁安市",
            parentCode: "130200",
            level: 3,
          },
        ],
      },
      {
        id: 77,
        regionCode: "130300",
        regionName: "秦皇岛市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 78,
            regionCode: "130302",
            regionName: "海港区",
            parentCode: "130300",
            level: 3,
          },
          {
            id: 79,
            regionCode: "130303",
            regionName: "山海关区",
            parentCode: "130300",
            level: 3,
          },
          {
            id: 80,
            regionCode: "130304",
            regionName: "北戴河区",
            parentCode: "130300",
            level: 3,
          },
          {
            id: 81,
            regionCode: "130321",
            regionName: "青龙满族自治县",
            parentCode: "130300",
            level: 3,
          },
          {
            id: 82,
            regionCode: "130322",
            regionName: "昌黎县",
            parentCode: "130300",
            level: 3,
          },
          {
            id: 83,
            regionCode: "130323",
            regionName: "抚宁县",
            parentCode: "130300",
            level: 3,
          },
          {
            id: 84,
            regionCode: "130324",
            regionName: "卢龙县",
            parentCode: "130300",
            level: 3,
          },
        ],
      },
      {
        id: 85,
        regionCode: "130400",
        regionName: "邯郸市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 86,
            regionCode: "130402",
            regionName: "邯山区",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 87,
            regionCode: "130403",
            regionName: "丛台区",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 88,
            regionCode: "130404",
            regionName: "复兴区",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 89,
            regionCode: "130406",
            regionName: "峰峰矿区",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 90,
            regionCode: "130421",
            regionName: "邯郸县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 91,
            regionCode: "130423",
            regionName: "临漳县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 92,
            regionCode: "130424",
            regionName: "成安县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 93,
            regionCode: "130425",
            regionName: "大名县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 94,
            regionCode: "130426",
            regionName: "涉县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 95,
            regionCode: "130427",
            regionName: "磁县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 96,
            regionCode: "130428",
            regionName: "肥乡县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 97,
            regionCode: "130429",
            regionName: "永年县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 98,
            regionCode: "130430",
            regionName: "邱县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 99,
            regionCode: "130431",
            regionName: "鸡泽县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 100,
            regionCode: "130432",
            regionName: "广平县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 101,
            regionCode: "130433",
            regionName: "馆陶县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 102,
            regionCode: "130434",
            regionName: "魏县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 103,
            regionCode: "130435",
            regionName: "曲周县",
            parentCode: "130400",
            level: 3,
          },
          {
            id: 104,
            regionCode: "130481",
            regionName: "武安市",
            parentCode: "130400",
            level: 3,
          },
        ],
      },
      {
        id: 105,
        regionCode: "130500",
        regionName: "邢台市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 106,
            regionCode: "130502",
            regionName: "桥东区",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 107,
            regionCode: "130503",
            regionName: "桥西区",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 108,
            regionCode: "130521",
            regionName: "邢台县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 109,
            regionCode: "130522",
            regionName: "临城县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 110,
            regionCode: "130523",
            regionName: "内丘县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 111,
            regionCode: "130524",
            regionName: "柏乡县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 112,
            regionCode: "130525",
            regionName: "隆尧县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 113,
            regionCode: "130526",
            regionName: "任县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 114,
            regionCode: "130527",
            regionName: "南和县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 115,
            regionCode: "130528",
            regionName: "宁晋县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 116,
            regionCode: "130529",
            regionName: "巨鹿县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 117,
            regionCode: "130530",
            regionName: "新河县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 118,
            regionCode: "130531",
            regionName: "广宗县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 119,
            regionCode: "130532",
            regionName: "平乡县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 120,
            regionCode: "130533",
            regionName: "威县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 121,
            regionCode: "130534",
            regionName: "清河县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 122,
            regionCode: "130535",
            regionName: "临西县",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 123,
            regionCode: "130581",
            regionName: "南宫市",
            parentCode: "130500",
            level: 3,
          },
          {
            id: 124,
            regionCode: "130582",
            regionName: "沙河市",
            parentCode: "130500",
            level: 3,
          },
        ],
      },
      {
        id: 125,
        regionCode: "130600",
        regionName: "保定市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 126,
            regionCode: "130602",
            regionName: "新市区",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 127,
            regionCode: "130603",
            regionName: "北市区",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 128,
            regionCode: "130604",
            regionName: "南市区",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 129,
            regionCode: "130621",
            regionName: "满城县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 130,
            regionCode: "130622",
            regionName: "清苑县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 131,
            regionCode: "130623",
            regionName: "涞水县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 132,
            regionCode: "130624",
            regionName: "阜平县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 133,
            regionCode: "130625",
            regionName: "徐水县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 134,
            regionCode: "130626",
            regionName: "定兴县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 135,
            regionCode: "130627",
            regionName: "唐县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 136,
            regionCode: "130628",
            regionName: "高阳县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 137,
            regionCode: "130629",
            regionName: "容城县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 138,
            regionCode: "130630",
            regionName: "涞源县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 139,
            regionCode: "130631",
            regionName: "望都县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 140,
            regionCode: "130632",
            regionName: "安新县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 141,
            regionCode: "130633",
            regionName: "易县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 142,
            regionCode: "130634",
            regionName: "曲阳县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 143,
            regionCode: "130635",
            regionName: "蠡县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 144,
            regionCode: "130636",
            regionName: "顺平县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 145,
            regionCode: "130637",
            regionName: "博野县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 146,
            regionCode: "130638",
            regionName: "雄县",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 147,
            regionCode: "130681",
            regionName: "涿州市",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 148,
            regionCode: "130682",
            regionName: "定州市",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 149,
            regionCode: "130683",
            regionName: "安国市",
            parentCode: "130600",
            level: 3,
          },
          {
            id: 150,
            regionCode: "130684",
            regionName: "高碑店市",
            parentCode: "130600",
            level: 3,
          },
        ],
      },
      {
        id: 151,
        regionCode: "130700",
        regionName: "张家口市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 152,
            regionCode: "130702",
            regionName: "桥东区",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 153,
            regionCode: "130703",
            regionName: "桥西区",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 154,
            regionCode: "130705",
            regionName: "宣化区",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 155,
            regionCode: "130706",
            regionName: "下花园区",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 156,
            regionCode: "130721",
            regionName: "宣化县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 157,
            regionCode: "130722",
            regionName: "张北县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 158,
            regionCode: "130723",
            regionName: "康保县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 159,
            regionCode: "130724",
            regionName: "沽源县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 160,
            regionCode: "130725",
            regionName: "尚义县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 161,
            regionCode: "130726",
            regionName: "蔚县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 162,
            regionCode: "130727",
            regionName: "阳原县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 163,
            regionCode: "130728",
            regionName: "怀安县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 164,
            regionCode: "130729",
            regionName: "万全县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 165,
            regionCode: "130730",
            regionName: "怀来县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 166,
            regionCode: "130731",
            regionName: "涿鹿县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 167,
            regionCode: "130732",
            regionName: "赤城县",
            parentCode: "130700",
            level: 3,
          },
          {
            id: 168,
            regionCode: "130733",
            regionName: "崇礼县",
            parentCode: "130700",
            level: 3,
          },
        ],
      },
      {
        id: 169,
        regionCode: "130800",
        regionName: "承德市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 170,
            regionCode: "130802",
            regionName: "双桥区",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 171,
            regionCode: "130803",
            regionName: "双滦区",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 172,
            regionCode: "130804",
            regionName: "鹰手营子矿区",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 173,
            regionCode: "130821",
            regionName: "承德县",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 174,
            regionCode: "130822",
            regionName: "兴隆县",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 175,
            regionCode: "130823",
            regionName: "平泉县",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 176,
            regionCode: "130824",
            regionName: "滦平县",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 177,
            regionCode: "130825",
            regionName: "隆化县",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 178,
            regionCode: "130826",
            regionName: "丰宁满族自治县",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 179,
            regionCode: "130827",
            regionName: "宽城满族自治县",
            parentCode: "130800",
            level: 3,
          },
          {
            id: 180,
            regionCode: "130828",
            regionName: "围场满族蒙古族自治县",
            parentCode: "130800",
            level: 3,
          },
        ],
      },
      {
        id: 181,
        regionCode: "130900",
        regionName: "沧州市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 182,
            regionCode: "130902",
            regionName: "新华区",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 183,
            regionCode: "130903",
            regionName: "运河区",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 184,
            regionCode: "130921",
            regionName: "沧县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 185,
            regionCode: "130922",
            regionName: "青县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 186,
            regionCode: "130923",
            regionName: "东光县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 187,
            regionCode: "130924",
            regionName: "海兴县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 188,
            regionCode: "130925",
            regionName: "盐山县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 189,
            regionCode: "130926",
            regionName: "肃宁县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 190,
            regionCode: "130927",
            regionName: "南皮县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 191,
            regionCode: "130928",
            regionName: "吴桥县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 192,
            regionCode: "130929",
            regionName: "献县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 193,
            regionCode: "130930",
            regionName: "孟村回族自治县",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 194,
            regionCode: "130981",
            regionName: "泊头市",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 195,
            regionCode: "130982",
            regionName: "任丘市",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 196,
            regionCode: "130983",
            regionName: "黄骅市",
            parentCode: "130900",
            level: 3,
          },
          {
            id: 197,
            regionCode: "130984",
            regionName: "河间市",
            parentCode: "130900",
            level: 3,
          },
        ],
      },
      {
        id: 198,
        regionCode: "131000",
        regionName: "廊坊市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 199,
            regionCode: "131002",
            regionName: "安次区",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 200,
            regionCode: "131003",
            regionName: "广阳区",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 201,
            regionCode: "131022",
            regionName: "固安县",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 202,
            regionCode: "131023",
            regionName: "永清县",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 203,
            regionCode: "131024",
            regionName: "香河县",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 204,
            regionCode: "131025",
            regionName: "大城县",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 205,
            regionCode: "131026",
            regionName: "文安县",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 206,
            regionCode: "131028",
            regionName: "大厂回族自治县",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 207,
            regionCode: "131081",
            regionName: "霸州市",
            parentCode: "131000",
            level: 3,
          },
          {
            id: 208,
            regionCode: "131082",
            regionName: "三河市",
            parentCode: "131000",
            level: 3,
          },
        ],
      },
      {
        id: 209,
        regionCode: "131100",
        regionName: "衡水市",
        parentCode: "130000",
        level: 2,
        children: [
          {
            id: 210,
            regionCode: "131102",
            regionName: "桃城区",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 211,
            regionCode: "131121",
            regionName: "枣强县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 212,
            regionCode: "131122",
            regionName: "武邑县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 213,
            regionCode: "131123",
            regionName: "武强县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 214,
            regionCode: "131124",
            regionName: "饶阳县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 215,
            regionCode: "131125",
            regionName: "安平县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 216,
            regionCode: "131126",
            regionName: "故城县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 217,
            regionCode: "131127",
            regionName: "景县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 218,
            regionCode: "131128",
            regionName: "阜城县",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 219,
            regionCode: "131181",
            regionName: "冀州市",
            parentCode: "131100",
            level: 3,
          },
          {
            id: 220,
            regionCode: "131182",
            regionName: "深州市",
            parentCode: "131100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 221,
    regionCode: "140000",
    regionName: "山西省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 222,
        regionCode: "140100",
        regionName: "太原市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 223,
            regionCode: "140105",
            regionName: "小店区",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 224,
            regionCode: "140106",
            regionName: "迎泽区",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 225,
            regionCode: "140107",
            regionName: "杏花岭区",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 226,
            regionCode: "140108",
            regionName: "尖草坪区",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 227,
            regionCode: "140109",
            regionName: "万柏林区",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 228,
            regionCode: "140110",
            regionName: "晋源区",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 229,
            regionCode: "140121",
            regionName: "清徐县",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 230,
            regionCode: "140122",
            regionName: "阳曲县",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 231,
            regionCode: "140123",
            regionName: "娄烦县",
            parentCode: "140100",
            level: 3,
          },
          {
            id: 232,
            regionCode: "140181",
            regionName: "古交市",
            parentCode: "140100",
            level: 3,
          },
        ],
      },
      {
        id: 233,
        regionCode: "140200",
        regionName: "大同市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 234,
            regionCode: "140202",
            regionName: "城区",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 235,
            regionCode: "140203",
            regionName: "矿区",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 236,
            regionCode: "140211",
            regionName: "南郊区",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 237,
            regionCode: "140212",
            regionName: "新荣区",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 238,
            regionCode: "140221",
            regionName: "阳高县",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 239,
            regionCode: "140222",
            regionName: "天镇县",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 240,
            regionCode: "140223",
            regionName: "广灵县",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 241,
            regionCode: "140224",
            regionName: "灵丘县",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 242,
            regionCode: "140225",
            regionName: "浑源县",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 243,
            regionCode: "140226",
            regionName: "左云县",
            parentCode: "140200",
            level: 3,
          },
          {
            id: 244,
            regionCode: "140227",
            regionName: "大同县",
            parentCode: "140200",
            level: 3,
          },
        ],
      },
      {
        id: 245,
        regionCode: "140300",
        regionName: "阳泉市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 246,
            regionCode: "140302",
            regionName: "城区",
            parentCode: "140300",
            level: 3,
          },
          {
            id: 247,
            regionCode: "140303",
            regionName: "矿区",
            parentCode: "140300",
            level: 3,
          },
          {
            id: 248,
            regionCode: "140311",
            regionName: "郊区",
            parentCode: "140300",
            level: 3,
          },
          {
            id: 249,
            regionCode: "140321",
            regionName: "平定县",
            parentCode: "140300",
            level: 3,
          },
          {
            id: 250,
            regionCode: "140322",
            regionName: "盂县",
            parentCode: "140300",
            level: 3,
          },
        ],
      },
      {
        id: 251,
        regionCode: "140400",
        regionName: "长治市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 252,
            regionCode: "140402",
            regionName: "城区",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 253,
            regionCode: "140411",
            regionName: "郊区",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 254,
            regionCode: "140421",
            regionName: "长治县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 255,
            regionCode: "140423",
            regionName: "襄垣县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 256,
            regionCode: "140424",
            regionName: "屯留县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 257,
            regionCode: "140425",
            regionName: "平顺县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 258,
            regionCode: "140426",
            regionName: "黎城县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 259,
            regionCode: "140427",
            regionName: "壶关县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 260,
            regionCode: "140428",
            regionName: "长子县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 261,
            regionCode: "140429",
            regionName: "武乡县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 262,
            regionCode: "140430",
            regionName: "沁县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 263,
            regionCode: "140431",
            regionName: "沁源县",
            parentCode: "140400",
            level: 3,
          },
          {
            id: 264,
            regionCode: "140481",
            regionName: "潞城市",
            parentCode: "140400",
            level: 3,
          },
        ],
      },
      {
        id: 265,
        regionCode: "140500",
        regionName: "晋城市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 266,
            regionCode: "140502",
            regionName: "城区",
            parentCode: "140500",
            level: 3,
          },
          {
            id: 267,
            regionCode: "140521",
            regionName: "沁水县",
            parentCode: "140500",
            level: 3,
          },
          {
            id: 268,
            regionCode: "140522",
            regionName: "阳城县",
            parentCode: "140500",
            level: 3,
          },
          {
            id: 269,
            regionCode: "140524",
            regionName: "陵川县",
            parentCode: "140500",
            level: 3,
          },
          {
            id: 270,
            regionCode: "140525",
            regionName: "泽州县",
            parentCode: "140500",
            level: 3,
          },
          {
            id: 271,
            regionCode: "140581",
            regionName: "高平市",
            parentCode: "140500",
            level: 3,
          },
        ],
      },
      {
        id: 272,
        regionCode: "140600",
        regionName: "朔州市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 273,
            regionCode: "140602",
            regionName: "朔城区",
            parentCode: "140600",
            level: 3,
          },
          {
            id: 274,
            regionCode: "140603",
            regionName: "平鲁区",
            parentCode: "140600",
            level: 3,
          },
          {
            id: 275,
            regionCode: "140621",
            regionName: "山阴县",
            parentCode: "140600",
            level: 3,
          },
          {
            id: 276,
            regionCode: "140622",
            regionName: "应县",
            parentCode: "140600",
            level: 3,
          },
          {
            id: 277,
            regionCode: "140623",
            regionName: "右玉县",
            parentCode: "140600",
            level: 3,
          },
          {
            id: 278,
            regionCode: "140624",
            regionName: "怀仁县",
            parentCode: "140600",
            level: 3,
          },
        ],
      },
      {
        id: 279,
        regionCode: "140700",
        regionName: "晋中市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 280,
            regionCode: "140702",
            regionName: "榆次区",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 281,
            regionCode: "140721",
            regionName: "榆社县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 282,
            regionCode: "140722",
            regionName: "左权县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 283,
            regionCode: "140723",
            regionName: "和顺县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 284,
            regionCode: "140724",
            regionName: "昔阳县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 285,
            regionCode: "140725",
            regionName: "寿阳县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 286,
            regionCode: "140726",
            regionName: "太谷县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 287,
            regionCode: "140727",
            regionName: "祁县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 288,
            regionCode: "140728",
            regionName: "平遥县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 289,
            regionCode: "140729",
            regionName: "灵石县",
            parentCode: "140700",
            level: 3,
          },
          {
            id: 290,
            regionCode: "140781",
            regionName: "介休市",
            parentCode: "140700",
            level: 3,
          },
        ],
      },
      {
        id: 291,
        regionCode: "140800",
        regionName: "运城市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 292,
            regionCode: "140802",
            regionName: "盐湖区",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 293,
            regionCode: "140821",
            regionName: "临猗县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 294,
            regionCode: "140822",
            regionName: "万荣县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 295,
            regionCode: "140823",
            regionName: "闻喜县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 296,
            regionCode: "140824",
            regionName: "稷山县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 297,
            regionCode: "140825",
            regionName: "新绛县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 298,
            regionCode: "140826",
            regionName: "绛县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 299,
            regionCode: "140827",
            regionName: "垣曲县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 300,
            regionCode: "140828",
            regionName: "夏县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 301,
            regionCode: "140829",
            regionName: "平陆县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 302,
            regionCode: "140830",
            regionName: "芮城县",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 303,
            regionCode: "140881",
            regionName: "永济市",
            parentCode: "140800",
            level: 3,
          },
          {
            id: 304,
            regionCode: "140882",
            regionName: "河津市",
            parentCode: "140800",
            level: 3,
          },
        ],
      },
      {
        id: 305,
        regionCode: "140900",
        regionName: "忻州市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 306,
            regionCode: "140902",
            regionName: "忻府区",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 307,
            regionCode: "140921",
            regionName: "定襄县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 308,
            regionCode: "140922",
            regionName: "五台县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 309,
            regionCode: "140923",
            regionName: "代县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 310,
            regionCode: "140924",
            regionName: "繁峙县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 311,
            regionCode: "140925",
            regionName: "宁武县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 312,
            regionCode: "140926",
            regionName: "静乐县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 313,
            regionCode: "140927",
            regionName: "神池县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 314,
            regionCode: "140928",
            regionName: "五寨县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 315,
            regionCode: "140929",
            regionName: "岢岚县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 316,
            regionCode: "140930",
            regionName: "河曲县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 317,
            regionCode: "140931",
            regionName: "保德县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 318,
            regionCode: "140932",
            regionName: "偏关县",
            parentCode: "140900",
            level: 3,
          },
          {
            id: 319,
            regionCode: "140981",
            regionName: "原平市",
            parentCode: "140900",
            level: 3,
          },
        ],
      },
      {
        id: 320,
        regionCode: "141000",
        regionName: "临汾市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 321,
            regionCode: "141002",
            regionName: "尧都区",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 322,
            regionCode: "141021",
            regionName: "曲沃县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 323,
            regionCode: "141022",
            regionName: "翼城县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 324,
            regionCode: "141023",
            regionName: "襄汾县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 325,
            regionCode: "141024",
            regionName: "洪洞县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 326,
            regionCode: "141025",
            regionName: "古县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 327,
            regionCode: "141026",
            regionName: "安泽县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 328,
            regionCode: "141027",
            regionName: "浮山县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 329,
            regionCode: "141028",
            regionName: "吉县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 330,
            regionCode: "141029",
            regionName: "乡宁县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 331,
            regionCode: "141030",
            regionName: "大宁县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 332,
            regionCode: "141031",
            regionName: "隰县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 333,
            regionCode: "141032",
            regionName: "永和县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 334,
            regionCode: "141033",
            regionName: "蒲县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 335,
            regionCode: "141034",
            regionName: "汾西县",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 336,
            regionCode: "141081",
            regionName: "侯马市",
            parentCode: "141000",
            level: 3,
          },
          {
            id: 337,
            regionCode: "141082",
            regionName: "霍州市",
            parentCode: "141000",
            level: 3,
          },
        ],
      },
      {
        id: 338,
        regionCode: "141100",
        regionName: "吕梁市",
        parentCode: "140000",
        level: 2,
        children: [
          {
            id: 339,
            regionCode: "141102",
            regionName: "离石区",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 340,
            regionCode: "141121",
            regionName: "文水县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 341,
            regionCode: "141122",
            regionName: "交城县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 342,
            regionCode: "141123",
            regionName: "兴县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 343,
            regionCode: "141124",
            regionName: "临县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 344,
            regionCode: "141125",
            regionName: "柳林县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 345,
            regionCode: "141126",
            regionName: "石楼县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 346,
            regionCode: "141127",
            regionName: "岚县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 347,
            regionCode: "141128",
            regionName: "方山县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 348,
            regionCode: "141129",
            regionName: "中阳县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 349,
            regionCode: "141130",
            regionName: "交口县",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 350,
            regionCode: "141181",
            regionName: "孝义市",
            parentCode: "141100",
            level: 3,
          },
          {
            id: 351,
            regionCode: "141182",
            regionName: "汾阳市",
            parentCode: "141100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 352,
    regionCode: "150000",
    regionName: "内蒙古自治区",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 353,
        regionCode: "150100",
        regionName: "呼和浩特市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 354,
            regionCode: "150102",
            regionName: "新城区",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 355,
            regionCode: "150103",
            regionName: "回民区",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 356,
            regionCode: "150104",
            regionName: "玉泉区",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 357,
            regionCode: "150105",
            regionName: "赛罕区",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 358,
            regionCode: "150121",
            regionName: "土默特左旗",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 359,
            regionCode: "150122",
            regionName: "托克托县",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 360,
            regionCode: "150123",
            regionName: "和林格尔县",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 361,
            regionCode: "150124",
            regionName: "清水河县",
            parentCode: "150100",
            level: 3,
          },
          {
            id: 362,
            regionCode: "150125",
            regionName: "武川县",
            parentCode: "150100",
            level: 3,
          },
        ],
      },
      {
        id: 363,
        regionCode: "150200",
        regionName: "包头市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 364,
            regionCode: "150202",
            regionName: "东河区",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 365,
            regionCode: "150203",
            regionName: "昆都仑区",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 366,
            regionCode: "150204",
            regionName: "青山区",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 367,
            regionCode: "150205",
            regionName: "石拐区",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 368,
            regionCode: "150206",
            regionName: "白云鄂博矿区",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 369,
            regionCode: "150207",
            regionName: "九原区",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 370,
            regionCode: "150221",
            regionName: "土默特右旗",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 371,
            regionCode: "150222",
            regionName: "固阳县",
            parentCode: "150200",
            level: 3,
          },
          {
            id: 372,
            regionCode: "150223",
            regionName: "达尔罕茂明安联合旗",
            parentCode: "150200",
            level: 3,
          },
        ],
      },
      {
        id: 373,
        regionCode: "150300",
        regionName: "乌海市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 374,
            regionCode: "150302",
            regionName: "海勃湾区",
            parentCode: "150300",
            level: 3,
          },
          {
            id: 375,
            regionCode: "150303",
            regionName: "海南区",
            parentCode: "150300",
            level: 3,
          },
          {
            id: 376,
            regionCode: "150304",
            regionName: "乌达区",
            parentCode: "150300",
            level: 3,
          },
        ],
      },
      {
        id: 377,
        regionCode: "150400",
        regionName: "赤峰市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 378,
            regionCode: "150402",
            regionName: "红山区",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 379,
            regionCode: "150403",
            regionName: "元宝山区",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 380,
            regionCode: "150404",
            regionName: "松山区",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 381,
            regionCode: "150421",
            regionName: "阿鲁科尔沁旗",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 382,
            regionCode: "150422",
            regionName: "巴林左旗",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 383,
            regionCode: "150423",
            regionName: "巴林右旗",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 384,
            regionCode: "150424",
            regionName: "林西县",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 385,
            regionCode: "150425",
            regionName: "克什克腾旗",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 386,
            regionCode: "150426",
            regionName: "翁牛特旗",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 387,
            regionCode: "150428",
            regionName: "喀喇沁旗",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 388,
            regionCode: "150429",
            regionName: "宁城县",
            parentCode: "150400",
            level: 3,
          },
          {
            id: 389,
            regionCode: "150430",
            regionName: "敖汉旗",
            parentCode: "150400",
            level: 3,
          },
        ],
      },
      {
        id: 390,
        regionCode: "150500",
        regionName: "通辽市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 391,
            regionCode: "150502",
            regionName: "科尔沁区",
            parentCode: "150500",
            level: 3,
          },
          {
            id: 392,
            regionCode: "150521",
            regionName: "科尔沁左翼中旗",
            parentCode: "150500",
            level: 3,
          },
          {
            id: 393,
            regionCode: "150522",
            regionName: "科尔沁左翼后旗",
            parentCode: "150500",
            level: 3,
          },
          {
            id: 394,
            regionCode: "150523",
            regionName: "开鲁县",
            parentCode: "150500",
            level: 3,
          },
          {
            id: 395,
            regionCode: "150524",
            regionName: "库伦旗",
            parentCode: "150500",
            level: 3,
          },
          {
            id: 396,
            regionCode: "150525",
            regionName: "奈曼旗",
            parentCode: "150500",
            level: 3,
          },
          {
            id: 397,
            regionCode: "150526",
            regionName: "扎鲁特旗",
            parentCode: "150500",
            level: 3,
          },
          {
            id: 398,
            regionCode: "150581",
            regionName: "霍林郭勒市",
            parentCode: "150500",
            level: 3,
          },
        ],
      },
      {
        id: 399,
        regionCode: "150600",
        regionName: "鄂尔多斯市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 400,
            regionCode: "150602",
            regionName: "东胜区",
            parentCode: "150600",
            level: 3,
          },
          {
            id: 401,
            regionCode: "150621",
            regionName: "达拉特旗",
            parentCode: "150600",
            level: 3,
          },
          {
            id: 402,
            regionCode: "150622",
            regionName: "准格尔旗",
            parentCode: "150600",
            level: 3,
          },
          {
            id: 403,
            regionCode: "150623",
            regionName: "鄂托克前旗",
            parentCode: "150600",
            level: 3,
          },
          {
            id: 404,
            regionCode: "150624",
            regionName: "鄂托克旗",
            parentCode: "150600",
            level: 3,
          },
          {
            id: 405,
            regionCode: "150625",
            regionName: "杭锦旗",
            parentCode: "150600",
            level: 3,
          },
          {
            id: 406,
            regionCode: "150626",
            regionName: "乌审旗",
            parentCode: "150600",
            level: 3,
          },
          {
            id: 407,
            regionCode: "150627",
            regionName: "伊金霍洛旗",
            parentCode: "150600",
            level: 3,
          },
        ],
      },
      {
        id: 408,
        regionCode: "150700",
        regionName: "呼伦贝尔市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 409,
            regionCode: "150702",
            regionName: "海拉尔区",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 410,
            regionCode: "150703",
            regionName: "扎赉诺尔区",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 411,
            regionCode: "150721",
            regionName: "阿荣旗",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 412,
            regionCode: "150722",
            regionName: "莫力达瓦达斡尔族自治旗",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 413,
            regionCode: "150723",
            regionName: "鄂伦春自治旗",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 414,
            regionCode: "150724",
            regionName: "鄂温克族自治旗",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 415,
            regionCode: "150725",
            regionName: "陈巴尔虎旗",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 416,
            regionCode: "150726",
            regionName: "新巴尔虎左旗",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 417,
            regionCode: "150727",
            regionName: "新巴尔虎右旗",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 418,
            regionCode: "150781",
            regionName: "满洲里市",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 419,
            regionCode: "150782",
            regionName: "牙克石市",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 420,
            regionCode: "150783",
            regionName: "扎兰屯市",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 421,
            regionCode: "150784",
            regionName: "额尔古纳市",
            parentCode: "150700",
            level: 3,
          },
          {
            id: 422,
            regionCode: "150785",
            regionName: "根河市",
            parentCode: "150700",
            level: 3,
          },
        ],
      },
      {
        id: 423,
        regionCode: "150800",
        regionName: "巴彦淖尔市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 424,
            regionCode: "150802",
            regionName: "临河区",
            parentCode: "150800",
            level: 3,
          },
          {
            id: 425,
            regionCode: "150821",
            regionName: "五原县",
            parentCode: "150800",
            level: 3,
          },
          {
            id: 426,
            regionCode: "150822",
            regionName: "磴口县",
            parentCode: "150800",
            level: 3,
          },
          {
            id: 427,
            regionCode: "150823",
            regionName: "乌拉特前旗",
            parentCode: "150800",
            level: 3,
          },
          {
            id: 428,
            regionCode: "150824",
            regionName: "乌拉特中旗",
            parentCode: "150800",
            level: 3,
          },
          {
            id: 429,
            regionCode: "150825",
            regionName: "乌拉特后旗",
            parentCode: "150800",
            level: 3,
          },
          {
            id: 430,
            regionCode: "150826",
            regionName: "杭锦后旗",
            parentCode: "150800",
            level: 3,
          },
        ],
      },
      {
        id: 431,
        regionCode: "150900",
        regionName: "乌兰察布市",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 432,
            regionCode: "150902",
            regionName: "集宁区",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 433,
            regionCode: "150921",
            regionName: "卓资县",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 434,
            regionCode: "150922",
            regionName: "化德县",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 435,
            regionCode: "150923",
            regionName: "商都县",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 436,
            regionCode: "150924",
            regionName: "兴和县",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 437,
            regionCode: "150925",
            regionName: "凉城县",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 438,
            regionCode: "150926",
            regionName: "察哈尔右翼前旗",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 439,
            regionCode: "150927",
            regionName: "察哈尔右翼中旗",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 440,
            regionCode: "150928",
            regionName: "察哈尔右翼后旗",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 441,
            regionCode: "150929",
            regionName: "四子王旗",
            parentCode: "150900",
            level: 3,
          },
          {
            id: 442,
            regionCode: "150981",
            regionName: "丰镇市",
            parentCode: "150900",
            level: 3,
          },
        ],
      },
      {
        id: 443,
        regionCode: "152200",
        regionName: "兴安盟",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 444,
            regionCode: "152201",
            regionName: "乌兰浩特市",
            parentCode: "152200",
            level: 3,
          },
          {
            id: 445,
            regionCode: "152202",
            regionName: "阿尔山市",
            parentCode: "152200",
            level: 3,
          },
          {
            id: 446,
            regionCode: "152221",
            regionName: "科尔沁右翼前旗",
            parentCode: "152200",
            level: 3,
          },
          {
            id: 447,
            regionCode: "152222",
            regionName: "科尔沁右翼中旗",
            parentCode: "152200",
            level: 3,
          },
          {
            id: 448,
            regionCode: "152223",
            regionName: "扎赉特旗",
            parentCode: "152200",
            level: 3,
          },
          {
            id: 449,
            regionCode: "152224",
            regionName: "突泉县",
            parentCode: "152200",
            level: 3,
          },
        ],
      },
      {
        id: 450,
        regionCode: "152500",
        regionName: "锡林郭勒盟",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 451,
            regionCode: "152501",
            regionName: "二连浩特市",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 452,
            regionCode: "152502",
            regionName: "锡林浩特市",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 453,
            regionCode: "152522",
            regionName: "阿巴嘎旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 454,
            regionCode: "152523",
            regionName: "苏尼特左旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 455,
            regionCode: "152524",
            regionName: "苏尼特右旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 456,
            regionCode: "152525",
            regionName: "东乌珠穆沁旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 457,
            regionCode: "152526",
            regionName: "西乌珠穆沁旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 458,
            regionCode: "152527",
            regionName: "太仆寺旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 459,
            regionCode: "152528",
            regionName: "镶黄旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 460,
            regionCode: "152529",
            regionName: "正镶白旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 461,
            regionCode: "152530",
            regionName: "正蓝旗",
            parentCode: "152500",
            level: 3,
          },
          {
            id: 462,
            regionCode: "152531",
            regionName: "多伦县",
            parentCode: "152500",
            level: 3,
          },
        ],
      },
      {
        id: 463,
        regionCode: "152900",
        regionName: "阿拉善盟",
        parentCode: "150000",
        level: 2,
        children: [
          {
            id: 464,
            regionCode: "152921",
            regionName: "阿拉善左旗",
            parentCode: "152900",
            level: 3,
          },
          {
            id: 465,
            regionCode: "152922",
            regionName: "阿拉善右旗",
            parentCode: "152900",
            level: 3,
          },
          {
            id: 466,
            regionCode: "152923",
            regionName: "额济纳旗",
            parentCode: "152900",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 467,
    regionCode: "210000",
    regionName: "辽宁省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 468,
        regionCode: "210100",
        regionName: "沈阳市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 469,
            regionCode: "210102",
            regionName: "和平区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 470,
            regionCode: "210103",
            regionName: "沈河区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 471,
            regionCode: "210104",
            regionName: "大东区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 472,
            regionCode: "210105",
            regionName: "皇姑区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 473,
            regionCode: "210106",
            regionName: "铁西区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 474,
            regionCode: "210111",
            regionName: "苏家屯区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 475,
            regionCode: "210112",
            regionName: "浑南区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 476,
            regionCode: "210113",
            regionName: "沈北新区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 477,
            regionCode: "210114",
            regionName: "于洪区",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 478,
            regionCode: "210122",
            regionName: "辽中县",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 479,
            regionCode: "210123",
            regionName: "康平县",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 480,
            regionCode: "210124",
            regionName: "法库县",
            parentCode: "210100",
            level: 3,
          },
          {
            id: 481,
            regionCode: "210181",
            regionName: "新民市",
            parentCode: "210100",
            level: 3,
          },
        ],
      },
      {
        id: 482,
        regionCode: "210200",
        regionName: "大连市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 483,
            regionCode: "210202",
            regionName: "中山区",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 484,
            regionCode: "210203",
            regionName: "西岗区",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 485,
            regionCode: "210204",
            regionName: "沙河口区",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 486,
            regionCode: "210211",
            regionName: "甘井子区",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 487,
            regionCode: "210212",
            regionName: "旅顺口区",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 488,
            regionCode: "210213",
            regionName: "金州区",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 489,
            regionCode: "210224",
            regionName: "长海县",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 490,
            regionCode: "210281",
            regionName: "瓦房店市",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 491,
            regionCode: "210282",
            regionName: "普兰店市",
            parentCode: "210200",
            level: 3,
          },
          {
            id: 492,
            regionCode: "210283",
            regionName: "庄河市",
            parentCode: "210200",
            level: 3,
          },
        ],
      },
      {
        id: 493,
        regionCode: "210300",
        regionName: "鞍山市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 494,
            regionCode: "210302",
            regionName: "铁东区",
            parentCode: "210300",
            level: 3,
          },
          {
            id: 495,
            regionCode: "210303",
            regionName: "铁西区",
            parentCode: "210300",
            level: 3,
          },
          {
            id: 496,
            regionCode: "210304",
            regionName: "立山区",
            parentCode: "210300",
            level: 3,
          },
          {
            id: 497,
            regionCode: "210311",
            regionName: "千山区",
            parentCode: "210300",
            level: 3,
          },
          {
            id: 498,
            regionCode: "210321",
            regionName: "台安县",
            parentCode: "210300",
            level: 3,
          },
          {
            id: 499,
            regionCode: "210323",
            regionName: "岫岩满族自治县",
            parentCode: "210300",
            level: 3,
          },
          {
            id: 500,
            regionCode: "210381",
            regionName: "海城市",
            parentCode: "210300",
            level: 3,
          },
        ],
      },
      {
        id: 501,
        regionCode: "210400",
        regionName: "抚顺市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 502,
            regionCode: "210402",
            regionName: "新抚区",
            parentCode: "210400",
            level: 3,
          },
          {
            id: 503,
            regionCode: "210403",
            regionName: "东洲区",
            parentCode: "210400",
            level: 3,
          },
          {
            id: 504,
            regionCode: "210404",
            regionName: "望花区",
            parentCode: "210400",
            level: 3,
          },
          {
            id: 505,
            regionCode: "210411",
            regionName: "顺城区",
            parentCode: "210400",
            level: 3,
          },
          {
            id: 506,
            regionCode: "210421",
            regionName: "抚顺县",
            parentCode: "210400",
            level: 3,
          },
          {
            id: 507,
            regionCode: "210422",
            regionName: "新宾满族自治县",
            parentCode: "210400",
            level: 3,
          },
          {
            id: 508,
            regionCode: "210423",
            regionName: "清原满族自治县",
            parentCode: "210400",
            level: 3,
          },
        ],
      },
      {
        id: 509,
        regionCode: "210500",
        regionName: "本溪市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 510,
            regionCode: "210502",
            regionName: "平山区",
            parentCode: "210500",
            level: 3,
          },
          {
            id: 511,
            regionCode: "210503",
            regionName: "溪湖区",
            parentCode: "210500",
            level: 3,
          },
          {
            id: 512,
            regionCode: "210504",
            regionName: "明山区",
            parentCode: "210500",
            level: 3,
          },
          {
            id: 513,
            regionCode: "210505",
            regionName: "南芬区",
            parentCode: "210500",
            level: 3,
          },
          {
            id: 514,
            regionCode: "210521",
            regionName: "本溪满族自治县",
            parentCode: "210500",
            level: 3,
          },
          {
            id: 515,
            regionCode: "210522",
            regionName: "桓仁满族自治县",
            parentCode: "210500",
            level: 3,
          },
        ],
      },
      {
        id: 516,
        regionCode: "210600",
        regionName: "丹东市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 517,
            regionCode: "210602",
            regionName: "元宝区",
            parentCode: "210600",
            level: 3,
          },
          {
            id: 518,
            regionCode: "210603",
            regionName: "振兴区",
            parentCode: "210600",
            level: 3,
          },
          {
            id: 519,
            regionCode: "210604",
            regionName: "振安区",
            parentCode: "210600",
            level: 3,
          },
          {
            id: 520,
            regionCode: "210624",
            regionName: "宽甸满族自治县",
            parentCode: "210600",
            level: 3,
          },
          {
            id: 521,
            regionCode: "210681",
            regionName: "东港市",
            parentCode: "210600",
            level: 3,
          },
          {
            id: 522,
            regionCode: "210682",
            regionName: "凤城市",
            parentCode: "210600",
            level: 3,
          },
        ],
      },
      {
        id: 523,
        regionCode: "210700",
        regionName: "锦州市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 524,
            regionCode: "210702",
            regionName: "古塔区",
            parentCode: "210700",
            level: 3,
          },
          {
            id: 525,
            regionCode: "210703",
            regionName: "凌河区",
            parentCode: "210700",
            level: 3,
          },
          {
            id: 526,
            regionCode: "210711",
            regionName: "太和区",
            parentCode: "210700",
            level: 3,
          },
          {
            id: 527,
            regionCode: "210726",
            regionName: "黑山县",
            parentCode: "210700",
            level: 3,
          },
          {
            id: 528,
            regionCode: "210727",
            regionName: "义县",
            parentCode: "210700",
            level: 3,
          },
          {
            id: 529,
            regionCode: "210781",
            regionName: "凌海市",
            parentCode: "210700",
            level: 3,
          },
          {
            id: 530,
            regionCode: "210782",
            regionName: "北镇市",
            parentCode: "210700",
            level: 3,
          },
        ],
      },
      {
        id: 531,
        regionCode: "210800",
        regionName: "营口市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 532,
            regionCode: "210802",
            regionName: "站前区",
            parentCode: "210800",
            level: 3,
          },
          {
            id: 533,
            regionCode: "210803",
            regionName: "西市区",
            parentCode: "210800",
            level: 3,
          },
          {
            id: 534,
            regionCode: "210804",
            regionName: "鲅鱼圈区",
            parentCode: "210800",
            level: 3,
          },
          {
            id: 535,
            regionCode: "210811",
            regionName: "老边区",
            parentCode: "210800",
            level: 3,
          },
          {
            id: 536,
            regionCode: "210881",
            regionName: "盖州市",
            parentCode: "210800",
            level: 3,
          },
          {
            id: 537,
            regionCode: "210882",
            regionName: "大石桥市",
            parentCode: "210800",
            level: 3,
          },
        ],
      },
      {
        id: 538,
        regionCode: "210900",
        regionName: "阜新市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 539,
            regionCode: "210902",
            regionName: "海州区",
            parentCode: "210900",
            level: 3,
          },
          {
            id: 540,
            regionCode: "210903",
            regionName: "新邱区",
            parentCode: "210900",
            level: 3,
          },
          {
            id: 541,
            regionCode: "210904",
            regionName: "太平区",
            parentCode: "210900",
            level: 3,
          },
          {
            id: 542,
            regionCode: "210905",
            regionName: "清河门区",
            parentCode: "210900",
            level: 3,
          },
          {
            id: 543,
            regionCode: "210911",
            regionName: "细河区",
            parentCode: "210900",
            level: 3,
          },
          {
            id: 544,
            regionCode: "210921",
            regionName: "阜新蒙古族自治县",
            parentCode: "210900",
            level: 3,
          },
          {
            id: 545,
            regionCode: "210922",
            regionName: "彰武县",
            parentCode: "210900",
            level: 3,
          },
        ],
      },
      {
        id: 546,
        regionCode: "211000",
        regionName: "辽阳市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 547,
            regionCode: "211002",
            regionName: "白塔区",
            parentCode: "211000",
            level: 3,
          },
          {
            id: 548,
            regionCode: "211003",
            regionName: "文圣区",
            parentCode: "211000",
            level: 3,
          },
          {
            id: 549,
            regionCode: "211004",
            regionName: "宏伟区",
            parentCode: "211000",
            level: 3,
          },
          {
            id: 550,
            regionCode: "211005",
            regionName: "弓长岭区",
            parentCode: "211000",
            level: 3,
          },
          {
            id: 551,
            regionCode: "211011",
            regionName: "太子河区",
            parentCode: "211000",
            level: 3,
          },
          {
            id: 552,
            regionCode: "211021",
            regionName: "辽阳县",
            parentCode: "211000",
            level: 3,
          },
          {
            id: 553,
            regionCode: "211081",
            regionName: "灯塔市",
            parentCode: "211000",
            level: 3,
          },
        ],
      },
      {
        id: 554,
        regionCode: "211100",
        regionName: "盘锦市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 555,
            regionCode: "211102",
            regionName: "双台子区",
            parentCode: "211100",
            level: 3,
          },
          {
            id: 556,
            regionCode: "211103",
            regionName: "兴隆台区",
            parentCode: "211100",
            level: 3,
          },
          {
            id: 557,
            regionCode: "211121",
            regionName: "大洼县",
            parentCode: "211100",
            level: 3,
          },
          {
            id: 558,
            regionCode: "211122",
            regionName: "盘山县",
            parentCode: "211100",
            level: 3,
          },
        ],
      },
      {
        id: 559,
        regionCode: "211200",
        regionName: "铁岭市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 560,
            regionCode: "211202",
            regionName: "银州区",
            parentCode: "211200",
            level: 3,
          },
          {
            id: 561,
            regionCode: "211204",
            regionName: "清河区",
            parentCode: "211200",
            level: 3,
          },
          {
            id: 562,
            regionCode: "211221",
            regionName: "铁岭县",
            parentCode: "211200",
            level: 3,
          },
          {
            id: 563,
            regionCode: "211223",
            regionName: "西丰县",
            parentCode: "211200",
            level: 3,
          },
          {
            id: 564,
            regionCode: "211224",
            regionName: "昌图县",
            parentCode: "211200",
            level: 3,
          },
          {
            id: 565,
            regionCode: "211281",
            regionName: "调兵山市",
            parentCode: "211200",
            level: 3,
          },
          {
            id: 566,
            regionCode: "211282",
            regionName: "开原市",
            parentCode: "211200",
            level: 3,
          },
        ],
      },
      {
        id: 567,
        regionCode: "211300",
        regionName: "朝阳市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 568,
            regionCode: "211302",
            regionName: "双塔区",
            parentCode: "211300",
            level: 3,
          },
          {
            id: 569,
            regionCode: "211303",
            regionName: "龙城区",
            parentCode: "211300",
            level: 3,
          },
          {
            id: 570,
            regionCode: "211321",
            regionName: "朝阳县",
            parentCode: "211300",
            level: 3,
          },
          {
            id: 571,
            regionCode: "211322",
            regionName: "建平县",
            parentCode: "211300",
            level: 3,
          },
          {
            id: 572,
            regionCode: "211324",
            regionName: "喀喇沁左翼蒙古族自治县",
            parentCode: "211300",
            level: 3,
          },
          {
            id: 573,
            regionCode: "211381",
            regionName: "北票市",
            parentCode: "211300",
            level: 3,
          },
          {
            id: 574,
            regionCode: "211382",
            regionName: "凌源市",
            parentCode: "211300",
            level: 3,
          },
        ],
      },
      {
        id: 575,
        regionCode: "211400",
        regionName: "葫芦岛市",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 576,
            regionCode: "211402",
            regionName: "连山区",
            parentCode: "211400",
            level: 3,
          },
          {
            id: 577,
            regionCode: "211403",
            regionName: "龙港区",
            parentCode: "211400",
            level: 3,
          },
          {
            id: 578,
            regionCode: "211404",
            regionName: "南票区",
            parentCode: "211400",
            level: 3,
          },
          {
            id: 579,
            regionCode: "211421",
            regionName: "绥中县",
            parentCode: "211400",
            level: 3,
          },
          {
            id: 580,
            regionCode: "211422",
            regionName: "建昌县",
            parentCode: "211400",
            level: 3,
          },
          {
            id: 581,
            regionCode: "211481",
            regionName: "兴城市",
            parentCode: "211400",
            level: 3,
          },
        ],
      },
      {
        id: 582,
        regionCode: "211500",
        regionName: "金普新区",
        parentCode: "210000",
        level: 2,
        children: [
          {
            id: 583,
            regionCode: "211501",
            regionName: "金州新区",
            parentCode: "211500",
            level: 3,
          },
          {
            id: 584,
            regionCode: "211502",
            regionName: "普湾新区",
            parentCode: "211500",
            level: 3,
          },
          {
            id: 585,
            regionCode: "211503",
            regionName: "保税区",
            parentCode: "211500",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 586,
    regionCode: "220000",
    regionName: "吉林省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 587,
        regionCode: "220100",
        regionName: "长春市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 588,
            regionCode: "220102",
            regionName: "南关区",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 589,
            regionCode: "220103",
            regionName: "宽城区",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 590,
            regionCode: "220104",
            regionName: "朝阳区",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 591,
            regionCode: "220105",
            regionName: "二道区",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 592,
            regionCode: "220106",
            regionName: "绿园区",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 593,
            regionCode: "220112",
            regionName: "双阳区",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 594,
            regionCode: "220113",
            regionName: "九台区",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 595,
            regionCode: "220122",
            regionName: "农安县",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 596,
            regionCode: "220182",
            regionName: "榆树市",
            parentCode: "220100",
            level: 3,
          },
          {
            id: 597,
            regionCode: "220183",
            regionName: "德惠市",
            parentCode: "220100",
            level: 3,
          },
        ],
      },
      {
        id: 598,
        regionCode: "220200",
        regionName: "吉林市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 599,
            regionCode: "220202",
            regionName: "昌邑区",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 600,
            regionCode: "220203",
            regionName: "龙潭区",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 601,
            regionCode: "220204",
            regionName: "船营区",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 602,
            regionCode: "220211",
            regionName: "丰满区",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 603,
            regionCode: "220221",
            regionName: "永吉县",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 604,
            regionCode: "220281",
            regionName: "蛟河市",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 605,
            regionCode: "220282",
            regionName: "桦甸市",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 606,
            regionCode: "220283",
            regionName: "舒兰市",
            parentCode: "220200",
            level: 3,
          },
          {
            id: 607,
            regionCode: "220284",
            regionName: "磐石市",
            parentCode: "220200",
            level: 3,
          },
        ],
      },
      {
        id: 608,
        regionCode: "220300",
        regionName: "四平市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 609,
            regionCode: "220302",
            regionName: "铁西区",
            parentCode: "220300",
            level: 3,
          },
          {
            id: 610,
            regionCode: "220303",
            regionName: "铁东区",
            parentCode: "220300",
            level: 3,
          },
          {
            id: 611,
            regionCode: "220322",
            regionName: "梨树县",
            parentCode: "220300",
            level: 3,
          },
          {
            id: 612,
            regionCode: "220323",
            regionName: "伊通满族自治县",
            parentCode: "220300",
            level: 3,
          },
          {
            id: 613,
            regionCode: "220381",
            regionName: "公主岭市",
            parentCode: "220300",
            level: 3,
          },
          {
            id: 614,
            regionCode: "220382",
            regionName: "双辽市",
            parentCode: "220300",
            level: 3,
          },
        ],
      },
      {
        id: 615,
        regionCode: "220400",
        regionName: "辽源市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 616,
            regionCode: "220402",
            regionName: "龙山区",
            parentCode: "220400",
            level: 3,
          },
          {
            id: 617,
            regionCode: "220403",
            regionName: "西安区",
            parentCode: "220400",
            level: 3,
          },
          {
            id: 618,
            regionCode: "220421",
            regionName: "东丰县",
            parentCode: "220400",
            level: 3,
          },
          {
            id: 619,
            regionCode: "220422",
            regionName: "东辽县",
            parentCode: "220400",
            level: 3,
          },
        ],
      },
      {
        id: 620,
        regionCode: "220500",
        regionName: "通化市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 621,
            regionCode: "220502",
            regionName: "东昌区",
            parentCode: "220500",
            level: 3,
          },
          {
            id: 622,
            regionCode: "220503",
            regionName: "二道江区",
            parentCode: "220500",
            level: 3,
          },
          {
            id: 623,
            regionCode: "220521",
            regionName: "通化县",
            parentCode: "220500",
            level: 3,
          },
          {
            id: 624,
            regionCode: "220523",
            regionName: "辉南县",
            parentCode: "220500",
            level: 3,
          },
          {
            id: 625,
            regionCode: "220524",
            regionName: "柳河县",
            parentCode: "220500",
            level: 3,
          },
          {
            id: 626,
            regionCode: "220581",
            regionName: "梅河口市",
            parentCode: "220500",
            level: 3,
          },
          {
            id: 627,
            regionCode: "220582",
            regionName: "集安市",
            parentCode: "220500",
            level: 3,
          },
        ],
      },
      {
        id: 628,
        regionCode: "220600",
        regionName: "白山市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 629,
            regionCode: "220602",
            regionName: "浑江区",
            parentCode: "220600",
            level: 3,
          },
          {
            id: 630,
            regionCode: "220605",
            regionName: "江源区",
            parentCode: "220600",
            level: 3,
          },
          {
            id: 631,
            regionCode: "220621",
            regionName: "抚松县",
            parentCode: "220600",
            level: 3,
          },
          {
            id: 632,
            regionCode: "220622",
            regionName: "靖宇县",
            parentCode: "220600",
            level: 3,
          },
          {
            id: 633,
            regionCode: "220623",
            regionName: "长白朝鲜族自治县",
            parentCode: "220600",
            level: 3,
          },
          {
            id: 634,
            regionCode: "220681",
            regionName: "临江市",
            parentCode: "220600",
            level: 3,
          },
        ],
      },
      {
        id: 635,
        regionCode: "220700",
        regionName: "松原市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 636,
            regionCode: "220702",
            regionName: "宁江区",
            parentCode: "220700",
            level: 3,
          },
          {
            id: 637,
            regionCode: "220721",
            regionName: "前郭尔罗斯蒙古族自治县",
            parentCode: "220700",
            level: 3,
          },
          {
            id: 638,
            regionCode: "220722",
            regionName: "长岭县",
            parentCode: "220700",
            level: 3,
          },
          {
            id: 639,
            regionCode: "220723",
            regionName: "乾安县",
            parentCode: "220700",
            level: 3,
          },
          {
            id: 640,
            regionCode: "220781",
            regionName: "扶余市",
            parentCode: "220700",
            level: 3,
          },
        ],
      },
      {
        id: 641,
        regionCode: "220800",
        regionName: "白城市",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 642,
            regionCode: "220802",
            regionName: "洮北区",
            parentCode: "220800",
            level: 3,
          },
          {
            id: 643,
            regionCode: "220821",
            regionName: "镇赉县",
            parentCode: "220800",
            level: 3,
          },
          {
            id: 644,
            regionCode: "220822",
            regionName: "通榆县",
            parentCode: "220800",
            level: 3,
          },
          {
            id: 645,
            regionCode: "220881",
            regionName: "洮南市",
            parentCode: "220800",
            level: 3,
          },
          {
            id: 646,
            regionCode: "220882",
            regionName: "大安市",
            parentCode: "220800",
            level: 3,
          },
        ],
      },
      {
        id: 647,
        regionCode: "222400",
        regionName: "延边朝鲜族自治州",
        parentCode: "220000",
        level: 2,
        children: [
          {
            id: 648,
            regionCode: "222401",
            regionName: "延吉市",
            parentCode: "222400",
            level: 3,
          },
          {
            id: 649,
            regionCode: "222402",
            regionName: "图们市",
            parentCode: "222400",
            level: 3,
          },
          {
            id: 650,
            regionCode: "222403",
            regionName: "敦化市",
            parentCode: "222400",
            level: 3,
          },
          {
            id: 651,
            regionCode: "222404",
            regionName: "珲春市",
            parentCode: "222400",
            level: 3,
          },
          {
            id: 652,
            regionCode: "222405",
            regionName: "龙井市",
            parentCode: "222400",
            level: 3,
          },
          {
            id: 653,
            regionCode: "222406",
            regionName: "和龙市",
            parentCode: "222400",
            level: 3,
          },
          {
            id: 654,
            regionCode: "222424",
            regionName: "汪清县",
            parentCode: "222400",
            level: 3,
          },
          {
            id: 655,
            regionCode: "222426",
            regionName: "安图县",
            parentCode: "222400",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 656,
    regionCode: "230000",
    regionName: "黑龙江省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 657,
        regionCode: "230100",
        regionName: "哈尔滨市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 658,
            regionCode: "230102",
            regionName: "道里区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 659,
            regionCode: "230103",
            regionName: "南岗区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 660,
            regionCode: "230104",
            regionName: "道外区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 661,
            regionCode: "230108",
            regionName: "平房区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 662,
            regionCode: "230109",
            regionName: "松北区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 663,
            regionCode: "230110",
            regionName: "香坊区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 664,
            regionCode: "230111",
            regionName: "呼兰区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 665,
            regionCode: "230112",
            regionName: "阿城区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 666,
            regionCode: "230113",
            regionName: "双城区",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 667,
            regionCode: "230123",
            regionName: "依兰县",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 668,
            regionCode: "230124",
            regionName: "方正县",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 669,
            regionCode: "230125",
            regionName: "宾县",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 670,
            regionCode: "230126",
            regionName: "巴彦县",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 671,
            regionCode: "230127",
            regionName: "木兰县",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 672,
            regionCode: "230128",
            regionName: "通河县",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 673,
            regionCode: "230129",
            regionName: "延寿县",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 674,
            regionCode: "230183",
            regionName: "尚志市",
            parentCode: "230100",
            level: 3,
          },
          {
            id: 675,
            regionCode: "230184",
            regionName: "五常市",
            parentCode: "230100",
            level: 3,
          },
        ],
      },
      {
        id: 676,
        regionCode: "230200",
        regionName: "齐齐哈尔市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 677,
            regionCode: "230202",
            regionName: "龙沙区",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 678,
            regionCode: "230203",
            regionName: "建华区",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 679,
            regionCode: "230204",
            regionName: "铁锋区",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 680,
            regionCode: "230205",
            regionName: "昂昂溪区",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 681,
            regionCode: "230206",
            regionName: "富拉尔基区",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 682,
            regionCode: "230207",
            regionName: "碾子山区",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 683,
            regionCode: "230208",
            regionName: "梅里斯达斡尔族区",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 684,
            regionCode: "230221",
            regionName: "龙江县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 685,
            regionCode: "230223",
            regionName: "依安县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 686,
            regionCode: "230224",
            regionName: "泰来县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 687,
            regionCode: "230225",
            regionName: "甘南县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 688,
            regionCode: "230227",
            regionName: "富裕县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 689,
            regionCode: "230229",
            regionName: "克山县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 690,
            regionCode: "230230",
            regionName: "克东县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 691,
            regionCode: "230231",
            regionName: "拜泉县",
            parentCode: "230200",
            level: 3,
          },
          {
            id: 692,
            regionCode: "230281",
            regionName: "讷河市",
            parentCode: "230200",
            level: 3,
          },
        ],
      },
      {
        id: 693,
        regionCode: "230300",
        regionName: "鸡西市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 694,
            regionCode: "230302",
            regionName: "鸡冠区",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 695,
            regionCode: "230303",
            regionName: "恒山区",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 696,
            regionCode: "230304",
            regionName: "滴道区",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 697,
            regionCode: "230305",
            regionName: "梨树区",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 698,
            regionCode: "230306",
            regionName: "城子河区",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 699,
            regionCode: "230307",
            regionName: "麻山区",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 700,
            regionCode: "230321",
            regionName: "鸡东县",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 701,
            regionCode: "230381",
            regionName: "虎林市",
            parentCode: "230300",
            level: 3,
          },
          {
            id: 702,
            regionCode: "230382",
            regionName: "密山市",
            parentCode: "230300",
            level: 3,
          },
        ],
      },
      {
        id: 703,
        regionCode: "230400",
        regionName: "鹤岗市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 704,
            regionCode: "230402",
            regionName: "向阳区",
            parentCode: "230400",
            level: 3,
          },
          {
            id: 705,
            regionCode: "230403",
            regionName: "工农区",
            parentCode: "230400",
            level: 3,
          },
          {
            id: 706,
            regionCode: "230404",
            regionName: "南山区",
            parentCode: "230400",
            level: 3,
          },
          {
            id: 707,
            regionCode: "230405",
            regionName: "兴安区",
            parentCode: "230400",
            level: 3,
          },
          {
            id: 708,
            regionCode: "230406",
            regionName: "东山区",
            parentCode: "230400",
            level: 3,
          },
          {
            id: 709,
            regionCode: "230407",
            regionName: "兴山区",
            parentCode: "230400",
            level: 3,
          },
          {
            id: 710,
            regionCode: "230421",
            regionName: "萝北县",
            parentCode: "230400",
            level: 3,
          },
          {
            id: 711,
            regionCode: "230422",
            regionName: "绥滨县",
            parentCode: "230400",
            level: 3,
          },
        ],
      },
      {
        id: 712,
        regionCode: "230500",
        regionName: "双鸭山市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 713,
            regionCode: "230502",
            regionName: "尖山区",
            parentCode: "230500",
            level: 3,
          },
          {
            id: 714,
            regionCode: "230503",
            regionName: "岭东区",
            parentCode: "230500",
            level: 3,
          },
          {
            id: 715,
            regionCode: "230505",
            regionName: "四方台区",
            parentCode: "230500",
            level: 3,
          },
          {
            id: 716,
            regionCode: "230506",
            regionName: "宝山区",
            parentCode: "230500",
            level: 3,
          },
          {
            id: 717,
            regionCode: "230521",
            regionName: "集贤县",
            parentCode: "230500",
            level: 3,
          },
          {
            id: 718,
            regionCode: "230522",
            regionName: "友谊县",
            parentCode: "230500",
            level: 3,
          },
          {
            id: 719,
            regionCode: "230523",
            regionName: "宝清县",
            parentCode: "230500",
            level: 3,
          },
          {
            id: 720,
            regionCode: "230524",
            regionName: "饶河县",
            parentCode: "230500",
            level: 3,
          },
        ],
      },
      {
        id: 721,
        regionCode: "230600",
        regionName: "大庆市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 722,
            regionCode: "230602",
            regionName: "萨尔图区",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 723,
            regionCode: "230603",
            regionName: "龙凤区",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 724,
            regionCode: "230604",
            regionName: "让胡路区",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 725,
            regionCode: "230605",
            regionName: "红岗区",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 726,
            regionCode: "230606",
            regionName: "大同区",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 727,
            regionCode: "230621",
            regionName: "肇州县",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 728,
            regionCode: "230622",
            regionName: "肇源县",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 729,
            regionCode: "230623",
            regionName: "林甸县",
            parentCode: "230600",
            level: 3,
          },
          {
            id: 730,
            regionCode: "230624",
            regionName: "杜尔伯特蒙古族自治县",
            parentCode: "230600",
            level: 3,
          },
        ],
      },
      {
        id: 731,
        regionCode: "230700",
        regionName: "伊春市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 732,
            regionCode: "230702",
            regionName: "伊春区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 733,
            regionCode: "230703",
            regionName: "南岔区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 734,
            regionCode: "230704",
            regionName: "友好区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 735,
            regionCode: "230705",
            regionName: "西林区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 736,
            regionCode: "230706",
            regionName: "翠峦区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 737,
            regionCode: "230707",
            regionName: "新青区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 738,
            regionCode: "230708",
            regionName: "美溪区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 739,
            regionCode: "230709",
            regionName: "金山屯区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 740,
            regionCode: "230710",
            regionName: "五营区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 741,
            regionCode: "230711",
            regionName: "乌马河区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 742,
            regionCode: "230712",
            regionName: "汤旺河区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 743,
            regionCode: "230713",
            regionName: "带岭区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 744,
            regionCode: "230714",
            regionName: "乌伊岭区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 745,
            regionCode: "230715",
            regionName: "红星区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 746,
            regionCode: "230716",
            regionName: "上甘岭区",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 747,
            regionCode: "230722",
            regionName: "嘉荫县",
            parentCode: "230700",
            level: 3,
          },
          {
            id: 748,
            regionCode: "230781",
            regionName: "铁力市",
            parentCode: "230700",
            level: 3,
          },
        ],
      },
      {
        id: 749,
        regionCode: "230800",
        regionName: "佳木斯市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 750,
            regionCode: "230803",
            regionName: "向阳区",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 751,
            regionCode: "230804",
            regionName: "前进区",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 752,
            regionCode: "230805",
            regionName: "东风区",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 753,
            regionCode: "230811",
            regionName: "郊区",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 754,
            regionCode: "230822",
            regionName: "桦南县",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 755,
            regionCode: "230826",
            regionName: "桦川县",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 756,
            regionCode: "230828",
            regionName: "汤原县",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 757,
            regionCode: "230833",
            regionName: "抚远县",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 758,
            regionCode: "230881",
            regionName: "同江市",
            parentCode: "230800",
            level: 3,
          },
          {
            id: 759,
            regionCode: "230882",
            regionName: "富锦市",
            parentCode: "230800",
            level: 3,
          },
        ],
      },
      {
        id: 760,
        regionCode: "230900",
        regionName: "七台河市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 761,
            regionCode: "230902",
            regionName: "新兴区",
            parentCode: "230900",
            level: 3,
          },
          {
            id: 762,
            regionCode: "230903",
            regionName: "桃山区",
            parentCode: "230900",
            level: 3,
          },
          {
            id: 763,
            regionCode: "230904",
            regionName: "茄子河区",
            parentCode: "230900",
            level: 3,
          },
          {
            id: 764,
            regionCode: "230921",
            regionName: "勃利县",
            parentCode: "230900",
            level: 3,
          },
        ],
      },
      {
        id: 765,
        regionCode: "231000",
        regionName: "牡丹江市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 766,
            regionCode: "231002",
            regionName: "东安区",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 767,
            regionCode: "231003",
            regionName: "阳明区",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 768,
            regionCode: "231004",
            regionName: "爱民区",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 769,
            regionCode: "231005",
            regionName: "西安区",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 770,
            regionCode: "231024",
            regionName: "东宁县",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 771,
            regionCode: "231025",
            regionName: "林口县",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 772,
            regionCode: "231081",
            regionName: "绥芬河市",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 773,
            regionCode: "231083",
            regionName: "海林市",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 774,
            regionCode: "231084",
            regionName: "宁安市",
            parentCode: "231000",
            level: 3,
          },
          {
            id: 775,
            regionCode: "231085",
            regionName: "穆棱市",
            parentCode: "231000",
            level: 3,
          },
        ],
      },
      {
        id: 776,
        regionCode: "231100",
        regionName: "黑河市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 777,
            regionCode: "231102",
            regionName: "爱辉区",
            parentCode: "231100",
            level: 3,
          },
          {
            id: 778,
            regionCode: "231121",
            regionName: "嫩江县",
            parentCode: "231100",
            level: 3,
          },
          {
            id: 779,
            regionCode: "231123",
            regionName: "逊克县",
            parentCode: "231100",
            level: 3,
          },
          {
            id: 780,
            regionCode: "231124",
            regionName: "孙吴县",
            parentCode: "231100",
            level: 3,
          },
          {
            id: 781,
            regionCode: "231181",
            regionName: "北安市",
            parentCode: "231100",
            level: 3,
          },
          {
            id: 782,
            regionCode: "231182",
            regionName: "五大连池市",
            parentCode: "231100",
            level: 3,
          },
        ],
      },
      {
        id: 783,
        regionCode: "231200",
        regionName: "绥化市",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 784,
            regionCode: "231202",
            regionName: "北林区",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 785,
            regionCode: "231221",
            regionName: "望奎县",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 786,
            regionCode: "231222",
            regionName: "兰西县",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 787,
            regionCode: "231223",
            regionName: "青冈县",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 788,
            regionCode: "231224",
            regionName: "庆安县",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 789,
            regionCode: "231225",
            regionName: "明水县",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 790,
            regionCode: "231226",
            regionName: "绥棱县",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 791,
            regionCode: "231281",
            regionName: "安达市",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 792,
            regionCode: "231282",
            regionName: "肇东市",
            parentCode: "231200",
            level: 3,
          },
          {
            id: 793,
            regionCode: "231283",
            regionName: "海伦市",
            parentCode: "231200",
            level: 3,
          },
        ],
      },
      {
        id: 794,
        regionCode: "232700",
        regionName: "大兴安岭地区",
        parentCode: "230000",
        level: 2,
        children: [
          {
            id: 795,
            regionCode: "232701",
            regionName: "加格达奇区",
            parentCode: "232700",
            level: 3,
          },
          {
            id: 796,
            regionCode: "232702",
            regionName: "新林区",
            parentCode: "232700",
            level: 3,
          },
          {
            id: 797,
            regionCode: "232703",
            regionName: "松岭区",
            parentCode: "232700",
            level: 3,
          },
          {
            id: 798,
            regionCode: "232704",
            regionName: "呼中区",
            parentCode: "232700",
            level: 3,
          },
          {
            id: 799,
            regionCode: "232721",
            regionName: "呼玛县",
            parentCode: "232700",
            level: 3,
          },
          {
            id: 800,
            regionCode: "232722",
            regionName: "塔河县",
            parentCode: "232700",
            level: 3,
          },
          {
            id: 801,
            regionCode: "232723",
            regionName: "漠河县",
            parentCode: "232700",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 802,
    regionCode: "310000",
    regionName: "上海",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 803,
        regionCode: "310100",
        regionName: "上海市",
        parentCode: "310000",
        level: 2,
        children: [
          {
            id: 804,
            regionCode: "310101",
            regionName: "黄浦区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 805,
            regionCode: "310104",
            regionName: "徐汇区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 806,
            regionCode: "310105",
            regionName: "长宁区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 807,
            regionCode: "310106",
            regionName: "静安区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 808,
            regionCode: "310107",
            regionName: "普陀区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 809,
            regionCode: "310108",
            regionName: "闸北区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 810,
            regionCode: "310109",
            regionName: "虹口区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 811,
            regionCode: "310110",
            regionName: "杨浦区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 812,
            regionCode: "310112",
            regionName: "闵行区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 813,
            regionCode: "310113",
            regionName: "宝山区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 814,
            regionCode: "310114",
            regionName: "嘉定区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 815,
            regionCode: "310115",
            regionName: "浦东新区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 816,
            regionCode: "310116",
            regionName: "金山区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 817,
            regionCode: "310117",
            regionName: "松江区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 818,
            regionCode: "310118",
            regionName: "青浦区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 819,
            regionCode: "310120",
            regionName: "奉贤区",
            parentCode: "310100",
            level: 3,
          },
          {
            id: 820,
            regionCode: "310230",
            regionName: "崇明县",
            parentCode: "310100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 821,
    regionCode: "320000",
    regionName: "江苏省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 822,
        regionCode: "320100",
        regionName: "南京市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 823,
            regionCode: "320102",
            regionName: "玄武区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 824,
            regionCode: "320104",
            regionName: "秦淮区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 825,
            regionCode: "320105",
            regionName: "建邺区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 826,
            regionCode: "320106",
            regionName: "鼓楼区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 827,
            regionCode: "320111",
            regionName: "浦口区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 828,
            regionCode: "320113",
            regionName: "栖霞区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 829,
            regionCode: "320114",
            regionName: "雨花台区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 830,
            regionCode: "320115",
            regionName: "江宁区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 831,
            regionCode: "320116",
            regionName: "六合区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 832,
            regionCode: "320117",
            regionName: "溧水区",
            parentCode: "320100",
            level: 3,
          },
          {
            id: 833,
            regionCode: "320118",
            regionName: "高淳区",
            parentCode: "320100",
            level: 3,
          },
        ],
      },
      {
        id: 834,
        regionCode: "320200",
        regionName: "无锡市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 835,
            regionCode: "320202",
            regionName: "崇安区",
            parentCode: "320200",
            level: 3,
          },
          {
            id: 836,
            regionCode: "320203",
            regionName: "南长区",
            parentCode: "320200",
            level: 3,
          },
          {
            id: 837,
            regionCode: "320204",
            regionName: "北塘区",
            parentCode: "320200",
            level: 3,
          },
          {
            id: 838,
            regionCode: "320205",
            regionName: "锡山区",
            parentCode: "320200",
            level: 3,
          },
          {
            id: 839,
            regionCode: "320206",
            regionName: "惠山区",
            parentCode: "320200",
            level: 3,
          },
          {
            id: 840,
            regionCode: "320211",
            regionName: "滨湖区",
            parentCode: "320200",
            level: 3,
          },
          {
            id: 841,
            regionCode: "320281",
            regionName: "江阴市",
            parentCode: "320200",
            level: 3,
          },
          {
            id: 842,
            regionCode: "320282",
            regionName: "宜兴市",
            parentCode: "320200",
            level: 3,
          },
        ],
      },
      {
        id: 843,
        regionCode: "320300",
        regionName: "徐州市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 844,
            regionCode: "320302",
            regionName: "鼓楼区",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 845,
            regionCode: "320303",
            regionName: "云龙区",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 846,
            regionCode: "320305",
            regionName: "贾汪区",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 847,
            regionCode: "320311",
            regionName: "泉山区",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 848,
            regionCode: "320312",
            regionName: "铜山区",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 849,
            regionCode: "320321",
            regionName: "丰县",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 850,
            regionCode: "320322",
            regionName: "沛县",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 851,
            regionCode: "320324",
            regionName: "睢宁县",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 852,
            regionCode: "320381",
            regionName: "新沂市",
            parentCode: "320300",
            level: 3,
          },
          {
            id: 853,
            regionCode: "320382",
            regionName: "邳州市",
            parentCode: "320300",
            level: 3,
          },
        ],
      },
      {
        id: 854,
        regionCode: "320400",
        regionName: "常州市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 855,
            regionCode: "320402",
            regionName: "天宁区",
            parentCode: "320400",
            level: 3,
          },
          {
            id: 856,
            regionCode: "320404",
            regionName: "钟楼区",
            parentCode: "320400",
            level: 3,
          },
          {
            id: 857,
            regionCode: "320405",
            regionName: "戚墅堰区",
            parentCode: "320400",
            level: 3,
          },
          {
            id: 858,
            regionCode: "320411",
            regionName: "新北区",
            parentCode: "320400",
            level: 3,
          },
          {
            id: 859,
            regionCode: "320412",
            regionName: "武进区",
            parentCode: "320400",
            level: 3,
          },
          {
            id: 860,
            regionCode: "320481",
            regionName: "溧阳市",
            parentCode: "320400",
            level: 3,
          },
          {
            id: 861,
            regionCode: "320482",
            regionName: "金坛市",
            parentCode: "320400",
            level: 3,
          },
        ],
      },
      {
        id: 862,
        regionCode: "320500",
        regionName: "苏州市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 863,
            regionCode: "320505",
            regionName: "虎丘区",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 864,
            regionCode: "320506",
            regionName: "吴中区",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 865,
            regionCode: "320507",
            regionName: "相城区",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 866,
            regionCode: "320508",
            regionName: "姑苏区",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 867,
            regionCode: "320509",
            regionName: "吴江区",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 868,
            regionCode: "320581",
            regionName: "常熟市",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 869,
            regionCode: "320582",
            regionName: "张家港市",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 870,
            regionCode: "320583",
            regionName: "昆山市",
            parentCode: "320500",
            level: 3,
          },
          {
            id: 871,
            regionCode: "320585",
            regionName: "太仓市",
            parentCode: "320500",
            level: 3,
          },
        ],
      },
      {
        id: 872,
        regionCode: "320600",
        regionName: "南通市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 873,
            regionCode: "320602",
            regionName: "崇川区",
            parentCode: "320600",
            level: 3,
          },
          {
            id: 874,
            regionCode: "320611",
            regionName: "港闸区",
            parentCode: "320600",
            level: 3,
          },
          {
            id: 875,
            regionCode: "320612",
            regionName: "通州区",
            parentCode: "320600",
            level: 3,
          },
          {
            id: 876,
            regionCode: "320621",
            regionName: "海安县",
            parentCode: "320600",
            level: 3,
          },
          {
            id: 877,
            regionCode: "320623",
            regionName: "如东县",
            parentCode: "320600",
            level: 3,
          },
          {
            id: 878,
            regionCode: "320681",
            regionName: "启东市",
            parentCode: "320600",
            level: 3,
          },
          {
            id: 879,
            regionCode: "320682",
            regionName: "如皋市",
            parentCode: "320600",
            level: 3,
          },
          {
            id: 880,
            regionCode: "320684",
            regionName: "海门市",
            parentCode: "320600",
            level: 3,
          },
        ],
      },
      {
        id: 881,
        regionCode: "320700",
        regionName: "连云港市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 882,
            regionCode: "320703",
            regionName: "连云区",
            parentCode: "320700",
            level: 3,
          },
          {
            id: 883,
            regionCode: "320706",
            regionName: "海州区",
            parentCode: "320700",
            level: 3,
          },
          {
            id: 884,
            regionCode: "320707",
            regionName: "赣榆区",
            parentCode: "320700",
            level: 3,
          },
          {
            id: 885,
            regionCode: "320722",
            regionName: "东海县",
            parentCode: "320700",
            level: 3,
          },
          {
            id: 886,
            regionCode: "320723",
            regionName: "灌云县",
            parentCode: "320700",
            level: 3,
          },
          {
            id: 887,
            regionCode: "320724",
            regionName: "灌南县",
            parentCode: "320700",
            level: 3,
          },
        ],
      },
      {
        id: 888,
        regionCode: "320800",
        regionName: "淮安市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 889,
            regionCode: "320802",
            regionName: "清河区",
            parentCode: "320800",
            level: 3,
          },
          {
            id: 890,
            regionCode: "320803",
            regionName: "淮安区",
            parentCode: "320800",
            level: 3,
          },
          {
            id: 891,
            regionCode: "320804",
            regionName: "淮阴区",
            parentCode: "320800",
            level: 3,
          },
          {
            id: 892,
            regionCode: "320811",
            regionName: "清浦区",
            parentCode: "320800",
            level: 3,
          },
          {
            id: 893,
            regionCode: "320826",
            regionName: "涟水县",
            parentCode: "320800",
            level: 3,
          },
          {
            id: 894,
            regionCode: "320829",
            regionName: "洪泽县",
            parentCode: "320800",
            level: 3,
          },
          {
            id: 895,
            regionCode: "320830",
            regionName: "盱眙县",
            parentCode: "320800",
            level: 3,
          },
          {
            id: 896,
            regionCode: "320831",
            regionName: "金湖县",
            parentCode: "320800",
            level: 3,
          },
        ],
      },
      {
        id: 897,
        regionCode: "320900",
        regionName: "盐城市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 898,
            regionCode: "320902",
            regionName: "亭湖区",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 899,
            regionCode: "320903",
            regionName: "盐都区",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 900,
            regionCode: "320921",
            regionName: "响水县",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 901,
            regionCode: "320922",
            regionName: "滨海县",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 902,
            regionCode: "320923",
            regionName: "阜宁县",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 903,
            regionCode: "320924",
            regionName: "射阳县",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 904,
            regionCode: "320925",
            regionName: "建湖县",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 905,
            regionCode: "320981",
            regionName: "东台市",
            parentCode: "320900",
            level: 3,
          },
          {
            id: 906,
            regionCode: "320982",
            regionName: "大丰市",
            parentCode: "320900",
            level: 3,
          },
        ],
      },
      {
        id: 907,
        regionCode: "321000",
        regionName: "扬州市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 908,
            regionCode: "321002",
            regionName: "广陵区",
            parentCode: "321000",
            level: 3,
          },
          {
            id: 909,
            regionCode: "321003",
            regionName: "邗江区",
            parentCode: "321000",
            level: 3,
          },
          {
            id: 910,
            regionCode: "321012",
            regionName: "江都区",
            parentCode: "321000",
            level: 3,
          },
          {
            id: 911,
            regionCode: "321023",
            regionName: "宝应县",
            parentCode: "321000",
            level: 3,
          },
          {
            id: 912,
            regionCode: "321081",
            regionName: "仪征市",
            parentCode: "321000",
            level: 3,
          },
          {
            id: 913,
            regionCode: "321084",
            regionName: "高邮市",
            parentCode: "321000",
            level: 3,
          },
        ],
      },
      {
        id: 914,
        regionCode: "321100",
        regionName: "镇江市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 915,
            regionCode: "321102",
            regionName: "京口区",
            parentCode: "321100",
            level: 3,
          },
          {
            id: 916,
            regionCode: "321111",
            regionName: "润州区",
            parentCode: "321100",
            level: 3,
          },
          {
            id: 917,
            regionCode: "321112",
            regionName: "丹徒区",
            parentCode: "321100",
            level: 3,
          },
          {
            id: 918,
            regionCode: "321181",
            regionName: "丹阳市",
            parentCode: "321100",
            level: 3,
          },
          {
            id: 919,
            regionCode: "321182",
            regionName: "扬中市",
            parentCode: "321100",
            level: 3,
          },
          {
            id: 920,
            regionCode: "321183",
            regionName: "句容市",
            parentCode: "321100",
            level: 3,
          },
        ],
      },
      {
        id: 921,
        regionCode: "321200",
        regionName: "泰州市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 922,
            regionCode: "321202",
            regionName: "海陵区",
            parentCode: "321200",
            level: 3,
          },
          {
            id: 923,
            regionCode: "321203",
            regionName: "高港区",
            parentCode: "321200",
            level: 3,
          },
          {
            id: 924,
            regionCode: "321204",
            regionName: "姜堰区",
            parentCode: "321200",
            level: 3,
          },
          {
            id: 925,
            regionCode: "321281",
            regionName: "兴化市",
            parentCode: "321200",
            level: 3,
          },
          {
            id: 926,
            regionCode: "321282",
            regionName: "靖江市",
            parentCode: "321200",
            level: 3,
          },
          {
            id: 927,
            regionCode: "321283",
            regionName: "泰兴市",
            parentCode: "321200",
            level: 3,
          },
        ],
      },
      {
        id: 928,
        regionCode: "321300",
        regionName: "宿迁市",
        parentCode: "320000",
        level: 2,
        children: [
          {
            id: 929,
            regionCode: "321302",
            regionName: "宿城区",
            parentCode: "321300",
            level: 3,
          },
          {
            id: 930,
            regionCode: "321311",
            regionName: "宿豫区",
            parentCode: "321300",
            level: 3,
          },
          {
            id: 931,
            regionCode: "321322",
            regionName: "沭阳县",
            parentCode: "321300",
            level: 3,
          },
          {
            id: 932,
            regionCode: "321323",
            regionName: "泗阳县",
            parentCode: "321300",
            level: 3,
          },
          {
            id: 933,
            regionCode: "321324",
            regionName: "泗洪县",
            parentCode: "321300",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 934,
    regionCode: "330000",
    regionName: "浙江省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 935,
        regionCode: "330100",
        regionName: "杭州市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 936,
            regionCode: "330102",
            regionName: "上城区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 937,
            regionCode: "330103",
            regionName: "下城区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 938,
            regionCode: "330104",
            regionName: "江干区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 939,
            regionCode: "330105",
            regionName: "拱墅区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 940,
            regionCode: "330106",
            regionName: "西湖区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 941,
            regionCode: "330108",
            regionName: "滨江区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 942,
            regionCode: "330109",
            regionName: "萧山区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 943,
            regionCode: "330110",
            regionName: "余杭区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 944,
            regionCode: "330122",
            regionName: "桐庐县",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 945,
            regionCode: "330127",
            regionName: "淳安县",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 946,
            regionCode: "330182",
            regionName: "建德市",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 947,
            regionCode: "330183",
            regionName: "富阳区",
            parentCode: "330100",
            level: 3,
          },
          {
            id: 948,
            regionCode: "330185",
            regionName: "临安市",
            parentCode: "330100",
            level: 3,
          },
        ],
      },
      {
        id: 949,
        regionCode: "330200",
        regionName: "宁波市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 950,
            regionCode: "330203",
            regionName: "海曙区",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 951,
            regionCode: "330204",
            regionName: "江东区",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 952,
            regionCode: "330205",
            regionName: "江北区",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 953,
            regionCode: "330206",
            regionName: "北仑区",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 954,
            regionCode: "330211",
            regionName: "镇海区",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 955,
            regionCode: "330212",
            regionName: "鄞州区",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 956,
            regionCode: "330225",
            regionName: "象山县",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 957,
            regionCode: "330226",
            regionName: "宁海县",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 958,
            regionCode: "330281",
            regionName: "余姚市",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 959,
            regionCode: "330282",
            regionName: "慈溪市",
            parentCode: "330200",
            level: 3,
          },
          {
            id: 960,
            regionCode: "330283",
            regionName: "奉化市",
            parentCode: "330200",
            level: 3,
          },
        ],
      },
      {
        id: 961,
        regionCode: "330300",
        regionName: "温州市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 962,
            regionCode: "330302",
            regionName: "鹿城区",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 963,
            regionCode: "330303",
            regionName: "龙湾区",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 964,
            regionCode: "330304",
            regionName: "瓯海区",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 965,
            regionCode: "330322",
            regionName: "洞头县",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 966,
            regionCode: "330324",
            regionName: "永嘉县",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 967,
            regionCode: "330326",
            regionName: "平阳县",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 968,
            regionCode: "330327",
            regionName: "苍南县",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 969,
            regionCode: "330328",
            regionName: "文成县",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 970,
            regionCode: "330329",
            regionName: "泰顺县",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 971,
            regionCode: "330381",
            regionName: "瑞安市",
            parentCode: "330300",
            level: 3,
          },
          {
            id: 972,
            regionCode: "330382",
            regionName: "乐清市",
            parentCode: "330300",
            level: 3,
          },
        ],
      },
      {
        id: 973,
        regionCode: "330400",
        regionName: "嘉兴市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 974,
            regionCode: "330402",
            regionName: "南湖区",
            parentCode: "330400",
            level: 3,
          },
          {
            id: 975,
            regionCode: "330411",
            regionName: "秀洲区",
            parentCode: "330400",
            level: 3,
          },
          {
            id: 976,
            regionCode: "330421",
            regionName: "嘉善县",
            parentCode: "330400",
            level: 3,
          },
          {
            id: 977,
            regionCode: "330424",
            regionName: "海盐县",
            parentCode: "330400",
            level: 3,
          },
          {
            id: 978,
            regionCode: "330481",
            regionName: "海宁市",
            parentCode: "330400",
            level: 3,
          },
          {
            id: 979,
            regionCode: "330482",
            regionName: "平湖市",
            parentCode: "330400",
            level: 3,
          },
          {
            id: 980,
            regionCode: "330483",
            regionName: "桐乡市",
            parentCode: "330400",
            level: 3,
          },
        ],
      },
      {
        id: 981,
        regionCode: "330500",
        regionName: "湖州市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 982,
            regionCode: "330502",
            regionName: "吴兴区",
            parentCode: "330500",
            level: 3,
          },
          {
            id: 983,
            regionCode: "330503",
            regionName: "南浔区",
            parentCode: "330500",
            level: 3,
          },
          {
            id: 984,
            regionCode: "330521",
            regionName: "德清县",
            parentCode: "330500",
            level: 3,
          },
          {
            id: 985,
            regionCode: "330522",
            regionName: "长兴县",
            parentCode: "330500",
            level: 3,
          },
          {
            id: 986,
            regionCode: "330523",
            regionName: "安吉县",
            parentCode: "330500",
            level: 3,
          },
        ],
      },
      {
        id: 987,
        regionCode: "330600",
        regionName: "绍兴市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 988,
            regionCode: "330602",
            regionName: "越城区",
            parentCode: "330600",
            level: 3,
          },
          {
            id: 989,
            regionCode: "330603",
            regionName: "柯桥区",
            parentCode: "330600",
            level: 3,
          },
          {
            id: 990,
            regionCode: "330604",
            regionName: "上虞区",
            parentCode: "330600",
            level: 3,
          },
          {
            id: 991,
            regionCode: "330624",
            regionName: "新昌县",
            parentCode: "330600",
            level: 3,
          },
          {
            id: 992,
            regionCode: "330681",
            regionName: "诸暨市",
            parentCode: "330600",
            level: 3,
          },
          {
            id: 993,
            regionCode: "330683",
            regionName: "嵊州市",
            parentCode: "330600",
            level: 3,
          },
        ],
      },
      {
        id: 994,
        regionCode: "330700",
        regionName: "金华市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 995,
            regionCode: "330702",
            regionName: "婺城区",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 996,
            regionCode: "330703",
            regionName: "金东区",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 997,
            regionCode: "330723",
            regionName: "武义县",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 998,
            regionCode: "330726",
            regionName: "浦江县",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 999,
            regionCode: "330727",
            regionName: "磐安县",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 1000,
            regionCode: "330781",
            regionName: "兰溪市",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 1001,
            regionCode: "330782",
            regionName: "义乌市",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 1002,
            regionCode: "330783",
            regionName: "东阳市",
            parentCode: "330700",
            level: 3,
          },
          {
            id: 1003,
            regionCode: "330784",
            regionName: "永康市",
            parentCode: "330700",
            level: 3,
          },
        ],
      },
      {
        id: 1004,
        regionCode: "330800",
        regionName: "衢州市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 1005,
            regionCode: "330802",
            regionName: "柯城区",
            parentCode: "330800",
            level: 3,
          },
          {
            id: 1006,
            regionCode: "330803",
            regionName: "衢江区",
            parentCode: "330800",
            level: 3,
          },
          {
            id: 1007,
            regionCode: "330822",
            regionName: "常山县",
            parentCode: "330800",
            level: 3,
          },
          {
            id: 1008,
            regionCode: "330824",
            regionName: "开化县",
            parentCode: "330800",
            level: 3,
          },
          {
            id: 1009,
            regionCode: "330825",
            regionName: "龙游县",
            parentCode: "330800",
            level: 3,
          },
          {
            id: 1010,
            regionCode: "330881",
            regionName: "江山市",
            parentCode: "330800",
            level: 3,
          },
        ],
      },
      {
        id: 1011,
        regionCode: "330900",
        regionName: "舟山市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 1012,
            regionCode: "330902",
            regionName: "定海区",
            parentCode: "330900",
            level: 3,
          },
          {
            id: 1013,
            regionCode: "330903",
            regionName: "普陀区",
            parentCode: "330900",
            level: 3,
          },
          {
            id: 1014,
            regionCode: "330921",
            regionName: "岱山县",
            parentCode: "330900",
            level: 3,
          },
          {
            id: 1015,
            regionCode: "330922",
            regionName: "嵊泗县",
            parentCode: "330900",
            level: 3,
          },
        ],
      },
      {
        id: 1016,
        regionCode: "331000",
        regionName: "台州市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 1017,
            regionCode: "331002",
            regionName: "椒江区",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1018,
            regionCode: "331003",
            regionName: "黄岩区",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1019,
            regionCode: "331004",
            regionName: "路桥区",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1020,
            regionCode: "331021",
            regionName: "玉环县",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1021,
            regionCode: "331022",
            regionName: "三门县",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1022,
            regionCode: "331023",
            regionName: "天台县",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1023,
            regionCode: "331024",
            regionName: "仙居县",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1024,
            regionCode: "331081",
            regionName: "温岭市",
            parentCode: "331000",
            level: 3,
          },
          {
            id: 1025,
            regionCode: "331082",
            regionName: "临海市",
            parentCode: "331000",
            level: 3,
          },
        ],
      },
      {
        id: 1026,
        regionCode: "331100",
        regionName: "丽水市",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 1027,
            regionCode: "331102",
            regionName: "莲都区",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1028,
            regionCode: "331121",
            regionName: "青田县",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1029,
            regionCode: "331122",
            regionName: "缙云县",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1030,
            regionCode: "331123",
            regionName: "遂昌县",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1031,
            regionCode: "331124",
            regionName: "松阳县",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1032,
            regionCode: "331125",
            regionName: "云和县",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1033,
            regionCode: "331126",
            regionName: "庆元县",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1034,
            regionCode: "331127",
            regionName: "景宁畲族自治县",
            parentCode: "331100",
            level: 3,
          },
          {
            id: 1035,
            regionCode: "331181",
            regionName: "龙泉市",
            parentCode: "331100",
            level: 3,
          },
        ],
      },
      {
        id: 1036,
        regionCode: "331200",
        regionName: "舟山群岛新区",
        parentCode: "330000",
        level: 2,
        children: [
          {
            id: 1037,
            regionCode: "331201",
            regionName: "金塘岛",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1038,
            regionCode: "331202",
            regionName: "六横岛",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1039,
            regionCode: "331203",
            regionName: "衢山岛",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1040,
            regionCode: "331204",
            regionName: "舟山本岛西北部",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1041,
            regionCode: "331205",
            regionName: "岱山岛西南部",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1042,
            regionCode: "331206",
            regionName: "泗礁岛",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1043,
            regionCode: "331207",
            regionName: "朱家尖岛",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1044,
            regionCode: "331208",
            regionName: "洋山岛",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1045,
            regionCode: "331209",
            regionName: "长涂岛",
            parentCode: "331200",
            level: 3,
          },
          {
            id: 1046,
            regionCode: "331210",
            regionName: "虾峙岛",
            parentCode: "331200",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1047,
    regionCode: "340000",
    regionName: "安徽省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1048,
        regionCode: "340100",
        regionName: "合肥市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1049,
            regionCode: "340102",
            regionName: "瑶海区",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1050,
            regionCode: "340103",
            regionName: "庐阳区",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1051,
            regionCode: "340104",
            regionName: "蜀山区",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1052,
            regionCode: "340111",
            regionName: "包河区",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1053,
            regionCode: "340121",
            regionName: "长丰县",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1054,
            regionCode: "340122",
            regionName: "肥东县",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1055,
            regionCode: "340123",
            regionName: "肥西县",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1056,
            regionCode: "340124",
            regionName: "庐江县",
            parentCode: "340100",
            level: 3,
          },
          {
            id: 1057,
            regionCode: "340181",
            regionName: "巢湖市",
            parentCode: "340100",
            level: 3,
          },
        ],
      },
      {
        id: 1058,
        regionCode: "340200",
        regionName: "芜湖市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1059,
            regionCode: "340202",
            regionName: "镜湖区",
            parentCode: "340200",
            level: 3,
          },
          {
            id: 1060,
            regionCode: "340203",
            regionName: "弋江区",
            parentCode: "340200",
            level: 3,
          },
          {
            id: 1061,
            regionCode: "340207",
            regionName: "鸠江区",
            parentCode: "340200",
            level: 3,
          },
          {
            id: 1062,
            regionCode: "340208",
            regionName: "三山区",
            parentCode: "340200",
            level: 3,
          },
          {
            id: 1063,
            regionCode: "340221",
            regionName: "芜湖县",
            parentCode: "340200",
            level: 3,
          },
          {
            id: 1064,
            regionCode: "340222",
            regionName: "繁昌县",
            parentCode: "340200",
            level: 3,
          },
          {
            id: 1065,
            regionCode: "340223",
            regionName: "南陵县",
            parentCode: "340200",
            level: 3,
          },
          {
            id: 1066,
            regionCode: "340225",
            regionName: "无为县",
            parentCode: "340200",
            level: 3,
          },
        ],
      },
      {
        id: 1067,
        regionCode: "340300",
        regionName: "蚌埠市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1068,
            regionCode: "340302",
            regionName: "龙子湖区",
            parentCode: "340300",
            level: 3,
          },
          {
            id: 1069,
            regionCode: "340303",
            regionName: "蚌山区",
            parentCode: "340300",
            level: 3,
          },
          {
            id: 1070,
            regionCode: "340304",
            regionName: "禹会区",
            parentCode: "340300",
            level: 3,
          },
          {
            id: 1071,
            regionCode: "340311",
            regionName: "淮上区",
            parentCode: "340300",
            level: 3,
          },
          {
            id: 1072,
            regionCode: "340321",
            regionName: "怀远县",
            parentCode: "340300",
            level: 3,
          },
          {
            id: 1073,
            regionCode: "340322",
            regionName: "五河县",
            parentCode: "340300",
            level: 3,
          },
          {
            id: 1074,
            regionCode: "340323",
            regionName: "固镇县",
            parentCode: "340300",
            level: 3,
          },
        ],
      },
      {
        id: 1075,
        regionCode: "340400",
        regionName: "淮南市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1076,
            regionCode: "340402",
            regionName: "大通区",
            parentCode: "340400",
            level: 3,
          },
          {
            id: 1077,
            regionCode: "340403",
            regionName: "田家庵区",
            parentCode: "340400",
            level: 3,
          },
          {
            id: 1078,
            regionCode: "340404",
            regionName: "谢家集区",
            parentCode: "340400",
            level: 3,
          },
          {
            id: 1079,
            regionCode: "340405",
            regionName: "八公山区",
            parentCode: "340400",
            level: 3,
          },
          {
            id: 1080,
            regionCode: "340406",
            regionName: "潘集区",
            parentCode: "340400",
            level: 3,
          },
          {
            id: 1081,
            regionCode: "340421",
            regionName: "凤台县",
            parentCode: "340400",
            level: 3,
          },
        ],
      },
      {
        id: 1082,
        regionCode: "340500",
        regionName: "马鞍山市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1083,
            regionCode: "340503",
            regionName: "花山区",
            parentCode: "340500",
            level: 3,
          },
          {
            id: 1084,
            regionCode: "340504",
            regionName: "雨山区",
            parentCode: "340500",
            level: 3,
          },
          {
            id: 1085,
            regionCode: "340506",
            regionName: "博望区",
            parentCode: "340500",
            level: 3,
          },
          {
            id: 1086,
            regionCode: "340521",
            regionName: "当涂县",
            parentCode: "340500",
            level: 3,
          },
          {
            id: 1087,
            regionCode: "340522",
            regionName: "含山县",
            parentCode: "340500",
            level: 3,
          },
          {
            id: 1088,
            regionCode: "340523",
            regionName: "和县",
            parentCode: "340500",
            level: 3,
          },
        ],
      },
      {
        id: 1089,
        regionCode: "340600",
        regionName: "淮北市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1090,
            regionCode: "340602",
            regionName: "杜集区",
            parentCode: "340600",
            level: 3,
          },
          {
            id: 1091,
            regionCode: "340603",
            regionName: "相山区",
            parentCode: "340600",
            level: 3,
          },
          {
            id: 1092,
            regionCode: "340604",
            regionName: "烈山区",
            parentCode: "340600",
            level: 3,
          },
          {
            id: 1093,
            regionCode: "340621",
            regionName: "濉溪县",
            parentCode: "340600",
            level: 3,
          },
        ],
      },
      {
        id: 1094,
        regionCode: "340700",
        regionName: "铜陵市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1095,
            regionCode: "340702",
            regionName: "铜官山区",
            parentCode: "340700",
            level: 3,
          },
          {
            id: 1096,
            regionCode: "340703",
            regionName: "狮子山区",
            parentCode: "340700",
            level: 3,
          },
          {
            id: 1097,
            regionCode: "340711",
            regionName: "郊区",
            parentCode: "340700",
            level: 3,
          },
          {
            id: 1098,
            regionCode: "340721",
            regionName: "铜陵县",
            parentCode: "340700",
            level: 3,
          },
        ],
      },
      {
        id: 1099,
        regionCode: "340800",
        regionName: "安庆市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1100,
            regionCode: "340802",
            regionName: "迎江区",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1101,
            regionCode: "340803",
            regionName: "大观区",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1102,
            regionCode: "340811",
            regionName: "宜秀区",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1103,
            regionCode: "340822",
            regionName: "怀宁县",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1104,
            regionCode: "340823",
            regionName: "枞阳县",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1105,
            regionCode: "340824",
            regionName: "潜山县",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1106,
            regionCode: "340825",
            regionName: "太湖县",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1107,
            regionCode: "340826",
            regionName: "宿松县",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1108,
            regionCode: "340827",
            regionName: "望江县",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1109,
            regionCode: "340828",
            regionName: "岳西县",
            parentCode: "340800",
            level: 3,
          },
          {
            id: 1110,
            regionCode: "340881",
            regionName: "桐城市",
            parentCode: "340800",
            level: 3,
          },
        ],
      },
      {
        id: 1111,
        regionCode: "341000",
        regionName: "黄山市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1112,
            regionCode: "341002",
            regionName: "屯溪区",
            parentCode: "341000",
            level: 3,
          },
          {
            id: 1113,
            regionCode: "341003",
            regionName: "黄山区",
            parentCode: "341000",
            level: 3,
          },
          {
            id: 1114,
            regionCode: "341004",
            regionName: "徽州区",
            parentCode: "341000",
            level: 3,
          },
          {
            id: 1115,
            regionCode: "341021",
            regionName: "歙县",
            parentCode: "341000",
            level: 3,
          },
          {
            id: 1116,
            regionCode: "341022",
            regionName: "休宁县",
            parentCode: "341000",
            level: 3,
          },
          {
            id: 1117,
            regionCode: "341023",
            regionName: "黟县",
            parentCode: "341000",
            level: 3,
          },
          {
            id: 1118,
            regionCode: "341024",
            regionName: "祁门县",
            parentCode: "341000",
            level: 3,
          },
        ],
      },
      {
        id: 1119,
        regionCode: "341100",
        regionName: "滁州市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1120,
            regionCode: "341102",
            regionName: "琅琊区",
            parentCode: "341100",
            level: 3,
          },
          {
            id: 1121,
            regionCode: "341103",
            regionName: "南谯区",
            parentCode: "341100",
            level: 3,
          },
          {
            id: 1122,
            regionCode: "341122",
            regionName: "来安县",
            parentCode: "341100",
            level: 3,
          },
          {
            id: 1123,
            regionCode: "341124",
            regionName: "全椒县",
            parentCode: "341100",
            level: 3,
          },
          {
            id: 1124,
            regionCode: "341125",
            regionName: "定远县",
            parentCode: "341100",
            level: 3,
          },
          {
            id: 1125,
            regionCode: "341126",
            regionName: "凤阳县",
            parentCode: "341100",
            level: 3,
          },
          {
            id: 1126,
            regionCode: "341181",
            regionName: "天长市",
            parentCode: "341100",
            level: 3,
          },
          {
            id: 1127,
            regionCode: "341182",
            regionName: "明光市",
            parentCode: "341100",
            level: 3,
          },
        ],
      },
      {
        id: 1128,
        regionCode: "341200",
        regionName: "阜阳市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1129,
            regionCode: "341202",
            regionName: "颍州区",
            parentCode: "341200",
            level: 3,
          },
          {
            id: 1130,
            regionCode: "341203",
            regionName: "颍东区",
            parentCode: "341200",
            level: 3,
          },
          {
            id: 1131,
            regionCode: "341204",
            regionName: "颍泉区",
            parentCode: "341200",
            level: 3,
          },
          {
            id: 1132,
            regionCode: "341221",
            regionName: "临泉县",
            parentCode: "341200",
            level: 3,
          },
          {
            id: 1133,
            regionCode: "341222",
            regionName: "太和县",
            parentCode: "341200",
            level: 3,
          },
          {
            id: 1134,
            regionCode: "341225",
            regionName: "阜南县",
            parentCode: "341200",
            level: 3,
          },
          {
            id: 1135,
            regionCode: "341226",
            regionName: "颍上县",
            parentCode: "341200",
            level: 3,
          },
          {
            id: 1136,
            regionCode: "341282",
            regionName: "界首市",
            parentCode: "341200",
            level: 3,
          },
        ],
      },
      {
        id: 1137,
        regionCode: "341300",
        regionName: "宿州市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1138,
            regionCode: "341302",
            regionName: "埇桥区",
            parentCode: "341300",
            level: 3,
          },
          {
            id: 1139,
            regionCode: "341321",
            regionName: "砀山县",
            parentCode: "341300",
            level: 3,
          },
          {
            id: 1140,
            regionCode: "341322",
            regionName: "萧县",
            parentCode: "341300",
            level: 3,
          },
          {
            id: 1141,
            regionCode: "341323",
            regionName: "灵璧县",
            parentCode: "341300",
            level: 3,
          },
          {
            id: 1142,
            regionCode: "341324",
            regionName: "泗县",
            parentCode: "341300",
            level: 3,
          },
        ],
      },
      {
        id: 1143,
        regionCode: "341500",
        regionName: "六安市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1144,
            regionCode: "341502",
            regionName: "金安区",
            parentCode: "341500",
            level: 3,
          },
          {
            id: 1145,
            regionCode: "341503",
            regionName: "裕安区",
            parentCode: "341500",
            level: 3,
          },
          {
            id: 1146,
            regionCode: "341521",
            regionName: "寿县",
            parentCode: "341500",
            level: 3,
          },
          {
            id: 1147,
            regionCode: "341522",
            regionName: "霍邱县",
            parentCode: "341500",
            level: 3,
          },
          {
            id: 1148,
            regionCode: "341523",
            regionName: "舒城县",
            parentCode: "341500",
            level: 3,
          },
          {
            id: 1149,
            regionCode: "341524",
            regionName: "金寨县",
            parentCode: "341500",
            level: 3,
          },
          {
            id: 1150,
            regionCode: "341525",
            regionName: "霍山县",
            parentCode: "341500",
            level: 3,
          },
        ],
      },
      {
        id: 1151,
        regionCode: "341600",
        regionName: "亳州市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1152,
            regionCode: "341602",
            regionName: "谯城区",
            parentCode: "341600",
            level: 3,
          },
          {
            id: 1153,
            regionCode: "341621",
            regionName: "涡阳县",
            parentCode: "341600",
            level: 3,
          },
          {
            id: 1154,
            regionCode: "341622",
            regionName: "蒙城县",
            parentCode: "341600",
            level: 3,
          },
          {
            id: 1155,
            regionCode: "341623",
            regionName: "利辛县",
            parentCode: "341600",
            level: 3,
          },
        ],
      },
      {
        id: 1156,
        regionCode: "341700",
        regionName: "池州市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1157,
            regionCode: "341702",
            regionName: "贵池区",
            parentCode: "341700",
            level: 3,
          },
          {
            id: 1158,
            regionCode: "341721",
            regionName: "东至县",
            parentCode: "341700",
            level: 3,
          },
          {
            id: 1159,
            regionCode: "341722",
            regionName: "石台县",
            parentCode: "341700",
            level: 3,
          },
          {
            id: 1160,
            regionCode: "341723",
            regionName: "青阳县",
            parentCode: "341700",
            level: 3,
          },
        ],
      },
      {
        id: 1161,
        regionCode: "341800",
        regionName: "宣城市",
        parentCode: "340000",
        level: 2,
        children: [
          {
            id: 1162,
            regionCode: "341802",
            regionName: "宣州区",
            parentCode: "341800",
            level: 3,
          },
          {
            id: 1163,
            regionCode: "341821",
            regionName: "郎溪县",
            parentCode: "341800",
            level: 3,
          },
          {
            id: 1164,
            regionCode: "341822",
            regionName: "广德县",
            parentCode: "341800",
            level: 3,
          },
          {
            id: 1165,
            regionCode: "341823",
            regionName: "泾县",
            parentCode: "341800",
            level: 3,
          },
          {
            id: 1166,
            regionCode: "341824",
            regionName: "绩溪县",
            parentCode: "341800",
            level: 3,
          },
          {
            id: 1167,
            regionCode: "341825",
            regionName: "旌德县",
            parentCode: "341800",
            level: 3,
          },
          {
            id: 1168,
            regionCode: "341881",
            regionName: "宁国市",
            parentCode: "341800",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1169,
    regionCode: "350000",
    regionName: "福建省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1170,
        regionCode: "350100",
        regionName: "福州市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1171,
            regionCode: "350102",
            regionName: "鼓楼区",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1172,
            regionCode: "350103",
            regionName: "台江区",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1173,
            regionCode: "350104",
            regionName: "仓山区",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1174,
            regionCode: "350105",
            regionName: "马尾区",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1175,
            regionCode: "350111",
            regionName: "晋安区",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1176,
            regionCode: "350121",
            regionName: "闽侯县",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1177,
            regionCode: "350122",
            regionName: "连江县",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1178,
            regionCode: "350123",
            regionName: "罗源县",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1179,
            regionCode: "350124",
            regionName: "闽清县",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1180,
            regionCode: "350125",
            regionName: "永泰县",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1181,
            regionCode: "350128",
            regionName: "平潭县",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1182,
            regionCode: "350181",
            regionName: "福清市",
            parentCode: "350100",
            level: 3,
          },
          {
            id: 1183,
            regionCode: "350182",
            regionName: "长乐市",
            parentCode: "350100",
            level: 3,
          },
        ],
      },
      {
        id: 1184,
        regionCode: "350200",
        regionName: "厦门市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1185,
            regionCode: "350203",
            regionName: "思明区",
            parentCode: "350200",
            level: 3,
          },
          {
            id: 1186,
            regionCode: "350205",
            regionName: "海沧区",
            parentCode: "350200",
            level: 3,
          },
          {
            id: 1187,
            regionCode: "350206",
            regionName: "湖里区",
            parentCode: "350200",
            level: 3,
          },
          {
            id: 1188,
            regionCode: "350211",
            regionName: "集美区",
            parentCode: "350200",
            level: 3,
          },
          {
            id: 1189,
            regionCode: "350212",
            regionName: "同安区",
            parentCode: "350200",
            level: 3,
          },
          {
            id: 1190,
            regionCode: "350213",
            regionName: "翔安区",
            parentCode: "350200",
            level: 3,
          },
        ],
      },
      {
        id: 1191,
        regionCode: "350300",
        regionName: "莆田市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1192,
            regionCode: "350302",
            regionName: "城厢区",
            parentCode: "350300",
            level: 3,
          },
          {
            id: 1193,
            regionCode: "350303",
            regionName: "涵江区",
            parentCode: "350300",
            level: 3,
          },
          {
            id: 1194,
            regionCode: "350304",
            regionName: "荔城区",
            parentCode: "350300",
            level: 3,
          },
          {
            id: 1195,
            regionCode: "350305",
            regionName: "秀屿区",
            parentCode: "350300",
            level: 3,
          },
          {
            id: 1196,
            regionCode: "350322",
            regionName: "仙游县",
            parentCode: "350300",
            level: 3,
          },
        ],
      },
      {
        id: 1197,
        regionCode: "350400",
        regionName: "三明市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1198,
            regionCode: "350402",
            regionName: "梅列区",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1199,
            regionCode: "350403",
            regionName: "三元区",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1200,
            regionCode: "350421",
            regionName: "明溪县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1201,
            regionCode: "350423",
            regionName: "清流县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1202,
            regionCode: "350424",
            regionName: "宁化县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1203,
            regionCode: "350425",
            regionName: "大田县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1204,
            regionCode: "350426",
            regionName: "尤溪县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1205,
            regionCode: "350427",
            regionName: "沙县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1206,
            regionCode: "350428",
            regionName: "将乐县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1207,
            regionCode: "350429",
            regionName: "泰宁县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1208,
            regionCode: "350430",
            regionName: "建宁县",
            parentCode: "350400",
            level: 3,
          },
          {
            id: 1209,
            regionCode: "350481",
            regionName: "永安市",
            parentCode: "350400",
            level: 3,
          },
        ],
      },
      {
        id: 1210,
        regionCode: "350500",
        regionName: "泉州市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1211,
            regionCode: "350502",
            regionName: "鲤城区",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1212,
            regionCode: "350503",
            regionName: "丰泽区",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1213,
            regionCode: "350504",
            regionName: "洛江区",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1214,
            regionCode: "350505",
            regionName: "泉港区",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1215,
            regionCode: "350521",
            regionName: "惠安县",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1216,
            regionCode: "350524",
            regionName: "安溪县",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1217,
            regionCode: "350525",
            regionName: "永春县",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1218,
            regionCode: "350526",
            regionName: "德化县",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1219,
            regionCode: "350527",
            regionName: "金门县",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1220,
            regionCode: "350581",
            regionName: "石狮市",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1221,
            regionCode: "350582",
            regionName: "晋江市",
            parentCode: "350500",
            level: 3,
          },
          {
            id: 1222,
            regionCode: "350583",
            regionName: "南安市",
            parentCode: "350500",
            level: 3,
          },
        ],
      },
      {
        id: 1223,
        regionCode: "350600",
        regionName: "漳州市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1224,
            regionCode: "350602",
            regionName: "芗城区",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1225,
            regionCode: "350603",
            regionName: "龙文区",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1226,
            regionCode: "350622",
            regionName: "云霄县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1227,
            regionCode: "350623",
            regionName: "漳浦县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1228,
            regionCode: "350624",
            regionName: "诏安县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1229,
            regionCode: "350625",
            regionName: "长泰县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1230,
            regionCode: "350626",
            regionName: "东山县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1231,
            regionCode: "350627",
            regionName: "南靖县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1232,
            regionCode: "350628",
            regionName: "平和县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1233,
            regionCode: "350629",
            regionName: "华安县",
            parentCode: "350600",
            level: 3,
          },
          {
            id: 1234,
            regionCode: "350681",
            regionName: "龙海市",
            parentCode: "350600",
            level: 3,
          },
        ],
      },
      {
        id: 1235,
        regionCode: "350700",
        regionName: "南平市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1236,
            regionCode: "350702",
            regionName: "延平区",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1237,
            regionCode: "350703",
            regionName: "建阳区",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1238,
            regionCode: "350721",
            regionName: "顺昌县",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1239,
            regionCode: "350722",
            regionName: "浦城县",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1240,
            regionCode: "350723",
            regionName: "光泽县",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1241,
            regionCode: "350724",
            regionName: "松溪县",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1242,
            regionCode: "350725",
            regionName: "政和县",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1243,
            regionCode: "350781",
            regionName: "邵武市",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1244,
            regionCode: "350782",
            regionName: "武夷山市",
            parentCode: "350700",
            level: 3,
          },
          {
            id: 1245,
            regionCode: "350783",
            regionName: "建瓯市",
            parentCode: "350700",
            level: 3,
          },
        ],
      },
      {
        id: 1246,
        regionCode: "350800",
        regionName: "龙岩市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1247,
            regionCode: "350802",
            regionName: "新罗区",
            parentCode: "350800",
            level: 3,
          },
          {
            id: 1248,
            regionCode: "350821",
            regionName: "长汀县",
            parentCode: "350800",
            level: 3,
          },
          {
            id: 1249,
            regionCode: "350822",
            regionName: "永定区",
            parentCode: "350800",
            level: 3,
          },
          {
            id: 1250,
            regionCode: "350823",
            regionName: "上杭县",
            parentCode: "350800",
            level: 3,
          },
          {
            id: 1251,
            regionCode: "350824",
            regionName: "武平县",
            parentCode: "350800",
            level: 3,
          },
          {
            id: 1252,
            regionCode: "350825",
            regionName: "连城县",
            parentCode: "350800",
            level: 3,
          },
          {
            id: 1253,
            regionCode: "350881",
            regionName: "漳平市",
            parentCode: "350800",
            level: 3,
          },
        ],
      },
      {
        id: 1254,
        regionCode: "350900",
        regionName: "宁德市",
        parentCode: "350000",
        level: 2,
        children: [
          {
            id: 1255,
            regionCode: "350902",
            regionName: "蕉城区",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1256,
            regionCode: "350921",
            regionName: "霞浦县",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1257,
            regionCode: "350922",
            regionName: "古田县",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1258,
            regionCode: "350923",
            regionName: "屏南县",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1259,
            regionCode: "350924",
            regionName: "寿宁县",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1260,
            regionCode: "350925",
            regionName: "周宁县",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1261,
            regionCode: "350926",
            regionName: "柘荣县",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1262,
            regionCode: "350981",
            regionName: "福安市",
            parentCode: "350900",
            level: 3,
          },
          {
            id: 1263,
            regionCode: "350982",
            regionName: "福鼎市",
            parentCode: "350900",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1264,
    regionCode: "360000",
    regionName: "江西省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1265,
        regionCode: "360100",
        regionName: "南昌市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1266,
            regionCode: "360102",
            regionName: "东湖区",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1267,
            regionCode: "360103",
            regionName: "西湖区",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1268,
            regionCode: "360104",
            regionName: "青云谱区",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1269,
            regionCode: "360105",
            regionName: "湾里区",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1270,
            regionCode: "360111",
            regionName: "青山湖区",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1271,
            regionCode: "360121",
            regionName: "南昌县",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1272,
            regionCode: "360122",
            regionName: "新建县",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1273,
            regionCode: "360123",
            regionName: "安义县",
            parentCode: "360100",
            level: 3,
          },
          {
            id: 1274,
            regionCode: "360124",
            regionName: "进贤县",
            parentCode: "360100",
            level: 3,
          },
        ],
      },
      {
        id: 1275,
        regionCode: "360200",
        regionName: "景德镇市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1276,
            regionCode: "360202",
            regionName: "昌江区",
            parentCode: "360200",
            level: 3,
          },
          {
            id: 1277,
            regionCode: "360203",
            regionName: "珠山区",
            parentCode: "360200",
            level: 3,
          },
          {
            id: 1278,
            regionCode: "360222",
            regionName: "浮梁县",
            parentCode: "360200",
            level: 3,
          },
          {
            id: 1279,
            regionCode: "360281",
            regionName: "乐平市",
            parentCode: "360200",
            level: 3,
          },
        ],
      },
      {
        id: 1280,
        regionCode: "360300",
        regionName: "萍乡市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1281,
            regionCode: "360302",
            regionName: "安源区",
            parentCode: "360300",
            level: 3,
          },
          {
            id: 1282,
            regionCode: "360313",
            regionName: "湘东区",
            parentCode: "360300",
            level: 3,
          },
          {
            id: 1283,
            regionCode: "360321",
            regionName: "莲花县",
            parentCode: "360300",
            level: 3,
          },
          {
            id: 1284,
            regionCode: "360322",
            regionName: "上栗县",
            parentCode: "360300",
            level: 3,
          },
          {
            id: 1285,
            regionCode: "360323",
            regionName: "芦溪县",
            parentCode: "360300",
            level: 3,
          },
        ],
      },
      {
        id: 1286,
        regionCode: "360400",
        regionName: "九江市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1287,
            regionCode: "360402",
            regionName: "庐山区",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1288,
            regionCode: "360403",
            regionName: "浔阳区",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1289,
            regionCode: "360421",
            regionName: "九江县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1290,
            regionCode: "360423",
            regionName: "武宁县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1291,
            regionCode: "360424",
            regionName: "修水县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1292,
            regionCode: "360425",
            regionName: "永修县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1293,
            regionCode: "360426",
            regionName: "德安县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1294,
            regionCode: "360427",
            regionName: "星子县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1295,
            regionCode: "360428",
            regionName: "都昌县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1296,
            regionCode: "360429",
            regionName: "湖口县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1297,
            regionCode: "360430",
            regionName: "彭泽县",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1298,
            regionCode: "360481",
            regionName: "瑞昌市",
            parentCode: "360400",
            level: 3,
          },
          {
            id: 1299,
            regionCode: "360482",
            regionName: "共青城市",
            parentCode: "360400",
            level: 3,
          },
        ],
      },
      {
        id: 1300,
        regionCode: "360500",
        regionName: "新余市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1301,
            regionCode: "360502",
            regionName: "渝水区",
            parentCode: "360500",
            level: 3,
          },
          {
            id: 1302,
            regionCode: "360521",
            regionName: "分宜县",
            parentCode: "360500",
            level: 3,
          },
        ],
      },
      {
        id: 1303,
        regionCode: "360600",
        regionName: "鹰潭市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1304,
            regionCode: "360602",
            regionName: "月湖区",
            parentCode: "360600",
            level: 3,
          },
          {
            id: 1305,
            regionCode: "360622",
            regionName: "余江县",
            parentCode: "360600",
            level: 3,
          },
          {
            id: 1306,
            regionCode: "360681",
            regionName: "贵溪市",
            parentCode: "360600",
            level: 3,
          },
        ],
      },
      {
        id: 1307,
        regionCode: "360700",
        regionName: "赣州市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1308,
            regionCode: "360702",
            regionName: "章贡区",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1309,
            regionCode: "360703",
            regionName: "南康区",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1310,
            regionCode: "360721",
            regionName: "赣县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1311,
            regionCode: "360722",
            regionName: "信丰县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1312,
            regionCode: "360723",
            regionName: "大余县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1313,
            regionCode: "360724",
            regionName: "上犹县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1314,
            regionCode: "360725",
            regionName: "崇义县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1315,
            regionCode: "360726",
            regionName: "安远县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1316,
            regionCode: "360727",
            regionName: "龙南县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1317,
            regionCode: "360728",
            regionName: "定南县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1318,
            regionCode: "360729",
            regionName: "全南县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1319,
            regionCode: "360730",
            regionName: "宁都县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1320,
            regionCode: "360731",
            regionName: "于都县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1321,
            regionCode: "360732",
            regionName: "兴国县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1322,
            regionCode: "360733",
            regionName: "会昌县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1323,
            regionCode: "360734",
            regionName: "寻乌县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1324,
            regionCode: "360735",
            regionName: "石城县",
            parentCode: "360700",
            level: 3,
          },
          {
            id: 1325,
            regionCode: "360781",
            regionName: "瑞金市",
            parentCode: "360700",
            level: 3,
          },
        ],
      },
      {
        id: 1326,
        regionCode: "360800",
        regionName: "吉安市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1327,
            regionCode: "360802",
            regionName: "吉州区",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1328,
            regionCode: "360803",
            regionName: "青原区",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1329,
            regionCode: "360821",
            regionName: "吉安县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1330,
            regionCode: "360822",
            regionName: "吉水县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1331,
            regionCode: "360823",
            regionName: "峡江县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1332,
            regionCode: "360824",
            regionName: "新干县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1333,
            regionCode: "360825",
            regionName: "永丰县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1334,
            regionCode: "360826",
            regionName: "泰和县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1335,
            regionCode: "360827",
            regionName: "遂川县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1336,
            regionCode: "360828",
            regionName: "万安县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1337,
            regionCode: "360829",
            regionName: "安福县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1338,
            regionCode: "360830",
            regionName: "永新县",
            parentCode: "360800",
            level: 3,
          },
          {
            id: 1339,
            regionCode: "360881",
            regionName: "井冈山市",
            parentCode: "360800",
            level: 3,
          },
        ],
      },
      {
        id: 1340,
        regionCode: "360900",
        regionName: "宜春市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1341,
            regionCode: "360902",
            regionName: "袁州区",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1342,
            regionCode: "360921",
            regionName: "奉新县",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1343,
            regionCode: "360922",
            regionName: "万载县",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1344,
            regionCode: "360923",
            regionName: "上高县",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1345,
            regionCode: "360924",
            regionName: "宜丰县",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1346,
            regionCode: "360925",
            regionName: "靖安县",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1347,
            regionCode: "360926",
            regionName: "铜鼓县",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1348,
            regionCode: "360981",
            regionName: "丰城市",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1349,
            regionCode: "360982",
            regionName: "樟树市",
            parentCode: "360900",
            level: 3,
          },
          {
            id: 1350,
            regionCode: "360983",
            regionName: "高安市",
            parentCode: "360900",
            level: 3,
          },
        ],
      },
      {
        id: 1351,
        regionCode: "361000",
        regionName: "抚州市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1352,
            regionCode: "361002",
            regionName: "临川区",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1353,
            regionCode: "361021",
            regionName: "南城县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1354,
            regionCode: "361022",
            regionName: "黎川县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1355,
            regionCode: "361023",
            regionName: "南丰县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1356,
            regionCode: "361024",
            regionName: "崇仁县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1357,
            regionCode: "361025",
            regionName: "乐安县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1358,
            regionCode: "361026",
            regionName: "宜黄县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1359,
            regionCode: "361027",
            regionName: "金溪县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1360,
            regionCode: "361028",
            regionName: "资溪县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1361,
            regionCode: "361029",
            regionName: "东乡县",
            parentCode: "361000",
            level: 3,
          },
          {
            id: 1362,
            regionCode: "361030",
            regionName: "广昌县",
            parentCode: "361000",
            level: 3,
          },
        ],
      },
      {
        id: 1363,
        regionCode: "361100",
        regionName: "上饶市",
        parentCode: "360000",
        level: 2,
        children: [
          {
            id: 1364,
            regionCode: "361102",
            regionName: "信州区",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1365,
            regionCode: "361121",
            regionName: "上饶县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1366,
            regionCode: "361122",
            regionName: "广丰县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1367,
            regionCode: "361123",
            regionName: "玉山县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1368,
            regionCode: "361124",
            regionName: "铅山县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1369,
            regionCode: "361125",
            regionName: "横峰县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1370,
            regionCode: "361126",
            regionName: "弋阳县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1371,
            regionCode: "361127",
            regionName: "余干县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1372,
            regionCode: "361128",
            regionName: "鄱阳县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1373,
            regionCode: "361129",
            regionName: "万年县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1374,
            regionCode: "361130",
            regionName: "婺源县",
            parentCode: "361100",
            level: 3,
          },
          {
            id: 1375,
            regionCode: "361181",
            regionName: "德兴市",
            parentCode: "361100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1376,
    regionCode: "370000",
    regionName: "山东省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1377,
        regionCode: "370100",
        regionName: "济南市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1378,
            regionCode: "370102",
            regionName: "历下区",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1379,
            regionCode: "370103",
            regionName: "市中区",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1380,
            regionCode: "370104",
            regionName: "槐荫区",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1381,
            regionCode: "370105",
            regionName: "天桥区",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1382,
            regionCode: "370112",
            regionName: "历城区",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1383,
            regionCode: "370113",
            regionName: "长清区",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1384,
            regionCode: "370124",
            regionName: "平阴县",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1385,
            regionCode: "370125",
            regionName: "济阳县",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1386,
            regionCode: "370126",
            regionName: "商河县",
            parentCode: "370100",
            level: 3,
          },
          {
            id: 1387,
            regionCode: "370181",
            regionName: "章丘市",
            parentCode: "370100",
            level: 3,
          },
        ],
      },
      {
        id: 1388,
        regionCode: "370200",
        regionName: "青岛市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1389,
            regionCode: "370202",
            regionName: "市南区",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1390,
            regionCode: "370203",
            regionName: "市北区",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1391,
            regionCode: "370211",
            regionName: "黄岛区",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1392,
            regionCode: "370212",
            regionName: "崂山区",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1393,
            regionCode: "370213",
            regionName: "李沧区",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1394,
            regionCode: "370214",
            regionName: "城阳区",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1395,
            regionCode: "370281",
            regionName: "胶州市",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1396,
            regionCode: "370282",
            regionName: "即墨市",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1397,
            regionCode: "370283",
            regionName: "平度市",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1398,
            regionCode: "370285",
            regionName: "莱西市",
            parentCode: "370200",
            level: 3,
          },
          {
            id: 1399,
            regionCode: "370286",
            regionName: "西海岸新区",
            parentCode: "370200",
            level: 3,
          },
        ],
      },
      {
        id: 1400,
        regionCode: "370300",
        regionName: "淄博市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1401,
            regionCode: "370302",
            regionName: "淄川区",
            parentCode: "370300",
            level: 3,
          },
          {
            id: 1402,
            regionCode: "370303",
            regionName: "张店区",
            parentCode: "370300",
            level: 3,
          },
          {
            id: 1403,
            regionCode: "370304",
            regionName: "博山区",
            parentCode: "370300",
            level: 3,
          },
          {
            id: 1404,
            regionCode: "370305",
            regionName: "临淄区",
            parentCode: "370300",
            level: 3,
          },
          {
            id: 1405,
            regionCode: "370306",
            regionName: "周村区",
            parentCode: "370300",
            level: 3,
          },
          {
            id: 1406,
            regionCode: "370321",
            regionName: "桓台县",
            parentCode: "370300",
            level: 3,
          },
          {
            id: 1407,
            regionCode: "370322",
            regionName: "高青县",
            parentCode: "370300",
            level: 3,
          },
          {
            id: 1408,
            regionCode: "370323",
            regionName: "沂源县",
            parentCode: "370300",
            level: 3,
          },
        ],
      },
      {
        id: 1409,
        regionCode: "370400",
        regionName: "枣庄市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1410,
            regionCode: "370402",
            regionName: "市中区",
            parentCode: "370400",
            level: 3,
          },
          {
            id: 1411,
            regionCode: "370403",
            regionName: "薛城区",
            parentCode: "370400",
            level: 3,
          },
          {
            id: 1412,
            regionCode: "370404",
            regionName: "峄城区",
            parentCode: "370400",
            level: 3,
          },
          {
            id: 1413,
            regionCode: "370405",
            regionName: "台儿庄区",
            parentCode: "370400",
            level: 3,
          },
          {
            id: 1414,
            regionCode: "370406",
            regionName: "山亭区",
            parentCode: "370400",
            level: 3,
          },
          {
            id: 1415,
            regionCode: "370481",
            regionName: "滕州市",
            parentCode: "370400",
            level: 3,
          },
        ],
      },
      {
        id: 1416,
        regionCode: "370500",
        regionName: "东营市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1417,
            regionCode: "370502",
            regionName: "东营区",
            parentCode: "370500",
            level: 3,
          },
          {
            id: 1418,
            regionCode: "370503",
            regionName: "河口区",
            parentCode: "370500",
            level: 3,
          },
          {
            id: 1419,
            regionCode: "370521",
            regionName: "垦利县",
            parentCode: "370500",
            level: 3,
          },
          {
            id: 1420,
            regionCode: "370522",
            regionName: "利津县",
            parentCode: "370500",
            level: 3,
          },
          {
            id: 1421,
            regionCode: "370523",
            regionName: "广饶县",
            parentCode: "370500",
            level: 3,
          },
        ],
      },
      {
        id: 1422,
        regionCode: "370600",
        regionName: "烟台市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1423,
            regionCode: "370602",
            regionName: "芝罘区",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1424,
            regionCode: "370611",
            regionName: "福山区",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1425,
            regionCode: "370612",
            regionName: "牟平区",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1426,
            regionCode: "370613",
            regionName: "莱山区",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1427,
            regionCode: "370634",
            regionName: "长岛县",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1428,
            regionCode: "370681",
            regionName: "龙口市",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1429,
            regionCode: "370682",
            regionName: "莱阳市",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1430,
            regionCode: "370683",
            regionName: "莱州市",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1431,
            regionCode: "370684",
            regionName: "蓬莱市",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1432,
            regionCode: "370685",
            regionName: "招远市",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1433,
            regionCode: "370686",
            regionName: "栖霞市",
            parentCode: "370600",
            level: 3,
          },
          {
            id: 1434,
            regionCode: "370687",
            regionName: "海阳市",
            parentCode: "370600",
            level: 3,
          },
        ],
      },
      {
        id: 1435,
        regionCode: "370700",
        regionName: "潍坊市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1436,
            regionCode: "370702",
            regionName: "潍城区",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1437,
            regionCode: "370703",
            regionName: "寒亭区",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1438,
            regionCode: "370704",
            regionName: "坊子区",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1439,
            regionCode: "370705",
            regionName: "奎文区",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1440,
            regionCode: "370724",
            regionName: "临朐县",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1441,
            regionCode: "370725",
            regionName: "昌乐县",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1442,
            regionCode: "370781",
            regionName: "青州市",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1443,
            regionCode: "370782",
            regionName: "诸城市",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1444,
            regionCode: "370783",
            regionName: "寿光市",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1445,
            regionCode: "370784",
            regionName: "安丘市",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1446,
            regionCode: "370785",
            regionName: "高密市",
            parentCode: "370700",
            level: 3,
          },
          {
            id: 1447,
            regionCode: "370786",
            regionName: "昌邑市",
            parentCode: "370700",
            level: 3,
          },
        ],
      },
      {
        id: 1448,
        regionCode: "370800",
        regionName: "济宁市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1449,
            regionCode: "370811",
            regionName: "任城区",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1450,
            regionCode: "370812",
            regionName: "兖州区",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1451,
            regionCode: "370826",
            regionName: "微山县",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1452,
            regionCode: "370827",
            regionName: "鱼台县",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1453,
            regionCode: "370828",
            regionName: "金乡县",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1454,
            regionCode: "370829",
            regionName: "嘉祥县",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1455,
            regionCode: "370830",
            regionName: "汶上县",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1456,
            regionCode: "370831",
            regionName: "泗水县",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1457,
            regionCode: "370832",
            regionName: "梁山县",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1458,
            regionCode: "370881",
            regionName: "曲阜市",
            parentCode: "370800",
            level: 3,
          },
          {
            id: 1459,
            regionCode: "370883",
            regionName: "邹城市",
            parentCode: "370800",
            level: 3,
          },
        ],
      },
      {
        id: 1460,
        regionCode: "370900",
        regionName: "泰安市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1461,
            regionCode: "370902",
            regionName: "泰山区",
            parentCode: "370900",
            level: 3,
          },
          {
            id: 1462,
            regionCode: "370911",
            regionName: "岱岳区",
            parentCode: "370900",
            level: 3,
          },
          {
            id: 1463,
            regionCode: "370921",
            regionName: "宁阳县",
            parentCode: "370900",
            level: 3,
          },
          {
            id: 1464,
            regionCode: "370923",
            regionName: "东平县",
            parentCode: "370900",
            level: 3,
          },
          {
            id: 1465,
            regionCode: "370982",
            regionName: "新泰市",
            parentCode: "370900",
            level: 3,
          },
          {
            id: 1466,
            regionCode: "370983",
            regionName: "肥城市",
            parentCode: "370900",
            level: 3,
          },
        ],
      },
      {
        id: 1467,
        regionCode: "371000",
        regionName: "威海市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1468,
            regionCode: "371002",
            regionName: "环翠区",
            parentCode: "371000",
            level: 3,
          },
          {
            id: 1469,
            regionCode: "371003",
            regionName: "文登区",
            parentCode: "371000",
            level: 3,
          },
          {
            id: 1470,
            regionCode: "371082",
            regionName: "荣成市",
            parentCode: "371000",
            level: 3,
          },
          {
            id: 1471,
            regionCode: "371083",
            regionName: "乳山市",
            parentCode: "371000",
            level: 3,
          },
        ],
      },
      {
        id: 1472,
        regionCode: "371100",
        regionName: "日照市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1473,
            regionCode: "371102",
            regionName: "东港区",
            parentCode: "371100",
            level: 3,
          },
          {
            id: 1474,
            regionCode: "371103",
            regionName: "岚山区",
            parentCode: "371100",
            level: 3,
          },
          {
            id: 1475,
            regionCode: "371121",
            regionName: "五莲县",
            parentCode: "371100",
            level: 3,
          },
          {
            id: 1476,
            regionCode: "371122",
            regionName: "莒县",
            parentCode: "371100",
            level: 3,
          },
        ],
      },
      {
        id: 1477,
        regionCode: "371200",
        regionName: "莱芜市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1478,
            regionCode: "371202",
            regionName: "莱城区",
            parentCode: "371200",
            level: 3,
          },
          {
            id: 1479,
            regionCode: "371203",
            regionName: "钢城区",
            parentCode: "371200",
            level: 3,
          },
        ],
      },
      {
        id: 1480,
        regionCode: "371300",
        regionName: "临沂市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1481,
            regionCode: "371302",
            regionName: "兰山区",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1482,
            regionCode: "371311",
            regionName: "罗庄区",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1483,
            regionCode: "371312",
            regionName: "河东区",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1484,
            regionCode: "371321",
            regionName: "沂南县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1485,
            regionCode: "371322",
            regionName: "郯城县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1486,
            regionCode: "371323",
            regionName: "沂水县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1487,
            regionCode: "371324",
            regionName: "兰陵县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1488,
            regionCode: "371325",
            regionName: "费县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1489,
            regionCode: "371326",
            regionName: "平邑县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1490,
            regionCode: "371327",
            regionName: "莒南县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1491,
            regionCode: "371328",
            regionName: "蒙阴县",
            parentCode: "371300",
            level: 3,
          },
          {
            id: 1492,
            regionCode: "371329",
            regionName: "临沭县",
            parentCode: "371300",
            level: 3,
          },
        ],
      },
      {
        id: 1493,
        regionCode: "371400",
        regionName: "德州市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1494,
            regionCode: "371402",
            regionName: "德城区",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1495,
            regionCode: "371403",
            regionName: "陵城区",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1496,
            regionCode: "371422",
            regionName: "宁津县",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1497,
            regionCode: "371423",
            regionName: "庆云县",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1498,
            regionCode: "371424",
            regionName: "临邑县",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1499,
            regionCode: "371425",
            regionName: "齐河县",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1500,
            regionCode: "371426",
            regionName: "平原县",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1501,
            regionCode: "371427",
            regionName: "夏津县",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1502,
            regionCode: "371428",
            regionName: "武城县",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1503,
            regionCode: "371481",
            regionName: "乐陵市",
            parentCode: "371400",
            level: 3,
          },
          {
            id: 1504,
            regionCode: "371482",
            regionName: "禹城市",
            parentCode: "371400",
            level: 3,
          },
        ],
      },
      {
        id: 1505,
        regionCode: "371500",
        regionName: "聊城市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1506,
            regionCode: "371502",
            regionName: "东昌府区",
            parentCode: "371500",
            level: 3,
          },
          {
            id: 1507,
            regionCode: "371521",
            regionName: "阳谷县",
            parentCode: "371500",
            level: 3,
          },
          {
            id: 1508,
            regionCode: "371522",
            regionName: "莘县",
            parentCode: "371500",
            level: 3,
          },
          {
            id: 1509,
            regionCode: "371523",
            regionName: "茌平县",
            parentCode: "371500",
            level: 3,
          },
          {
            id: 1510,
            regionCode: "371524",
            regionName: "东阿县",
            parentCode: "371500",
            level: 3,
          },
          {
            id: 1511,
            regionCode: "371525",
            regionName: "冠县",
            parentCode: "371500",
            level: 3,
          },
          {
            id: 1512,
            regionCode: "371526",
            regionName: "高唐县",
            parentCode: "371500",
            level: 3,
          },
          {
            id: 1513,
            regionCode: "371581",
            regionName: "临清市",
            parentCode: "371500",
            level: 3,
          },
        ],
      },
      {
        id: 1514,
        regionCode: "371600",
        regionName: "滨州市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1515,
            regionCode: "371602",
            regionName: "滨城区",
            parentCode: "371600",
            level: 3,
          },
          {
            id: 1516,
            regionCode: "371603",
            regionName: "沾化区",
            parentCode: "371600",
            level: 3,
          },
          {
            id: 1517,
            regionCode: "371621",
            regionName: "惠民县",
            parentCode: "371600",
            level: 3,
          },
          {
            id: 1518,
            regionCode: "371622",
            regionName: "阳信县",
            parentCode: "371600",
            level: 3,
          },
          {
            id: 1519,
            regionCode: "371623",
            regionName: "无棣县",
            parentCode: "371600",
            level: 3,
          },
          {
            id: 1520,
            regionCode: "371625",
            regionName: "博兴县",
            parentCode: "371600",
            level: 3,
          },
          {
            id: 1521,
            regionCode: "371626",
            regionName: "邹平县",
            parentCode: "371600",
            level: 3,
          },
          {
            id: 1522,
            regionCode: "371627",
            regionName: "北海新区",
            parentCode: "371600",
            level: 3,
          },
        ],
      },
      {
        id: 1523,
        regionCode: "371700",
        regionName: "菏泽市",
        parentCode: "370000",
        level: 2,
        children: [
          {
            id: 1524,
            regionCode: "371702",
            regionName: "牡丹区",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1525,
            regionCode: "371721",
            regionName: "曹县",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1526,
            regionCode: "371722",
            regionName: "单县",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1527,
            regionCode: "371723",
            regionName: "成武县",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1528,
            regionCode: "371724",
            regionName: "巨野县",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1529,
            regionCode: "371725",
            regionName: "郓城县",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1530,
            regionCode: "371726",
            regionName: "鄄城县",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1531,
            regionCode: "371727",
            regionName: "定陶县",
            parentCode: "371700",
            level: 3,
          },
          {
            id: 1532,
            regionCode: "371728",
            regionName: "东明县",
            parentCode: "371700",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1533,
    regionCode: "410000",
    regionName: "河南省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1534,
        regionCode: "410100",
        regionName: "郑州市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1535,
            regionCode: "410102",
            regionName: "中原区",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1536,
            regionCode: "410103",
            regionName: "二七区",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1537,
            regionCode: "410104",
            regionName: "管城回族区",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1538,
            regionCode: "410105",
            regionName: "金水区",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1539,
            regionCode: "410106",
            regionName: "上街区",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1540,
            regionCode: "410108",
            regionName: "惠济区",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1541,
            regionCode: "410122",
            regionName: "中牟县",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1542,
            regionCode: "410181",
            regionName: "巩义市",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1543,
            regionCode: "410182",
            regionName: "荥阳市",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1544,
            regionCode: "410183",
            regionName: "新密市",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1545,
            regionCode: "410184",
            regionName: "新郑市",
            parentCode: "410100",
            level: 3,
          },
          {
            id: 1546,
            regionCode: "410185",
            regionName: "登封市",
            parentCode: "410100",
            level: 3,
          },
        ],
      },
      {
        id: 1547,
        regionCode: "410200",
        regionName: "开封市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1548,
            regionCode: "410202",
            regionName: "龙亭区",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1549,
            regionCode: "410203",
            regionName: "顺河回族区",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1550,
            regionCode: "410204",
            regionName: "鼓楼区",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1551,
            regionCode: "410205",
            regionName: "禹王台区",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1552,
            regionCode: "410212",
            regionName: "祥符区",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1553,
            regionCode: "410221",
            regionName: "杞县",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1554,
            regionCode: "410222",
            regionName: "通许县",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1555,
            regionCode: "410223",
            regionName: "尉氏县",
            parentCode: "410200",
            level: 3,
          },
          {
            id: 1556,
            regionCode: "410225",
            regionName: "兰考县",
            parentCode: "410200",
            level: 3,
          },
        ],
      },
      {
        id: 1557,
        regionCode: "410300",
        regionName: "洛阳市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1558,
            regionCode: "410302",
            regionName: "老城区",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1559,
            regionCode: "410303",
            regionName: "西工区",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1560,
            regionCode: "410304",
            regionName: "瀍河回族区",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1561,
            regionCode: "410305",
            regionName: "涧西区",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1562,
            regionCode: "410306",
            regionName: "吉利区",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1563,
            regionCode: "410311",
            regionName: "洛龙区",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1564,
            regionCode: "410322",
            regionName: "孟津县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1565,
            regionCode: "410323",
            regionName: "新安县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1566,
            regionCode: "410324",
            regionName: "栾川县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1567,
            regionCode: "410325",
            regionName: "嵩县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1568,
            regionCode: "410326",
            regionName: "汝阳县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1569,
            regionCode: "410327",
            regionName: "宜阳县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1570,
            regionCode: "410328",
            regionName: "洛宁县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1571,
            regionCode: "410329",
            regionName: "伊川县",
            parentCode: "410300",
            level: 3,
          },
          {
            id: 1572,
            regionCode: "410381",
            regionName: "偃师市",
            parentCode: "410300",
            level: 3,
          },
        ],
      },
      {
        id: 1573,
        regionCode: "410400",
        regionName: "平顶山市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1574,
            regionCode: "410402",
            regionName: "新华区",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1575,
            regionCode: "410403",
            regionName: "卫东区",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1576,
            regionCode: "410404",
            regionName: "石龙区",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1577,
            regionCode: "410411",
            regionName: "湛河区",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1578,
            regionCode: "410421",
            regionName: "宝丰县",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1579,
            regionCode: "410422",
            regionName: "叶县",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1580,
            regionCode: "410423",
            regionName: "鲁山县",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1581,
            regionCode: "410425",
            regionName: "郏县",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1582,
            regionCode: "410481",
            regionName: "舞钢市",
            parentCode: "410400",
            level: 3,
          },
          {
            id: 1583,
            regionCode: "410482",
            regionName: "汝州市",
            parentCode: "410400",
            level: 3,
          },
        ],
      },
      {
        id: 1584,
        regionCode: "410500",
        regionName: "安阳市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1585,
            regionCode: "410502",
            regionName: "文峰区",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1586,
            regionCode: "410503",
            regionName: "北关区",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1587,
            regionCode: "410505",
            regionName: "殷都区",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1588,
            regionCode: "410506",
            regionName: "龙安区",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1589,
            regionCode: "410522",
            regionName: "安阳县",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1590,
            regionCode: "410523",
            regionName: "汤阴县",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1591,
            regionCode: "410526",
            regionName: "滑县",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1592,
            regionCode: "410527",
            regionName: "内黄县",
            parentCode: "410500",
            level: 3,
          },
          {
            id: 1593,
            regionCode: "410581",
            regionName: "林州市",
            parentCode: "410500",
            level: 3,
          },
        ],
      },
      {
        id: 1594,
        regionCode: "410600",
        regionName: "鹤壁市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1595,
            regionCode: "410602",
            regionName: "鹤山区",
            parentCode: "410600",
            level: 3,
          },
          {
            id: 1596,
            regionCode: "410603",
            regionName: "山城区",
            parentCode: "410600",
            level: 3,
          },
          {
            id: 1597,
            regionCode: "410611",
            regionName: "淇滨区",
            parentCode: "410600",
            level: 3,
          },
          {
            id: 1598,
            regionCode: "410621",
            regionName: "浚县",
            parentCode: "410600",
            level: 3,
          },
          {
            id: 1599,
            regionCode: "410622",
            regionName: "淇县",
            parentCode: "410600",
            level: 3,
          },
        ],
      },
      {
        id: 1600,
        regionCode: "410700",
        regionName: "新乡市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1601,
            regionCode: "410702",
            regionName: "红旗区",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1602,
            regionCode: "410703",
            regionName: "卫滨区",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1603,
            regionCode: "410704",
            regionName: "凤泉区",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1604,
            regionCode: "410711",
            regionName: "牧野区",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1605,
            regionCode: "410721",
            regionName: "新乡县",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1606,
            regionCode: "410724",
            regionName: "获嘉县",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1607,
            regionCode: "410725",
            regionName: "原阳县",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1608,
            regionCode: "410726",
            regionName: "延津县",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1609,
            regionCode: "410727",
            regionName: "封丘县",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1610,
            regionCode: "410728",
            regionName: "长垣县",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1611,
            regionCode: "410781",
            regionName: "卫辉市",
            parentCode: "410700",
            level: 3,
          },
          {
            id: 1612,
            regionCode: "410782",
            regionName: "辉县市",
            parentCode: "410700",
            level: 3,
          },
        ],
      },
      {
        id: 1613,
        regionCode: "410800",
        regionName: "焦作市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1614,
            regionCode: "410802",
            regionName: "解放区",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1615,
            regionCode: "410803",
            regionName: "中站区",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1616,
            regionCode: "410804",
            regionName: "马村区",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1617,
            regionCode: "410811",
            regionName: "山阳区",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1618,
            regionCode: "410821",
            regionName: "修武县",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1619,
            regionCode: "410822",
            regionName: "博爱县",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1620,
            regionCode: "410823",
            regionName: "武陟县",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1621,
            regionCode: "410825",
            regionName: "温县",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1622,
            regionCode: "410882",
            regionName: "沁阳市",
            parentCode: "410800",
            level: 3,
          },
          {
            id: 1623,
            regionCode: "410883",
            regionName: "孟州市",
            parentCode: "410800",
            level: 3,
          },
        ],
      },
      {
        id: 1624,
        regionCode: "410900",
        regionName: "濮阳市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1625,
            regionCode: "410902",
            regionName: "华龙区",
            parentCode: "410900",
            level: 3,
          },
          {
            id: 1626,
            regionCode: "410922",
            regionName: "清丰县",
            parentCode: "410900",
            level: 3,
          },
          {
            id: 1627,
            regionCode: "410923",
            regionName: "南乐县",
            parentCode: "410900",
            level: 3,
          },
          {
            id: 1628,
            regionCode: "410926",
            regionName: "范县",
            parentCode: "410900",
            level: 3,
          },
          {
            id: 1629,
            regionCode: "410927",
            regionName: "台前县",
            parentCode: "410900",
            level: 3,
          },
          {
            id: 1630,
            regionCode: "410928",
            regionName: "濮阳县",
            parentCode: "410900",
            level: 3,
          },
        ],
      },
      {
        id: 1631,
        regionCode: "411000",
        regionName: "许昌市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1632,
            regionCode: "411002",
            regionName: "魏都区",
            parentCode: "411000",
            level: 3,
          },
          {
            id: 1633,
            regionCode: "411023",
            regionName: "许昌县",
            parentCode: "411000",
            level: 3,
          },
          {
            id: 1634,
            regionCode: "411024",
            regionName: "鄢陵县",
            parentCode: "411000",
            level: 3,
          },
          {
            id: 1635,
            regionCode: "411025",
            regionName: "襄城县",
            parentCode: "411000",
            level: 3,
          },
          {
            id: 1636,
            regionCode: "411081",
            regionName: "禹州市",
            parentCode: "411000",
            level: 3,
          },
          {
            id: 1637,
            regionCode: "411082",
            regionName: "长葛市",
            parentCode: "411000",
            level: 3,
          },
        ],
      },
      {
        id: 1638,
        regionCode: "411100",
        regionName: "漯河市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1639,
            regionCode: "411102",
            regionName: "源汇区",
            parentCode: "411100",
            level: 3,
          },
          {
            id: 1640,
            regionCode: "411103",
            regionName: "郾城区",
            parentCode: "411100",
            level: 3,
          },
          {
            id: 1641,
            regionCode: "411104",
            regionName: "召陵区",
            parentCode: "411100",
            level: 3,
          },
          {
            id: 1642,
            regionCode: "411121",
            regionName: "舞阳县",
            parentCode: "411100",
            level: 3,
          },
          {
            id: 1643,
            regionCode: "411122",
            regionName: "临颍县",
            parentCode: "411100",
            level: 3,
          },
        ],
      },
      {
        id: 1644,
        regionCode: "411200",
        regionName: "三门峡市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1645,
            regionCode: "411202",
            regionName: "湖滨区",
            parentCode: "411200",
            level: 3,
          },
          {
            id: 1646,
            regionCode: "411221",
            regionName: "渑池县",
            parentCode: "411200",
            level: 3,
          },
          {
            id: 1647,
            regionCode: "411222",
            regionName: "陕县",
            parentCode: "411200",
            level: 3,
          },
          {
            id: 1648,
            regionCode: "411224",
            regionName: "卢氏县",
            parentCode: "411200",
            level: 3,
          },
          {
            id: 1649,
            regionCode: "411281",
            regionName: "义马市",
            parentCode: "411200",
            level: 3,
          },
          {
            id: 1650,
            regionCode: "411282",
            regionName: "灵宝市",
            parentCode: "411200",
            level: 3,
          },
        ],
      },
      {
        id: 1651,
        regionCode: "411300",
        regionName: "南阳市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1652,
            regionCode: "411302",
            regionName: "宛城区",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1653,
            regionCode: "411303",
            regionName: "卧龙区",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1654,
            regionCode: "411321",
            regionName: "南召县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1655,
            regionCode: "411322",
            regionName: "方城县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1656,
            regionCode: "411323",
            regionName: "西峡县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1657,
            regionCode: "411324",
            regionName: "镇平县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1658,
            regionCode: "411325",
            regionName: "内乡县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1659,
            regionCode: "411326",
            regionName: "淅川县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1660,
            regionCode: "411327",
            regionName: "社旗县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1661,
            regionCode: "411328",
            regionName: "唐河县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1662,
            regionCode: "411329",
            regionName: "新野县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1663,
            regionCode: "411330",
            regionName: "桐柏县",
            parentCode: "411300",
            level: 3,
          },
          {
            id: 1664,
            regionCode: "411381",
            regionName: "邓州市",
            parentCode: "411300",
            level: 3,
          },
        ],
      },
      {
        id: 1665,
        regionCode: "411400",
        regionName: "商丘市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1666,
            regionCode: "411402",
            regionName: "梁园区",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1667,
            regionCode: "411403",
            regionName: "睢阳区",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1668,
            regionCode: "411421",
            regionName: "民权县",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1669,
            regionCode: "411422",
            regionName: "睢县",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1670,
            regionCode: "411423",
            regionName: "宁陵县",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1671,
            regionCode: "411424",
            regionName: "柘城县",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1672,
            regionCode: "411425",
            regionName: "虞城县",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1673,
            regionCode: "411426",
            regionName: "夏邑县",
            parentCode: "411400",
            level: 3,
          },
          {
            id: 1674,
            regionCode: "411481",
            regionName: "永城市",
            parentCode: "411400",
            level: 3,
          },
        ],
      },
      {
        id: 1675,
        regionCode: "411500",
        regionName: "信阳市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1676,
            regionCode: "411502",
            regionName: "浉河区",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1677,
            regionCode: "411503",
            regionName: "平桥区",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1678,
            regionCode: "411521",
            regionName: "罗山县",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1679,
            regionCode: "411522",
            regionName: "光山县",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1680,
            regionCode: "411523",
            regionName: "新县",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1681,
            regionCode: "411524",
            regionName: "商城县",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1682,
            regionCode: "411525",
            regionName: "固始县",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1683,
            regionCode: "411526",
            regionName: "潢川县",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1684,
            regionCode: "411527",
            regionName: "淮滨县",
            parentCode: "411500",
            level: 3,
          },
          {
            id: 1685,
            regionCode: "411528",
            regionName: "息县",
            parentCode: "411500",
            level: 3,
          },
        ],
      },
      {
        id: 1686,
        regionCode: "411600",
        regionName: "周口市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1687,
            regionCode: "411602",
            regionName: "川汇区",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1688,
            regionCode: "411621",
            regionName: "扶沟县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1689,
            regionCode: "411622",
            regionName: "西华县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1690,
            regionCode: "411623",
            regionName: "商水县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1691,
            regionCode: "411624",
            regionName: "沈丘县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1692,
            regionCode: "411625",
            regionName: "郸城县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1693,
            regionCode: "411626",
            regionName: "淮阳县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1694,
            regionCode: "411627",
            regionName: "太康县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1695,
            regionCode: "411628",
            regionName: "鹿邑县",
            parentCode: "411600",
            level: 3,
          },
          {
            id: 1696,
            regionCode: "411681",
            regionName: "项城市",
            parentCode: "411600",
            level: 3,
          },
        ],
      },
      {
        id: 1697,
        regionCode: "411700",
        regionName: "驻马店市",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1698,
            regionCode: "411702",
            regionName: "驿城区",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1699,
            regionCode: "411721",
            regionName: "西平县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1700,
            regionCode: "411722",
            regionName: "上蔡县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1701,
            regionCode: "411723",
            regionName: "平舆县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1702,
            regionCode: "411724",
            regionName: "正阳县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1703,
            regionCode: "411725",
            regionName: "确山县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1704,
            regionCode: "411726",
            regionName: "泌阳县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1705,
            regionCode: "411727",
            regionName: "汝南县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1706,
            regionCode: "411728",
            regionName: "遂平县",
            parentCode: "411700",
            level: 3,
          },
          {
            id: 1707,
            regionCode: "411729",
            regionName: "新蔡县",
            parentCode: "411700",
            level: 3,
          },
        ],
      },
      {
        id: 1708,
        regionCode: "419000",
        regionName: "直辖县级",
        parentCode: "410000",
        level: 2,
        children: [
          {
            id: 1709,
            regionCode: "419001",
            regionName: "济源市",
            parentCode: "419000",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1710,
    regionCode: "420000",
    regionName: "湖北省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1711,
        regionCode: "420100",
        regionName: "武汉市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1712,
            regionCode: "420102",
            regionName: "江岸区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1713,
            regionCode: "420103",
            regionName: "江汉区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1714,
            regionCode: "420104",
            regionName: "硚口区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1715,
            regionCode: "420105",
            regionName: "汉阳区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1716,
            regionCode: "420106",
            regionName: "武昌区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1717,
            regionCode: "420107",
            regionName: "青山区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1718,
            regionCode: "420111",
            regionName: "洪山区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1719,
            regionCode: "420112",
            regionName: "东西湖区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1720,
            regionCode: "420113",
            regionName: "汉南区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1721,
            regionCode: "420114",
            regionName: "蔡甸区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1722,
            regionCode: "420115",
            regionName: "江夏区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1723,
            regionCode: "420116",
            regionName: "黄陂区",
            parentCode: "420100",
            level: 3,
          },
          {
            id: 1724,
            regionCode: "420117",
            regionName: "新洲区",
            parentCode: "420100",
            level: 3,
          },
        ],
      },
      {
        id: 1725,
        regionCode: "420200",
        regionName: "黄石市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1726,
            regionCode: "420202",
            regionName: "黄石港区",
            parentCode: "420200",
            level: 3,
          },
          {
            id: 1727,
            regionCode: "420203",
            regionName: "西塞山区",
            parentCode: "420200",
            level: 3,
          },
          {
            id: 1728,
            regionCode: "420204",
            regionName: "下陆区",
            parentCode: "420200",
            level: 3,
          },
          {
            id: 1729,
            regionCode: "420205",
            regionName: "铁山区",
            parentCode: "420200",
            level: 3,
          },
          {
            id: 1730,
            regionCode: "420222",
            regionName: "阳新县",
            parentCode: "420200",
            level: 3,
          },
          {
            id: 1731,
            regionCode: "420281",
            regionName: "大冶市",
            parentCode: "420200",
            level: 3,
          },
        ],
      },
      {
        id: 1732,
        regionCode: "420300",
        regionName: "十堰市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1733,
            regionCode: "420302",
            regionName: "茅箭区",
            parentCode: "420300",
            level: 3,
          },
          {
            id: 1734,
            regionCode: "420303",
            regionName: "张湾区",
            parentCode: "420300",
            level: 3,
          },
          {
            id: 1735,
            regionCode: "420304",
            regionName: "郧阳区",
            parentCode: "420300",
            level: 3,
          },
          {
            id: 1736,
            regionCode: "420322",
            regionName: "郧西县",
            parentCode: "420300",
            level: 3,
          },
          {
            id: 1737,
            regionCode: "420323",
            regionName: "竹山县",
            parentCode: "420300",
            level: 3,
          },
          {
            id: 1738,
            regionCode: "420324",
            regionName: "竹溪县",
            parentCode: "420300",
            level: 3,
          },
          {
            id: 1739,
            regionCode: "420325",
            regionName: "房县",
            parentCode: "420300",
            level: 3,
          },
          {
            id: 1740,
            regionCode: "420381",
            regionName: "丹江口市",
            parentCode: "420300",
            level: 3,
          },
        ],
      },
      {
        id: 1741,
        regionCode: "420500",
        regionName: "宜昌市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1742,
            regionCode: "420502",
            regionName: "西陵区",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1743,
            regionCode: "420503",
            regionName: "伍家岗区",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1744,
            regionCode: "420504",
            regionName: "点军区",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1745,
            regionCode: "420505",
            regionName: "猇亭区",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1746,
            regionCode: "420506",
            regionName: "夷陵区",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1747,
            regionCode: "420525",
            regionName: "远安县",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1748,
            regionCode: "420526",
            regionName: "兴山县",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1749,
            regionCode: "420527",
            regionName: "秭归县",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1750,
            regionCode: "420528",
            regionName: "长阳土家族自治县",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1751,
            regionCode: "420529",
            regionName: "五峰土家族自治县",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1752,
            regionCode: "420581",
            regionName: "宜都市",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1753,
            regionCode: "420582",
            regionName: "当阳市",
            parentCode: "420500",
            level: 3,
          },
          {
            id: 1754,
            regionCode: "420583",
            regionName: "枝江市",
            parentCode: "420500",
            level: 3,
          },
        ],
      },
      {
        id: 1755,
        regionCode: "420600",
        regionName: "襄阳市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1756,
            regionCode: "420602",
            regionName: "襄城区",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1757,
            regionCode: "420606",
            regionName: "樊城区",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1758,
            regionCode: "420607",
            regionName: "襄州区",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1759,
            regionCode: "420624",
            regionName: "南漳县",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1760,
            regionCode: "420625",
            regionName: "谷城县",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1761,
            regionCode: "420626",
            regionName: "保康县",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1762,
            regionCode: "420682",
            regionName: "老河口市",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1763,
            regionCode: "420683",
            regionName: "枣阳市",
            parentCode: "420600",
            level: 3,
          },
          {
            id: 1764,
            regionCode: "420684",
            regionName: "宜城市",
            parentCode: "420600",
            level: 3,
          },
        ],
      },
      {
        id: 1765,
        regionCode: "420700",
        regionName: "鄂州市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1766,
            regionCode: "420702",
            regionName: "梁子湖区",
            parentCode: "420700",
            level: 3,
          },
          {
            id: 1767,
            regionCode: "420703",
            regionName: "华容区",
            parentCode: "420700",
            level: 3,
          },
          {
            id: 1768,
            regionCode: "420704",
            regionName: "鄂城区",
            parentCode: "420700",
            level: 3,
          },
        ],
      },
      {
        id: 1769,
        regionCode: "420800",
        regionName: "荆门市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1770,
            regionCode: "420802",
            regionName: "东宝区",
            parentCode: "420800",
            level: 3,
          },
          {
            id: 1771,
            regionCode: "420804",
            regionName: "掇刀区",
            parentCode: "420800",
            level: 3,
          },
          {
            id: 1772,
            regionCode: "420821",
            regionName: "京山县",
            parentCode: "420800",
            level: 3,
          },
          {
            id: 1773,
            regionCode: "420822",
            regionName: "沙洋县",
            parentCode: "420800",
            level: 3,
          },
          {
            id: 1774,
            regionCode: "420881",
            regionName: "钟祥市",
            parentCode: "420800",
            level: 3,
          },
        ],
      },
      {
        id: 1775,
        regionCode: "420900",
        regionName: "孝感市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1776,
            regionCode: "420902",
            regionName: "孝南区",
            parentCode: "420900",
            level: 3,
          },
          {
            id: 1777,
            regionCode: "420921",
            regionName: "孝昌县",
            parentCode: "420900",
            level: 3,
          },
          {
            id: 1778,
            regionCode: "420922",
            regionName: "大悟县",
            parentCode: "420900",
            level: 3,
          },
          {
            id: 1779,
            regionCode: "420923",
            regionName: "云梦县",
            parentCode: "420900",
            level: 3,
          },
          {
            id: 1780,
            regionCode: "420981",
            regionName: "应城市",
            parentCode: "420900",
            level: 3,
          },
          {
            id: 1781,
            regionCode: "420982",
            regionName: "安陆市",
            parentCode: "420900",
            level: 3,
          },
          {
            id: 1782,
            regionCode: "420984",
            regionName: "汉川市",
            parentCode: "420900",
            level: 3,
          },
        ],
      },
      {
        id: 1783,
        regionCode: "421000",
        regionName: "荆州市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1784,
            regionCode: "421002",
            regionName: "沙市区",
            parentCode: "421000",
            level: 3,
          },
          {
            id: 1785,
            regionCode: "421003",
            regionName: "荆州区",
            parentCode: "421000",
            level: 3,
          },
          {
            id: 1786,
            regionCode: "421022",
            regionName: "公安县",
            parentCode: "421000",
            level: 3,
          },
          {
            id: 1787,
            regionCode: "421023",
            regionName: "监利县",
            parentCode: "421000",
            level: 3,
          },
          {
            id: 1788,
            regionCode: "421024",
            regionName: "江陵县",
            parentCode: "421000",
            level: 3,
          },
          {
            id: 1789,
            regionCode: "421081",
            regionName: "石首市",
            parentCode: "421000",
            level: 3,
          },
          {
            id: 1790,
            regionCode: "421083",
            regionName: "洪湖市",
            parentCode: "421000",
            level: 3,
          },
          {
            id: 1791,
            regionCode: "421087",
            regionName: "松滋市",
            parentCode: "421000",
            level: 3,
          },
        ],
      },
      {
        id: 1792,
        regionCode: "421100",
        regionName: "黄冈市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1793,
            regionCode: "421102",
            regionName: "黄州区",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1794,
            regionCode: "421121",
            regionName: "团风县",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1795,
            regionCode: "421122",
            regionName: "红安县",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1796,
            regionCode: "421123",
            regionName: "罗田县",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1797,
            regionCode: "421124",
            regionName: "英山县",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1798,
            regionCode: "421125",
            regionName: "浠水县",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1799,
            regionCode: "421126",
            regionName: "蕲春县",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1800,
            regionCode: "421127",
            regionName: "黄梅县",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1801,
            regionCode: "421181",
            regionName: "麻城市",
            parentCode: "421100",
            level: 3,
          },
          {
            id: 1802,
            regionCode: "421182",
            regionName: "武穴市",
            parentCode: "421100",
            level: 3,
          },
        ],
      },
      {
        id: 1803,
        regionCode: "421200",
        regionName: "咸宁市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1804,
            regionCode: "421202",
            regionName: "咸安区",
            parentCode: "421200",
            level: 3,
          },
          {
            id: 1805,
            regionCode: "421221",
            regionName: "嘉鱼县",
            parentCode: "421200",
            level: 3,
          },
          {
            id: 1806,
            regionCode: "421222",
            regionName: "通城县",
            parentCode: "421200",
            level: 3,
          },
          {
            id: 1807,
            regionCode: "421223",
            regionName: "崇阳县",
            parentCode: "421200",
            level: 3,
          },
          {
            id: 1808,
            regionCode: "421224",
            regionName: "通山县",
            parentCode: "421200",
            level: 3,
          },
          {
            id: 1809,
            regionCode: "421281",
            regionName: "赤壁市",
            parentCode: "421200",
            level: 3,
          },
        ],
      },
      {
        id: 1810,
        regionCode: "421300",
        regionName: "随州市",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1811,
            regionCode: "421303",
            regionName: "曾都区",
            parentCode: "421300",
            level: 3,
          },
          {
            id: 1812,
            regionCode: "421321",
            regionName: "随县",
            parentCode: "421300",
            level: 3,
          },
          {
            id: 1813,
            regionCode: "421381",
            regionName: "广水市",
            parentCode: "421300",
            level: 3,
          },
        ],
      },
      {
        id: 1814,
        regionCode: "422800",
        regionName: "恩施土家族苗族自治州",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1815,
            regionCode: "422801",
            regionName: "恩施市",
            parentCode: "422800",
            level: 3,
          },
          {
            id: 1816,
            regionCode: "422802",
            regionName: "利川市",
            parentCode: "422800",
            level: 3,
          },
          {
            id: 1817,
            regionCode: "422822",
            regionName: "建始县",
            parentCode: "422800",
            level: 3,
          },
          {
            id: 1818,
            regionCode: "422823",
            regionName: "巴东县",
            parentCode: "422800",
            level: 3,
          },
          {
            id: 1819,
            regionCode: "422825",
            regionName: "宣恩县",
            parentCode: "422800",
            level: 3,
          },
          {
            id: 1820,
            regionCode: "422826",
            regionName: "咸丰县",
            parentCode: "422800",
            level: 3,
          },
          {
            id: 1821,
            regionCode: "422827",
            regionName: "来凤县",
            parentCode: "422800",
            level: 3,
          },
          {
            id: 1822,
            regionCode: "422828",
            regionName: "鹤峰县",
            parentCode: "422800",
            level: 3,
          },
        ],
      },
      {
        id: 1823,
        regionCode: "429000",
        regionName: "直辖县级",
        parentCode: "420000",
        level: 2,
        children: [
          {
            id: 1824,
            regionCode: "429004",
            regionName: "仙桃市",
            parentCode: "429000",
            level: 3,
          },
          {
            id: 1825,
            regionCode: "429005",
            regionName: "潜江市",
            parentCode: "429000",
            level: 3,
          },
          {
            id: 1826,
            regionCode: "429006",
            regionName: "天门市",
            parentCode: "429000",
            level: 3,
          },
          {
            id: 1827,
            regionCode: "429021",
            regionName: "神农架林区",
            parentCode: "429000",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1828,
    regionCode: "430000",
    regionName: "湖南省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1829,
        regionCode: "430100",
        regionName: "长沙市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1830,
            regionCode: "430102",
            regionName: "芙蓉区",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1831,
            regionCode: "430103",
            regionName: "天心区",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1832,
            regionCode: "430104",
            regionName: "岳麓区",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1833,
            regionCode: "430105",
            regionName: "开福区",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1834,
            regionCode: "430111",
            regionName: "雨花区",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1835,
            regionCode: "430112",
            regionName: "望城区",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1836,
            regionCode: "430121",
            regionName: "长沙县",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1837,
            regionCode: "430124",
            regionName: "宁乡县",
            parentCode: "430100",
            level: 3,
          },
          {
            id: 1838,
            regionCode: "430181",
            regionName: "浏阳市",
            parentCode: "430100",
            level: 3,
          },
        ],
      },
      {
        id: 1839,
        regionCode: "430200",
        regionName: "株洲市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1840,
            regionCode: "430202",
            regionName: "荷塘区",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1841,
            regionCode: "430203",
            regionName: "芦淞区",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1842,
            regionCode: "430204",
            regionName: "石峰区",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1843,
            regionCode: "430211",
            regionName: "天元区",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1844,
            regionCode: "430221",
            regionName: "株洲县",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1845,
            regionCode: "430223",
            regionName: "攸县",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1846,
            regionCode: "430224",
            regionName: "茶陵县",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1847,
            regionCode: "430225",
            regionName: "炎陵县",
            parentCode: "430200",
            level: 3,
          },
          {
            id: 1848,
            regionCode: "430281",
            regionName: "醴陵市",
            parentCode: "430200",
            level: 3,
          },
        ],
      },
      {
        id: 1849,
        regionCode: "430300",
        regionName: "湘潭市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1850,
            regionCode: "430302",
            regionName: "雨湖区",
            parentCode: "430300",
            level: 3,
          },
          {
            id: 1851,
            regionCode: "430304",
            regionName: "岳塘区",
            parentCode: "430300",
            level: 3,
          },
          {
            id: 1852,
            regionCode: "430321",
            regionName: "湘潭县",
            parentCode: "430300",
            level: 3,
          },
          {
            id: 1853,
            regionCode: "430381",
            regionName: "湘乡市",
            parentCode: "430300",
            level: 3,
          },
          {
            id: 1854,
            regionCode: "430382",
            regionName: "韶山市",
            parentCode: "430300",
            level: 3,
          },
        ],
      },
      {
        id: 1855,
        regionCode: "430400",
        regionName: "衡阳市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1856,
            regionCode: "430405",
            regionName: "珠晖区",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1857,
            regionCode: "430406",
            regionName: "雁峰区",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1858,
            regionCode: "430407",
            regionName: "石鼓区",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1859,
            regionCode: "430408",
            regionName: "蒸湘区",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1860,
            regionCode: "430412",
            regionName: "南岳区",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1861,
            regionCode: "430421",
            regionName: "衡阳县",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1862,
            regionCode: "430422",
            regionName: "衡南县",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1863,
            regionCode: "430423",
            regionName: "衡山县",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1864,
            regionCode: "430424",
            regionName: "衡东县",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1865,
            regionCode: "430426",
            regionName: "祁东县",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1866,
            regionCode: "430481",
            regionName: "耒阳市",
            parentCode: "430400",
            level: 3,
          },
          {
            id: 1867,
            regionCode: "430482",
            regionName: "常宁市",
            parentCode: "430400",
            level: 3,
          },
        ],
      },
      {
        id: 1868,
        regionCode: "430500",
        regionName: "邵阳市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1869,
            regionCode: "430502",
            regionName: "双清区",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1870,
            regionCode: "430503",
            regionName: "大祥区",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1871,
            regionCode: "430511",
            regionName: "北塔区",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1872,
            regionCode: "430521",
            regionName: "邵东县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1873,
            regionCode: "430522",
            regionName: "新邵县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1874,
            regionCode: "430523",
            regionName: "邵阳县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1875,
            regionCode: "430524",
            regionName: "隆回县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1876,
            regionCode: "430525",
            regionName: "洞口县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1877,
            regionCode: "430527",
            regionName: "绥宁县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1878,
            regionCode: "430528",
            regionName: "新宁县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1879,
            regionCode: "430529",
            regionName: "城步苗族自治县",
            parentCode: "430500",
            level: 3,
          },
          {
            id: 1880,
            regionCode: "430581",
            regionName: "武冈市",
            parentCode: "430500",
            level: 3,
          },
        ],
      },
      {
        id: 1881,
        regionCode: "430600",
        regionName: "岳阳市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1882,
            regionCode: "430602",
            regionName: "岳阳楼区",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1883,
            regionCode: "430603",
            regionName: "云溪区",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1884,
            regionCode: "430611",
            regionName: "君山区",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1885,
            regionCode: "430621",
            regionName: "岳阳县",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1886,
            regionCode: "430623",
            regionName: "华容县",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1887,
            regionCode: "430624",
            regionName: "湘阴县",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1888,
            regionCode: "430626",
            regionName: "平江县",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1889,
            regionCode: "430681",
            regionName: "汨罗市",
            parentCode: "430600",
            level: 3,
          },
          {
            id: 1890,
            regionCode: "430682",
            regionName: "临湘市",
            parentCode: "430600",
            level: 3,
          },
        ],
      },
      {
        id: 1891,
        regionCode: "430700",
        regionName: "常德市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1892,
            regionCode: "430702",
            regionName: "武陵区",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1893,
            regionCode: "430703",
            regionName: "鼎城区",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1894,
            regionCode: "430721",
            regionName: "安乡县",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1895,
            regionCode: "430722",
            regionName: "汉寿县",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1896,
            regionCode: "430723",
            regionName: "澧县",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1897,
            regionCode: "430724",
            regionName: "临澧县",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1898,
            regionCode: "430725",
            regionName: "桃源县",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1899,
            regionCode: "430726",
            regionName: "石门县",
            parentCode: "430700",
            level: 3,
          },
          {
            id: 1900,
            regionCode: "430781",
            regionName: "津市市",
            parentCode: "430700",
            level: 3,
          },
        ],
      },
      {
        id: 1901,
        regionCode: "430800",
        regionName: "张家界市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1902,
            regionCode: "430802",
            regionName: "永定区",
            parentCode: "430800",
            level: 3,
          },
          {
            id: 1903,
            regionCode: "430811",
            regionName: "武陵源区",
            parentCode: "430800",
            level: 3,
          },
          {
            id: 1904,
            regionCode: "430821",
            regionName: "慈利县",
            parentCode: "430800",
            level: 3,
          },
          {
            id: 1905,
            regionCode: "430822",
            regionName: "桑植县",
            parentCode: "430800",
            level: 3,
          },
        ],
      },
      {
        id: 1906,
        regionCode: "430900",
        regionName: "益阳市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1907,
            regionCode: "430902",
            regionName: "资阳区",
            parentCode: "430900",
            level: 3,
          },
          {
            id: 1908,
            regionCode: "430903",
            regionName: "赫山区",
            parentCode: "430900",
            level: 3,
          },
          {
            id: 1909,
            regionCode: "430921",
            regionName: "南县",
            parentCode: "430900",
            level: 3,
          },
          {
            id: 1910,
            regionCode: "430922",
            regionName: "桃江县",
            parentCode: "430900",
            level: 3,
          },
          {
            id: 1911,
            regionCode: "430923",
            regionName: "安化县",
            parentCode: "430900",
            level: 3,
          },
          {
            id: 1912,
            regionCode: "430981",
            regionName: "沅江市",
            parentCode: "430900",
            level: 3,
          },
        ],
      },
      {
        id: 1913,
        regionCode: "431000",
        regionName: "郴州市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1914,
            regionCode: "431002",
            regionName: "北湖区",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1915,
            regionCode: "431003",
            regionName: "苏仙区",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1916,
            regionCode: "431021",
            regionName: "桂阳县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1917,
            regionCode: "431022",
            regionName: "宜章县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1918,
            regionCode: "431023",
            regionName: "永兴县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1919,
            regionCode: "431024",
            regionName: "嘉禾县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1920,
            regionCode: "431025",
            regionName: "临武县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1921,
            regionCode: "431026",
            regionName: "汝城县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1922,
            regionCode: "431027",
            regionName: "桂东县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1923,
            regionCode: "431028",
            regionName: "安仁县",
            parentCode: "431000",
            level: 3,
          },
          {
            id: 1924,
            regionCode: "431081",
            regionName: "资兴市",
            parentCode: "431000",
            level: 3,
          },
        ],
      },
      {
        id: 1925,
        regionCode: "431100",
        regionName: "永州市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1926,
            regionCode: "431102",
            regionName: "零陵区",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1927,
            regionCode: "431103",
            regionName: "冷水滩区",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1928,
            regionCode: "431121",
            regionName: "祁阳县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1929,
            regionCode: "431122",
            regionName: "东安县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1930,
            regionCode: "431123",
            regionName: "双牌县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1931,
            regionCode: "431124",
            regionName: "道县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1932,
            regionCode: "431125",
            regionName: "江永县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1933,
            regionCode: "431126",
            regionName: "宁远县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1934,
            regionCode: "431127",
            regionName: "蓝山县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1935,
            regionCode: "431128",
            regionName: "新田县",
            parentCode: "431100",
            level: 3,
          },
          {
            id: 1936,
            regionCode: "431129",
            regionName: "江华瑶族自治县",
            parentCode: "431100",
            level: 3,
          },
        ],
      },
      {
        id: 1937,
        regionCode: "431200",
        regionName: "怀化市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1938,
            regionCode: "431202",
            regionName: "鹤城区",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1939,
            regionCode: "431221",
            regionName: "中方县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1940,
            regionCode: "431222",
            regionName: "沅陵县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1941,
            regionCode: "431223",
            regionName: "辰溪县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1942,
            regionCode: "431224",
            regionName: "溆浦县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1943,
            regionCode: "431225",
            regionName: "会同县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1944,
            regionCode: "431226",
            regionName: "麻阳苗族自治县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1945,
            regionCode: "431227",
            regionName: "新晃侗族自治县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1946,
            regionCode: "431228",
            regionName: "芷江侗族自治县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1947,
            regionCode: "431229",
            regionName: "靖州苗族侗族自治县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1948,
            regionCode: "431230",
            regionName: "通道侗族自治县",
            parentCode: "431200",
            level: 3,
          },
          {
            id: 1949,
            regionCode: "431281",
            regionName: "洪江市",
            parentCode: "431200",
            level: 3,
          },
        ],
      },
      {
        id: 1950,
        regionCode: "431300",
        regionName: "娄底市",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1951,
            regionCode: "431302",
            regionName: "娄星区",
            parentCode: "431300",
            level: 3,
          },
          {
            id: 1952,
            regionCode: "431321",
            regionName: "双峰县",
            parentCode: "431300",
            level: 3,
          },
          {
            id: 1953,
            regionCode: "431322",
            regionName: "新化县",
            parentCode: "431300",
            level: 3,
          },
          {
            id: 1954,
            regionCode: "431381",
            regionName: "冷水江市",
            parentCode: "431300",
            level: 3,
          },
          {
            id: 1955,
            regionCode: "431382",
            regionName: "涟源市",
            parentCode: "431300",
            level: 3,
          },
        ],
      },
      {
        id: 1956,
        regionCode: "433100",
        regionName: "湘西土家族苗族自治州",
        parentCode: "430000",
        level: 2,
        children: [
          {
            id: 1957,
            regionCode: "433101",
            regionName: "吉首市",
            parentCode: "433100",
            level: 3,
          },
          {
            id: 1958,
            regionCode: "433122",
            regionName: "泸溪县",
            parentCode: "433100",
            level: 3,
          },
          {
            id: 1959,
            regionCode: "433123",
            regionName: "凤凰县",
            parentCode: "433100",
            level: 3,
          },
          {
            id: 1960,
            regionCode: "433124",
            regionName: "花垣县",
            parentCode: "433100",
            level: 3,
          },
          {
            id: 1961,
            regionCode: "433125",
            regionName: "保靖县",
            parentCode: "433100",
            level: 3,
          },
          {
            id: 1962,
            regionCode: "433126",
            regionName: "古丈县",
            parentCode: "433100",
            level: 3,
          },
          {
            id: 1963,
            regionCode: "433127",
            regionName: "永顺县",
            parentCode: "433100",
            level: 3,
          },
          {
            id: 1964,
            regionCode: "433130",
            regionName: "龙山县",
            parentCode: "433100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 1965,
    regionCode: "440000",
    regionName: "广东省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 1966,
        regionCode: "440100",
        regionName: "广州市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 1967,
            regionCode: "440103",
            regionName: "荔湾区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1968,
            regionCode: "440104",
            regionName: "越秀区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1969,
            regionCode: "440105",
            regionName: "海珠区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1970,
            regionCode: "440106",
            regionName: "天河区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1971,
            regionCode: "440111",
            regionName: "白云区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1972,
            regionCode: "440112",
            regionName: "黄埔区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1973,
            regionCode: "440113",
            regionName: "番禺区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1974,
            regionCode: "440114",
            regionName: "花都区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1975,
            regionCode: "440115",
            regionName: "南沙区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1976,
            regionCode: "440117",
            regionName: "从化区",
            parentCode: "440100",
            level: 3,
          },
          {
            id: 1977,
            regionCode: "440118",
            regionName: "增城区",
            parentCode: "440100",
            level: 3,
          },
        ],
      },
      {
        id: 1978,
        regionCode: "440200",
        regionName: "韶关市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 1979,
            regionCode: "440203",
            regionName: "武江区",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1980,
            regionCode: "440204",
            regionName: "浈江区",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1981,
            regionCode: "440205",
            regionName: "曲江区",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1982,
            regionCode: "440222",
            regionName: "始兴县",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1983,
            regionCode: "440224",
            regionName: "仁化县",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1984,
            regionCode: "440229",
            regionName: "翁源县",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1985,
            regionCode: "440232",
            regionName: "乳源瑶族自治县",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1986,
            regionCode: "440233",
            regionName: "新丰县",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1987,
            regionCode: "440281",
            regionName: "乐昌市",
            parentCode: "440200",
            level: 3,
          },
          {
            id: 1988,
            regionCode: "440282",
            regionName: "南雄市",
            parentCode: "440200",
            level: 3,
          },
        ],
      },
      {
        id: 1989,
        regionCode: "440300",
        regionName: "深圳市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 1990,
            regionCode: "440303",
            regionName: "罗湖区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1991,
            regionCode: "440304",
            regionName: "福田区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1992,
            regionCode: "440305",
            regionName: "南山区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1993,
            regionCode: "440306",
            regionName: "宝安区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1994,
            regionCode: "440307",
            regionName: "龙岗区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1995,
            regionCode: "440308",
            regionName: "盐田区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1996,
            regionCode: "440309",
            regionName: "光明新区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1997,
            regionCode: "440310",
            regionName: "坪山新区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1998,
            regionCode: "440311",
            regionName: "大鹏新区",
            parentCode: "440300",
            level: 3,
          },
          {
            id: 1999,
            regionCode: "440312",
            regionName: "龙华新区",
            parentCode: "440300",
            level: 3,
          },
        ],
      },
      {
        id: 2000,
        regionCode: "440400",
        regionName: "珠海市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2001,
            regionCode: "440402",
            regionName: "香洲区",
            parentCode: "440400",
            level: 3,
          },
          {
            id: 2002,
            regionCode: "440403",
            regionName: "斗门区",
            parentCode: "440400",
            level: 3,
          },
          {
            id: 2003,
            regionCode: "440404",
            regionName: "金湾区",
            parentCode: "440400",
            level: 3,
          },
        ],
      },
      {
        id: 2004,
        regionCode: "440500",
        regionName: "汕头市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2005,
            regionCode: "440507",
            regionName: "龙湖区",
            parentCode: "440500",
            level: 3,
          },
          {
            id: 2006,
            regionCode: "440511",
            regionName: "金平区",
            parentCode: "440500",
            level: 3,
          },
          {
            id: 2007,
            regionCode: "440512",
            regionName: "濠江区",
            parentCode: "440500",
            level: 3,
          },
          {
            id: 2008,
            regionCode: "440513",
            regionName: "潮阳区",
            parentCode: "440500",
            level: 3,
          },
          {
            id: 2009,
            regionCode: "440514",
            regionName: "潮南区",
            parentCode: "440500",
            level: 3,
          },
          {
            id: 2010,
            regionCode: "440515",
            regionName: "澄海区",
            parentCode: "440500",
            level: 3,
          },
          {
            id: 2011,
            regionCode: "440523",
            regionName: "南澳县",
            parentCode: "440500",
            level: 3,
          },
        ],
      },
      {
        id: 2012,
        regionCode: "440600",
        regionName: "佛山市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2013,
            regionCode: "440604",
            regionName: "禅城区",
            parentCode: "440600",
            level: 3,
          },
          {
            id: 2014,
            regionCode: "440605",
            regionName: "南海区",
            parentCode: "440600",
            level: 3,
          },
          {
            id: 2015,
            regionCode: "440606",
            regionName: "顺德区",
            parentCode: "440600",
            level: 3,
          },
          {
            id: 2016,
            regionCode: "440607",
            regionName: "三水区",
            parentCode: "440600",
            level: 3,
          },
          {
            id: 2017,
            regionCode: "440608",
            regionName: "高明区",
            parentCode: "440600",
            level: 3,
          },
        ],
      },
      {
        id: 2018,
        regionCode: "440700",
        regionName: "江门市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2019,
            regionCode: "440703",
            regionName: "蓬江区",
            parentCode: "440700",
            level: 3,
          },
          {
            id: 2020,
            regionCode: "440704",
            regionName: "江海区",
            parentCode: "440700",
            level: 3,
          },
          {
            id: 2021,
            regionCode: "440705",
            regionName: "新会区",
            parentCode: "440700",
            level: 3,
          },
          {
            id: 2022,
            regionCode: "440781",
            regionName: "台山市",
            parentCode: "440700",
            level: 3,
          },
          {
            id: 2023,
            regionCode: "440783",
            regionName: "开平市",
            parentCode: "440700",
            level: 3,
          },
          {
            id: 2024,
            regionCode: "440784",
            regionName: "鹤山市",
            parentCode: "440700",
            level: 3,
          },
          {
            id: 2025,
            regionCode: "440785",
            regionName: "恩平市",
            parentCode: "440700",
            level: 3,
          },
        ],
      },
      {
        id: 2026,
        regionCode: "440800",
        regionName: "湛江市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2027,
            regionCode: "440802",
            regionName: "赤坎区",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2028,
            regionCode: "440803",
            regionName: "霞山区",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2029,
            regionCode: "440804",
            regionName: "坡头区",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2030,
            regionCode: "440811",
            regionName: "麻章区",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2031,
            regionCode: "440823",
            regionName: "遂溪县",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2032,
            regionCode: "440825",
            regionName: "徐闻县",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2033,
            regionCode: "440881",
            regionName: "廉江市",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2034,
            regionCode: "440882",
            regionName: "雷州市",
            parentCode: "440800",
            level: 3,
          },
          {
            id: 2035,
            regionCode: "440883",
            regionName: "吴川市",
            parentCode: "440800",
            level: 3,
          },
        ],
      },
      {
        id: 2036,
        regionCode: "440900",
        regionName: "茂名市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2037,
            regionCode: "440902",
            regionName: "茂南区",
            parentCode: "440900",
            level: 3,
          },
          {
            id: 2038,
            regionCode: "440904",
            regionName: "电白区",
            parentCode: "440900",
            level: 3,
          },
          {
            id: 2039,
            regionCode: "440981",
            regionName: "高州市",
            parentCode: "440900",
            level: 3,
          },
          {
            id: 2040,
            regionCode: "440982",
            regionName: "化州市",
            parentCode: "440900",
            level: 3,
          },
          {
            id: 2041,
            regionCode: "440983",
            regionName: "信宜市",
            parentCode: "440900",
            level: 3,
          },
        ],
      },
      {
        id: 2042,
        regionCode: "441200",
        regionName: "肇庆市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2043,
            regionCode: "441202",
            regionName: "端州区",
            parentCode: "441200",
            level: 3,
          },
          {
            id: 2044,
            regionCode: "441203",
            regionName: "鼎湖区",
            parentCode: "441200",
            level: 3,
          },
          {
            id: 2045,
            regionCode: "441223",
            regionName: "广宁县",
            parentCode: "441200",
            level: 3,
          },
          {
            id: 2046,
            regionCode: "441224",
            regionName: "怀集县",
            parentCode: "441200",
            level: 3,
          },
          {
            id: 2047,
            regionCode: "441225",
            regionName: "封开县",
            parentCode: "441200",
            level: 3,
          },
          {
            id: 2048,
            regionCode: "441226",
            regionName: "德庆县",
            parentCode: "441200",
            level: 3,
          },
          {
            id: 2049,
            regionCode: "441283",
            regionName: "高要市",
            parentCode: "441200",
            level: 3,
          },
          {
            id: 2050,
            regionCode: "441284",
            regionName: "四会市",
            parentCode: "441200",
            level: 3,
          },
        ],
      },
      {
        id: 2051,
        regionCode: "441300",
        regionName: "惠州市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2052,
            regionCode: "441302",
            regionName: "惠城区",
            parentCode: "441300",
            level: 3,
          },
          {
            id: 2053,
            regionCode: "441303",
            regionName: "惠阳区",
            parentCode: "441300",
            level: 3,
          },
          {
            id: 2054,
            regionCode: "441322",
            regionName: "博罗县",
            parentCode: "441300",
            level: 3,
          },
          {
            id: 2055,
            regionCode: "441323",
            regionName: "惠东县",
            parentCode: "441300",
            level: 3,
          },
          {
            id: 2056,
            regionCode: "441324",
            regionName: "龙门县",
            parentCode: "441300",
            level: 3,
          },
        ],
      },
      {
        id: 2057,
        regionCode: "441400",
        regionName: "梅州市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2058,
            regionCode: "441402",
            regionName: "梅江区",
            parentCode: "441400",
            level: 3,
          },
          {
            id: 2059,
            regionCode: "441403",
            regionName: "梅县区",
            parentCode: "441400",
            level: 3,
          },
          {
            id: 2060,
            regionCode: "441422",
            regionName: "大埔县",
            parentCode: "441400",
            level: 3,
          },
          {
            id: 2061,
            regionCode: "441423",
            regionName: "丰顺县",
            parentCode: "441400",
            level: 3,
          },
          {
            id: 2062,
            regionCode: "441424",
            regionName: "五华县",
            parentCode: "441400",
            level: 3,
          },
          {
            id: 2063,
            regionCode: "441426",
            regionName: "平远县",
            parentCode: "441400",
            level: 3,
          },
          {
            id: 2064,
            regionCode: "441427",
            regionName: "蕉岭县",
            parentCode: "441400",
            level: 3,
          },
          {
            id: 2065,
            regionCode: "441481",
            regionName: "兴宁市",
            parentCode: "441400",
            level: 3,
          },
        ],
      },
      {
        id: 2066,
        regionCode: "441500",
        regionName: "汕尾市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2067,
            regionCode: "441502",
            regionName: "城区",
            parentCode: "441500",
            level: 3,
          },
          {
            id: 2068,
            regionCode: "441521",
            regionName: "海丰县",
            parentCode: "441500",
            level: 3,
          },
          {
            id: 2069,
            regionCode: "441523",
            regionName: "陆河县",
            parentCode: "441500",
            level: 3,
          },
          {
            id: 2070,
            regionCode: "441581",
            regionName: "陆丰市",
            parentCode: "441500",
            level: 3,
          },
        ],
      },
      {
        id: 2071,
        regionCode: "441600",
        regionName: "河源市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2072,
            regionCode: "441602",
            regionName: "源城区",
            parentCode: "441600",
            level: 3,
          },
          {
            id: 2073,
            regionCode: "441621",
            regionName: "紫金县",
            parentCode: "441600",
            level: 3,
          },
          {
            id: 2074,
            regionCode: "441622",
            regionName: "龙川县",
            parentCode: "441600",
            level: 3,
          },
          {
            id: 2075,
            regionCode: "441623",
            regionName: "连平县",
            parentCode: "441600",
            level: 3,
          },
          {
            id: 2076,
            regionCode: "441624",
            regionName: "和平县",
            parentCode: "441600",
            level: 3,
          },
          {
            id: 2077,
            regionCode: "441625",
            regionName: "东源县",
            parentCode: "441600",
            level: 3,
          },
        ],
      },
      {
        id: 2078,
        regionCode: "441700",
        regionName: "阳江市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2079,
            regionCode: "441702",
            regionName: "江城区",
            parentCode: "441700",
            level: 3,
          },
          {
            id: 2080,
            regionCode: "441704",
            regionName: "阳东区",
            parentCode: "441700",
            level: 3,
          },
          {
            id: 2081,
            regionCode: "441721",
            regionName: "阳西县",
            parentCode: "441700",
            level: 3,
          },
          {
            id: 2082,
            regionCode: "441781",
            regionName: "阳春市",
            parentCode: "441700",
            level: 3,
          },
        ],
      },
      {
        id: 2083,
        regionCode: "441800",
        regionName: "清远市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2084,
            regionCode: "441802",
            regionName: "清城区",
            parentCode: "441800",
            level: 3,
          },
          {
            id: 2085,
            regionCode: "441803",
            regionName: "清新区",
            parentCode: "441800",
            level: 3,
          },
          {
            id: 2086,
            regionCode: "441821",
            regionName: "佛冈县",
            parentCode: "441800",
            level: 3,
          },
          {
            id: 2087,
            regionCode: "441823",
            regionName: "阳山县",
            parentCode: "441800",
            level: 3,
          },
          {
            id: 2088,
            regionCode: "441825",
            regionName: "连山壮族瑶族自治县",
            parentCode: "441800",
            level: 3,
          },
          {
            id: 2089,
            regionCode: "441826",
            regionName: "连南瑶族自治县",
            parentCode: "441800",
            level: 3,
          },
          {
            id: 2090,
            regionCode: "441881",
            regionName: "英德市",
            parentCode: "441800",
            level: 3,
          },
          {
            id: 2091,
            regionCode: "441882",
            regionName: "连州市",
            parentCode: "441800",
            level: 3,
          },
        ],
      },
      {
        id: 2092,
        regionCode: "441900",
        regionName: "东莞市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2093,
            regionCode: "441901",
            regionName: "莞城区",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2094,
            regionCode: "441902",
            regionName: "南城区",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2095,
            regionCode: "441904",
            regionName: "万江区",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2096,
            regionCode: "441905",
            regionName: "石碣镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2097,
            regionCode: "441906",
            regionName: "石龙镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2098,
            regionCode: "441907",
            regionName: "茶山镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2099,
            regionCode: "441908",
            regionName: "石排镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2100,
            regionCode: "441909",
            regionName: "企石镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2101,
            regionCode: "441910",
            regionName: "横沥镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2102,
            regionCode: "441911",
            regionName: "桥头镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2103,
            regionCode: "441912",
            regionName: "谢岗镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2104,
            regionCode: "441913",
            regionName: "东坑镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2105,
            regionCode: "441914",
            regionName: "常平镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2106,
            regionCode: "441915",
            regionName: "寮步镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2107,
            regionCode: "441916",
            regionName: "大朗镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2108,
            regionCode: "441917",
            regionName: "麻涌镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2109,
            regionCode: "441918",
            regionName: "中堂镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2110,
            regionCode: "441919",
            regionName: "高埗镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2111,
            regionCode: "441920",
            regionName: "樟木头镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2112,
            regionCode: "441921",
            regionName: "大岭山镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2113,
            regionCode: "441922",
            regionName: "望牛墩镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2114,
            regionCode: "441923",
            regionName: "黄江镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2115,
            regionCode: "441924",
            regionName: "洪梅镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2116,
            regionCode: "441925",
            regionName: "清溪镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2117,
            regionCode: "441926",
            regionName: "沙田镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2118,
            regionCode: "441927",
            regionName: "道滘镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2119,
            regionCode: "441928",
            regionName: "塘厦镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2120,
            regionCode: "441929",
            regionName: "虎门镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2121,
            regionCode: "441930",
            regionName: "厚街镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2122,
            regionCode: "441931",
            regionName: "凤岗镇",
            parentCode: "441900",
            level: 3,
          },
          {
            id: 2123,
            regionCode: "441932",
            regionName: "长安镇",
            parentCode: "441900",
            level: 3,
          },
        ],
      },
      {
        id: 2124,
        regionCode: "442000",
        regionName: "中山市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2125,
            regionCode: "442001",
            regionName: "石岐区",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2126,
            regionCode: "442004",
            regionName: "南区",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2127,
            regionCode: "442005",
            regionName: "五桂山区",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2128,
            regionCode: "442006",
            regionName: "火炬开发区",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2129,
            regionCode: "442007",
            regionName: "黄圃镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2130,
            regionCode: "442008",
            regionName: "南头镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2131,
            regionCode: "442009",
            regionName: "东凤镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2132,
            regionCode: "442010",
            regionName: "阜沙镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2133,
            regionCode: "442011",
            regionName: "小榄镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2134,
            regionCode: "442012",
            regionName: "东升镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2135,
            regionCode: "442013",
            regionName: "古镇镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2136,
            regionCode: "442014",
            regionName: "横栏镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2137,
            regionCode: "442015",
            regionName: "三角镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2138,
            regionCode: "442016",
            regionName: "民众镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2139,
            regionCode: "442017",
            regionName: "南朗镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2140,
            regionCode: "442018",
            regionName: "港口镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2141,
            regionCode: "442019",
            regionName: "大涌镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2142,
            regionCode: "442020",
            regionName: "沙溪镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2143,
            regionCode: "442021",
            regionName: "三乡镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2144,
            regionCode: "442022",
            regionName: "板芙镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2145,
            regionCode: "442023",
            regionName: "神湾镇",
            parentCode: "442000",
            level: 3,
          },
          {
            id: 2146,
            regionCode: "442024",
            regionName: "坦洲镇",
            parentCode: "442000",
            level: 3,
          },
        ],
      },
      {
        id: 2147,
        regionCode: "445100",
        regionName: "潮州市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2148,
            regionCode: "445102",
            regionName: "湘桥区",
            parentCode: "445100",
            level: 3,
          },
          {
            id: 2149,
            regionCode: "445103",
            regionName: "潮安区",
            parentCode: "445100",
            level: 3,
          },
          {
            id: 2150,
            regionCode: "445122",
            regionName: "饶平县",
            parentCode: "445100",
            level: 3,
          },
        ],
      },
      {
        id: 2151,
        regionCode: "445200",
        regionName: "揭阳市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2152,
            regionCode: "445202",
            regionName: "榕城区",
            parentCode: "445200",
            level: 3,
          },
          {
            id: 2153,
            regionCode: "445203",
            regionName: "揭东区",
            parentCode: "445200",
            level: 3,
          },
          {
            id: 2154,
            regionCode: "445222",
            regionName: "揭西县",
            parentCode: "445200",
            level: 3,
          },
          {
            id: 2155,
            regionCode: "445224",
            regionName: "惠来县",
            parentCode: "445200",
            level: 3,
          },
          {
            id: 2156,
            regionCode: "445281",
            regionName: "普宁市",
            parentCode: "445200",
            level: 3,
          },
        ],
      },
      {
        id: 2157,
        regionCode: "445300",
        regionName: "云浮市",
        parentCode: "440000",
        level: 2,
        children: [
          {
            id: 2158,
            regionCode: "445302",
            regionName: "云城区",
            parentCode: "445300",
            level: 3,
          },
          {
            id: 2159,
            regionCode: "445303",
            regionName: "云安区",
            parentCode: "445300",
            level: 3,
          },
          {
            id: 2160,
            regionCode: "445321",
            regionName: "新兴县",
            parentCode: "445300",
            level: 3,
          },
          {
            id: 2161,
            regionCode: "445322",
            regionName: "郁南县",
            parentCode: "445300",
            level: 3,
          },
          {
            id: 2162,
            regionCode: "445381",
            regionName: "罗定市",
            parentCode: "445300",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2163,
    regionCode: "450000",
    regionName: "广西壮族自治区",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2164,
        regionCode: "450100",
        regionName: "南宁市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2165,
            regionCode: "450102",
            regionName: "兴宁区",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2166,
            regionCode: "450103",
            regionName: "青秀区",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2167,
            regionCode: "450105",
            regionName: "江南区",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2168,
            regionCode: "450107",
            regionName: "西乡塘区",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2169,
            regionCode: "450108",
            regionName: "良庆区",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2170,
            regionCode: "450109",
            regionName: "邕宁区",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2171,
            regionCode: "450122",
            regionName: "武鸣县",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2172,
            regionCode: "450123",
            regionName: "隆安县",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2173,
            regionCode: "450124",
            regionName: "马山县",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2174,
            regionCode: "450125",
            regionName: "上林县",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2175,
            regionCode: "450126",
            regionName: "宾阳县",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2176,
            regionCode: "450127",
            regionName: "横县",
            parentCode: "450100",
            level: 3,
          },
          {
            id: 2177,
            regionCode: "450128",
            regionName: "埌东新区",
            parentCode: "450100",
            level: 3,
          },
        ],
      },
      {
        id: 2178,
        regionCode: "450200",
        regionName: "柳州市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2179,
            regionCode: "450202",
            regionName: "城中区",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2180,
            regionCode: "450203",
            regionName: "鱼峰区",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2181,
            regionCode: "450204",
            regionName: "柳南区",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2182,
            regionCode: "450205",
            regionName: "柳北区",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2183,
            regionCode: "450221",
            regionName: "柳江县",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2184,
            regionCode: "450222",
            regionName: "柳城县",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2185,
            regionCode: "450223",
            regionName: "鹿寨县",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2186,
            regionCode: "450224",
            regionName: "融安县",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2187,
            regionCode: "450225",
            regionName: "融水苗族自治县",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2188,
            regionCode: "450226",
            regionName: "三江侗族自治县",
            parentCode: "450200",
            level: 3,
          },
          {
            id: 2189,
            regionCode: "450227",
            regionName: "柳东新区",
            parentCode: "450200",
            level: 3,
          },
        ],
      },
      {
        id: 2190,
        regionCode: "450300",
        regionName: "桂林市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2191,
            regionCode: "450302",
            regionName: "秀峰区",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2192,
            regionCode: "450303",
            regionName: "叠彩区",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2193,
            regionCode: "450304",
            regionName: "象山区",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2194,
            regionCode: "450305",
            regionName: "七星区",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2195,
            regionCode: "450311",
            regionName: "雁山区",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2196,
            regionCode: "450312",
            regionName: "临桂区",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2197,
            regionCode: "450321",
            regionName: "阳朔县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2198,
            regionCode: "450323",
            regionName: "灵川县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2199,
            regionCode: "450324",
            regionName: "全州县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2200,
            regionCode: "450325",
            regionName: "兴安县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2201,
            regionCode: "450326",
            regionName: "永福县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2202,
            regionCode: "450327",
            regionName: "灌阳县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2203,
            regionCode: "450328",
            regionName: "龙胜各族自治县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2204,
            regionCode: "450329",
            regionName: "资源县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2205,
            regionCode: "450330",
            regionName: "平乐县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2206,
            regionCode: "450331",
            regionName: "荔浦县",
            parentCode: "450300",
            level: 3,
          },
          {
            id: 2207,
            regionCode: "450332",
            regionName: "恭城瑶族自治县",
            parentCode: "450300",
            level: 3,
          },
        ],
      },
      {
        id: 2208,
        regionCode: "450400",
        regionName: "梧州市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2209,
            regionCode: "450403",
            regionName: "万秀区",
            parentCode: "450400",
            level: 3,
          },
          {
            id: 2210,
            regionCode: "450405",
            regionName: "长洲区",
            parentCode: "450400",
            level: 3,
          },
          {
            id: 2211,
            regionCode: "450406",
            regionName: "龙圩区",
            parentCode: "450400",
            level: 3,
          },
          {
            id: 2212,
            regionCode: "450421",
            regionName: "苍梧县",
            parentCode: "450400",
            level: 3,
          },
          {
            id: 2213,
            regionCode: "450422",
            regionName: "藤县",
            parentCode: "450400",
            level: 3,
          },
          {
            id: 2214,
            regionCode: "450423",
            regionName: "蒙山县",
            parentCode: "450400",
            level: 3,
          },
          {
            id: 2215,
            regionCode: "450481",
            regionName: "岑溪市",
            parentCode: "450400",
            level: 3,
          },
        ],
      },
      {
        id: 2216,
        regionCode: "450500",
        regionName: "北海市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2217,
            regionCode: "450502",
            regionName: "海城区",
            parentCode: "450500",
            level: 3,
          },
          {
            id: 2218,
            regionCode: "450503",
            regionName: "银海区",
            parentCode: "450500",
            level: 3,
          },
          {
            id: 2219,
            regionCode: "450512",
            regionName: "铁山港区",
            parentCode: "450500",
            level: 3,
          },
          {
            id: 2220,
            regionCode: "450521",
            regionName: "合浦县",
            parentCode: "450500",
            level: 3,
          },
        ],
      },
      {
        id: 2221,
        regionCode: "450600",
        regionName: "防城港市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2222,
            regionCode: "450602",
            regionName: "港口区",
            parentCode: "450600",
            level: 3,
          },
          {
            id: 2223,
            regionCode: "450603",
            regionName: "防城区",
            parentCode: "450600",
            level: 3,
          },
          {
            id: 2224,
            regionCode: "450621",
            regionName: "上思县",
            parentCode: "450600",
            level: 3,
          },
          {
            id: 2225,
            regionCode: "450681",
            regionName: "东兴市",
            parentCode: "450600",
            level: 3,
          },
        ],
      },
      {
        id: 2226,
        regionCode: "450700",
        regionName: "钦州市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2227,
            regionCode: "450702",
            regionName: "钦南区",
            parentCode: "450700",
            level: 3,
          },
          {
            id: 2228,
            regionCode: "450703",
            regionName: "钦北区",
            parentCode: "450700",
            level: 3,
          },
          {
            id: 2229,
            regionCode: "450721",
            regionName: "灵山县",
            parentCode: "450700",
            level: 3,
          },
          {
            id: 2230,
            regionCode: "450722",
            regionName: "浦北县",
            parentCode: "450700",
            level: 3,
          },
        ],
      },
      {
        id: 2231,
        regionCode: "450800",
        regionName: "贵港市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2232,
            regionCode: "450802",
            regionName: "港北区",
            parentCode: "450800",
            level: 3,
          },
          {
            id: 2233,
            regionCode: "450803",
            regionName: "港南区",
            parentCode: "450800",
            level: 3,
          },
          {
            id: 2234,
            regionCode: "450804",
            regionName: "覃塘区",
            parentCode: "450800",
            level: 3,
          },
          {
            id: 2235,
            regionCode: "450821",
            regionName: "平南县",
            parentCode: "450800",
            level: 3,
          },
          {
            id: 2236,
            regionCode: "450881",
            regionName: "桂平市",
            parentCode: "450800",
            level: 3,
          },
        ],
      },
      {
        id: 2237,
        regionCode: "450900",
        regionName: "玉林市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2238,
            regionCode: "450902",
            regionName: "玉州区",
            parentCode: "450900",
            level: 3,
          },
          {
            id: 2239,
            regionCode: "450903",
            regionName: "福绵区",
            parentCode: "450900",
            level: 3,
          },
          {
            id: 2240,
            regionCode: "450904",
            regionName: "玉东新区",
            parentCode: "450900",
            level: 3,
          },
          {
            id: 2241,
            regionCode: "450921",
            regionName: "容县",
            parentCode: "450900",
            level: 3,
          },
          {
            id: 2242,
            regionCode: "450922",
            regionName: "陆川县",
            parentCode: "450900",
            level: 3,
          },
          {
            id: 2243,
            regionCode: "450923",
            regionName: "博白县",
            parentCode: "450900",
            level: 3,
          },
          {
            id: 2244,
            regionCode: "450924",
            regionName: "兴业县",
            parentCode: "450900",
            level: 3,
          },
          {
            id: 2245,
            regionCode: "450981",
            regionName: "北流市",
            parentCode: "450900",
            level: 3,
          },
        ],
      },
      {
        id: 2246,
        regionCode: "451000",
        regionName: "百色市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2247,
            regionCode: "451002",
            regionName: "右江区",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2248,
            regionCode: "451021",
            regionName: "田阳县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2249,
            regionCode: "451022",
            regionName: "田东县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2250,
            regionCode: "451023",
            regionName: "平果县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2251,
            regionCode: "451024",
            regionName: "德保县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2252,
            regionCode: "451025",
            regionName: "靖西县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2253,
            regionCode: "451026",
            regionName: "那坡县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2254,
            regionCode: "451027",
            regionName: "凌云县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2255,
            regionCode: "451028",
            regionName: "乐业县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2256,
            regionCode: "451029",
            regionName: "田林县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2257,
            regionCode: "451030",
            regionName: "西林县",
            parentCode: "451000",
            level: 3,
          },
          {
            id: 2258,
            regionCode: "451031",
            regionName: "隆林各族自治县",
            parentCode: "451000",
            level: 3,
          },
        ],
      },
      {
        id: 2259,
        regionCode: "451100",
        regionName: "贺州市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2260,
            regionCode: "451102",
            regionName: "八步区",
            parentCode: "451100",
            level: 3,
          },
          {
            id: 2261,
            regionCode: "451121",
            regionName: "昭平县",
            parentCode: "451100",
            level: 3,
          },
          {
            id: 2262,
            regionCode: "451122",
            regionName: "钟山县",
            parentCode: "451100",
            level: 3,
          },
          {
            id: 2263,
            regionCode: "451123",
            regionName: "富川瑶族自治县",
            parentCode: "451100",
            level: 3,
          },
          {
            id: 2264,
            regionCode: "451124",
            regionName: "平桂管理区",
            parentCode: "451100",
            level: 3,
          },
        ],
      },
      {
        id: 2265,
        regionCode: "451200",
        regionName: "河池市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2266,
            regionCode: "451202",
            regionName: "金城江区",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2267,
            regionCode: "451221",
            regionName: "南丹县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2268,
            regionCode: "451222",
            regionName: "天峨县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2269,
            regionCode: "451223",
            regionName: "凤山县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2270,
            regionCode: "451224",
            regionName: "东兰县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2271,
            regionCode: "451225",
            regionName: "罗城仫佬族自治县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2272,
            regionCode: "451226",
            regionName: "环江毛南族自治县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2273,
            regionCode: "451227",
            regionName: "巴马瑶族自治县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2274,
            regionCode: "451228",
            regionName: "都安瑶族自治县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2275,
            regionCode: "451229",
            regionName: "大化瑶族自治县",
            parentCode: "451200",
            level: 3,
          },
          {
            id: 2276,
            regionCode: "451281",
            regionName: "宜州市",
            parentCode: "451200",
            level: 3,
          },
        ],
      },
      {
        id: 2277,
        regionCode: "451300",
        regionName: "来宾市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2278,
            regionCode: "451302",
            regionName: "兴宾区",
            parentCode: "451300",
            level: 3,
          },
          {
            id: 2279,
            regionCode: "451321",
            regionName: "忻城县",
            parentCode: "451300",
            level: 3,
          },
          {
            id: 2280,
            regionCode: "451322",
            regionName: "象州县",
            parentCode: "451300",
            level: 3,
          },
          {
            id: 2281,
            regionCode: "451323",
            regionName: "武宣县",
            parentCode: "451300",
            level: 3,
          },
          {
            id: 2282,
            regionCode: "451324",
            regionName: "金秀瑶族自治县",
            parentCode: "451300",
            level: 3,
          },
          {
            id: 2283,
            regionCode: "451381",
            regionName: "合山市",
            parentCode: "451300",
            level: 3,
          },
        ],
      },
      {
        id: 2284,
        regionCode: "451400",
        regionName: "崇左市",
        parentCode: "450000",
        level: 2,
        children: [
          {
            id: 2285,
            regionCode: "451402",
            regionName: "江州区",
            parentCode: "451400",
            level: 3,
          },
          {
            id: 2286,
            regionCode: "451421",
            regionName: "扶绥县",
            parentCode: "451400",
            level: 3,
          },
          {
            id: 2287,
            regionCode: "451422",
            regionName: "宁明县",
            parentCode: "451400",
            level: 3,
          },
          {
            id: 2288,
            regionCode: "451423",
            regionName: "龙州县",
            parentCode: "451400",
            level: 3,
          },
          {
            id: 2289,
            regionCode: "451424",
            regionName: "大新县",
            parentCode: "451400",
            level: 3,
          },
          {
            id: 2290,
            regionCode: "451425",
            regionName: "天等县",
            parentCode: "451400",
            level: 3,
          },
          {
            id: 2291,
            regionCode: "451481",
            regionName: "凭祥市",
            parentCode: "451400",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2292,
    regionCode: "460000",
    regionName: "海南省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2293,
        regionCode: "460100",
        regionName: "海口市",
        parentCode: "460000",
        level: 2,
        children: [
          {
            id: 2294,
            regionCode: "460105",
            regionName: "秀英区",
            parentCode: "460100",
            level: 3,
          },
          {
            id: 2295,
            regionCode: "460106",
            regionName: "龙华区",
            parentCode: "460100",
            level: 3,
          },
          {
            id: 2296,
            regionCode: "460107",
            regionName: "琼山区",
            parentCode: "460100",
            level: 3,
          },
          {
            id: 2297,
            regionCode: "460108",
            regionName: "美兰区",
            parentCode: "460100",
            level: 3,
          },
        ],
      },
      {
        id: 2298,
        regionCode: "460200",
        regionName: "三亚市",
        parentCode: "460000",
        level: 2,
        children: [
          {
            id: 2299,
            regionCode: "460202",
            regionName: "海棠区",
            parentCode: "460200",
            level: 3,
          },
          {
            id: 2300,
            regionCode: "460203",
            regionName: "吉阳区",
            parentCode: "460200",
            level: 3,
          },
          {
            id: 2301,
            regionCode: "460204",
            regionName: "天涯区",
            parentCode: "460200",
            level: 3,
          },
          {
            id: 2302,
            regionCode: "460205",
            regionName: "崖州区",
            parentCode: "460200",
            level: 3,
          },
        ],
      },
      {
        id: 2303,
        regionCode: "460300",
        regionName: "三沙市",
        parentCode: "460000",
        level: 2,
        children: [
          {
            id: 2304,
            regionCode: "460321",
            regionName: "西沙群岛",
            parentCode: "460300",
            level: 3,
          },
          {
            id: 2305,
            regionCode: "460322",
            regionName: "南沙群岛",
            parentCode: "460300",
            level: 3,
          },
          {
            id: 2306,
            regionCode: "460323",
            regionName: "中沙群岛",
            parentCode: "460300",
            level: 3,
          },
        ],
      },
      {
        id: 2307,
        regionCode: "469000",
        regionName: "直辖县级",
        parentCode: "460000",
        level: 2,
        children: [
          {
            id: 2308,
            regionCode: "469001",
            regionName: "五指山市",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2309,
            regionCode: "469002",
            regionName: "琼海市",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2310,
            regionCode: "469003",
            regionName: "儋州市",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2311,
            regionCode: "469005",
            regionName: "文昌市",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2312,
            regionCode: "469006",
            regionName: "万宁市",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2313,
            regionCode: "469007",
            regionName: "东方市",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2314,
            regionCode: "469021",
            regionName: "定安县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2315,
            regionCode: "469022",
            regionName: "屯昌县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2316,
            regionCode: "469023",
            regionName: "澄迈县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2317,
            regionCode: "469024",
            regionName: "临高县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2318,
            regionCode: "469025",
            regionName: "白沙黎族自治县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2319,
            regionCode: "469026",
            regionName: "昌江黎族自治县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2320,
            regionCode: "469027",
            regionName: "乐东黎族自治县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2321,
            regionCode: "469028",
            regionName: "陵水黎族自治县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2322,
            regionCode: "469029",
            regionName: "保亭黎族苗族自治县",
            parentCode: "469000",
            level: 3,
          },
          {
            id: 2323,
            regionCode: "469030",
            regionName: "琼中黎族苗族自治县",
            parentCode: "469000",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2324,
    regionCode: "500000",
    regionName: "重庆",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2325,
        regionCode: "500100",
        regionName: "重庆市",
        parentCode: "500000",
        level: 2,
        children: [
          {
            id: 2326,
            regionCode: "500101",
            regionName: "万州区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2327,
            regionCode: "500102",
            regionName: "涪陵区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2328,
            regionCode: "500103",
            regionName: "渝中区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2329,
            regionCode: "500104",
            regionName: "大渡口区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2330,
            regionCode: "500105",
            regionName: "江北区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2331,
            regionCode: "500106",
            regionName: "沙坪坝区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2332,
            regionCode: "500107",
            regionName: "九龙坡区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2333,
            regionCode: "500108",
            regionName: "南岸区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2334,
            regionCode: "500109",
            regionName: "北碚区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2335,
            regionCode: "500110",
            regionName: "綦江区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2336,
            regionCode: "500111",
            regionName: "大足区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2337,
            regionCode: "500112",
            regionName: "渝北区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2338,
            regionCode: "500113",
            regionName: "巴南区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2339,
            regionCode: "500114",
            regionName: "黔江区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2340,
            regionCode: "500115",
            regionName: "长寿区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2341,
            regionCode: "500116",
            regionName: "江津区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2342,
            regionCode: "500117",
            regionName: "合川区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2343,
            regionCode: "500118",
            regionName: "永川区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2344,
            regionCode: "500119",
            regionName: "南川区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2345,
            regionCode: "500120",
            regionName: "璧山区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2346,
            regionCode: "500151",
            regionName: "铜梁区",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2347,
            regionCode: "500223",
            regionName: "潼南县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2348,
            regionCode: "500226",
            regionName: "荣昌县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2349,
            regionCode: "500228",
            regionName: "梁平县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2350,
            regionCode: "500229",
            regionName: "城口县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2351,
            regionCode: "500230",
            regionName: "丰都县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2352,
            regionCode: "500231",
            regionName: "垫江县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2353,
            regionCode: "500232",
            regionName: "武隆县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2354,
            regionCode: "500233",
            regionName: "忠县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2355,
            regionCode: "500234",
            regionName: "开县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2356,
            regionCode: "500235",
            regionName: "云阳县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2357,
            regionCode: "500236",
            regionName: "奉节县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2358,
            regionCode: "500237",
            regionName: "巫山县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2359,
            regionCode: "500238",
            regionName: "巫溪县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2360,
            regionCode: "500240",
            regionName: "石柱土家族自治县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2361,
            regionCode: "500241",
            regionName: "秀山土家族苗族自治县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2362,
            regionCode: "500242",
            regionName: "酉阳土家族苗族自治县",
            parentCode: "500100",
            level: 3,
          },
          {
            id: 2363,
            regionCode: "500243",
            regionName: "彭水苗族土家族自治县",
            parentCode: "500100",
            level: 3,
          },
        ],
      },
      {
        id: 2364,
        regionCode: "500300",
        regionName: "两江新区",
        parentCode: "500000",
        level: 2,
        children: [
          {
            id: 2365,
            regionCode: "500301",
            regionName: "北部新区",
            parentCode: "500300",
            level: 3,
          },
          {
            id: 2366,
            regionCode: "500302",
            regionName: "保税港区",
            parentCode: "500300",
            level: 3,
          },
          {
            id: 2367,
            regionCode: "500303",
            regionName: "工业园区",
            parentCode: "500300",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2368,
    regionCode: "510000",
    regionName: "四川省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2369,
        regionCode: "510100",
        regionName: "成都市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2370,
            regionCode: "510104",
            regionName: "锦江区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2371,
            regionCode: "510105",
            regionName: "青羊区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2372,
            regionCode: "510106",
            regionName: "金牛区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2373,
            regionCode: "510107",
            regionName: "武侯区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2374,
            regionCode: "510108",
            regionName: "成华区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2375,
            regionCode: "510112",
            regionName: "龙泉驿区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2376,
            regionCode: "510113",
            regionName: "青白江区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2377,
            regionCode: "510114",
            regionName: "新都区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2378,
            regionCode: "510115",
            regionName: "温江区",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2379,
            regionCode: "510121",
            regionName: "金堂县",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2380,
            regionCode: "510122",
            regionName: "双流县",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2381,
            regionCode: "510124",
            regionName: "郫县",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2382,
            regionCode: "510129",
            regionName: "大邑县",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2383,
            regionCode: "510131",
            regionName: "蒲江县",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2384,
            regionCode: "510132",
            regionName: "新津县",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2385,
            regionCode: "510181",
            regionName: "都江堰市",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2386,
            regionCode: "510182",
            regionName: "彭州市",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2387,
            regionCode: "510183",
            regionName: "邛崃市",
            parentCode: "510100",
            level: 3,
          },
          {
            id: 2388,
            regionCode: "510184",
            regionName: "崇州市",
            parentCode: "510100",
            level: 3,
          },
        ],
      },
      {
        id: 2389,
        regionCode: "510300",
        regionName: "自贡市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2390,
            regionCode: "510302",
            regionName: "自流井区",
            parentCode: "510300",
            level: 3,
          },
          {
            id: 2391,
            regionCode: "510303",
            regionName: "贡井区",
            parentCode: "510300",
            level: 3,
          },
          {
            id: 2392,
            regionCode: "510304",
            regionName: "大安区",
            parentCode: "510300",
            level: 3,
          },
          {
            id: 2393,
            regionCode: "510311",
            regionName: "沿滩区",
            parentCode: "510300",
            level: 3,
          },
          {
            id: 2394,
            regionCode: "510321",
            regionName: "荣县",
            parentCode: "510300",
            level: 3,
          },
          {
            id: 2395,
            regionCode: "510322",
            regionName: "富顺县",
            parentCode: "510300",
            level: 3,
          },
        ],
      },
      {
        id: 2396,
        regionCode: "510400",
        regionName: "攀枝花市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2397,
            regionCode: "510402",
            regionName: "东区",
            parentCode: "510400",
            level: 3,
          },
          {
            id: 2398,
            regionCode: "510403",
            regionName: "西区",
            parentCode: "510400",
            level: 3,
          },
          {
            id: 2399,
            regionCode: "510411",
            regionName: "仁和区",
            parentCode: "510400",
            level: 3,
          },
          {
            id: 2400,
            regionCode: "510421",
            regionName: "米易县",
            parentCode: "510400",
            level: 3,
          },
          {
            id: 2401,
            regionCode: "510422",
            regionName: "盐边县",
            parentCode: "510400",
            level: 3,
          },
        ],
      },
      {
        id: 2402,
        regionCode: "510500",
        regionName: "泸州市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2403,
            regionCode: "510502",
            regionName: "江阳区",
            parentCode: "510500",
            level: 3,
          },
          {
            id: 2404,
            regionCode: "510503",
            regionName: "纳溪区",
            parentCode: "510500",
            level: 3,
          },
          {
            id: 2405,
            regionCode: "510504",
            regionName: "龙马潭区",
            parentCode: "510500",
            level: 3,
          },
          {
            id: 2406,
            regionCode: "510521",
            regionName: "泸县",
            parentCode: "510500",
            level: 3,
          },
          {
            id: 2407,
            regionCode: "510522",
            regionName: "合江县",
            parentCode: "510500",
            level: 3,
          },
          {
            id: 2408,
            regionCode: "510524",
            regionName: "叙永县",
            parentCode: "510500",
            level: 3,
          },
          {
            id: 2409,
            regionCode: "510525",
            regionName: "古蔺县",
            parentCode: "510500",
            level: 3,
          },
        ],
      },
      {
        id: 2410,
        regionCode: "510600",
        regionName: "德阳市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2411,
            regionCode: "510603",
            regionName: "旌阳区",
            parentCode: "510600",
            level: 3,
          },
          {
            id: 2412,
            regionCode: "510623",
            regionName: "中江县",
            parentCode: "510600",
            level: 3,
          },
          {
            id: 2413,
            regionCode: "510626",
            regionName: "罗江县",
            parentCode: "510600",
            level: 3,
          },
          {
            id: 2414,
            regionCode: "510681",
            regionName: "广汉市",
            parentCode: "510600",
            level: 3,
          },
          {
            id: 2415,
            regionCode: "510682",
            regionName: "什邡市",
            parentCode: "510600",
            level: 3,
          },
          {
            id: 2416,
            regionCode: "510683",
            regionName: "绵竹市",
            parentCode: "510600",
            level: 3,
          },
        ],
      },
      {
        id: 2417,
        regionCode: "510700",
        regionName: "绵阳市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2418,
            regionCode: "510703",
            regionName: "涪城区",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2419,
            regionCode: "510704",
            regionName: "游仙区",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2420,
            regionCode: "510722",
            regionName: "三台县",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2421,
            regionCode: "510723",
            regionName: "盐亭县",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2422,
            regionCode: "510724",
            regionName: "安县",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2423,
            regionCode: "510725",
            regionName: "梓潼县",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2424,
            regionCode: "510726",
            regionName: "北川羌族自治县",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2425,
            regionCode: "510727",
            regionName: "平武县",
            parentCode: "510700",
            level: 3,
          },
          {
            id: 2426,
            regionCode: "510781",
            regionName: "江油市",
            parentCode: "510700",
            level: 3,
          },
        ],
      },
      {
        id: 2427,
        regionCode: "510800",
        regionName: "广元市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2428,
            regionCode: "510802",
            regionName: "利州区",
            parentCode: "510800",
            level: 3,
          },
          {
            id: 2429,
            regionCode: "510811",
            regionName: "昭化区",
            parentCode: "510800",
            level: 3,
          },
          {
            id: 2430,
            regionCode: "510812",
            regionName: "朝天区",
            parentCode: "510800",
            level: 3,
          },
          {
            id: 2431,
            regionCode: "510821",
            regionName: "旺苍县",
            parentCode: "510800",
            level: 3,
          },
          {
            id: 2432,
            regionCode: "510822",
            regionName: "青川县",
            parentCode: "510800",
            level: 3,
          },
          {
            id: 2433,
            regionCode: "510823",
            regionName: "剑阁县",
            parentCode: "510800",
            level: 3,
          },
          {
            id: 2434,
            regionCode: "510824",
            regionName: "苍溪县",
            parentCode: "510800",
            level: 3,
          },
        ],
      },
      {
        id: 2435,
        regionCode: "510900",
        regionName: "遂宁市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2436,
            regionCode: "510903",
            regionName: "船山区",
            parentCode: "510900",
            level: 3,
          },
          {
            id: 2437,
            regionCode: "510904",
            regionName: "安居区",
            parentCode: "510900",
            level: 3,
          },
          {
            id: 2438,
            regionCode: "510921",
            regionName: "蓬溪县",
            parentCode: "510900",
            level: 3,
          },
          {
            id: 2439,
            regionCode: "510922",
            regionName: "射洪县",
            parentCode: "510900",
            level: 3,
          },
          {
            id: 2440,
            regionCode: "510923",
            regionName: "大英县",
            parentCode: "510900",
            level: 3,
          },
        ],
      },
      {
        id: 2441,
        regionCode: "511000",
        regionName: "内江市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2442,
            regionCode: "511002",
            regionName: "市中区",
            parentCode: "511000",
            level: 3,
          },
          {
            id: 2443,
            regionCode: "511011",
            regionName: "东兴区",
            parentCode: "511000",
            level: 3,
          },
          {
            id: 2444,
            regionCode: "511024",
            regionName: "威远县",
            parentCode: "511000",
            level: 3,
          },
          {
            id: 2445,
            regionCode: "511025",
            regionName: "资中县",
            parentCode: "511000",
            level: 3,
          },
          {
            id: 2446,
            regionCode: "511028",
            regionName: "隆昌县",
            parentCode: "511000",
            level: 3,
          },
        ],
      },
      {
        id: 2447,
        regionCode: "511100",
        regionName: "乐山市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2448,
            regionCode: "511102",
            regionName: "市中区",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2449,
            regionCode: "511111",
            regionName: "沙湾区",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2450,
            regionCode: "511112",
            regionName: "五通桥区",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2451,
            regionCode: "511113",
            regionName: "金口河区",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2452,
            regionCode: "511123",
            regionName: "犍为县",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2453,
            regionCode: "511124",
            regionName: "井研县",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2454,
            regionCode: "511126",
            regionName: "夹江县",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2455,
            regionCode: "511129",
            regionName: "沐川县",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2456,
            regionCode: "511132",
            regionName: "峨边彝族自治县",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2457,
            regionCode: "511133",
            regionName: "马边彝族自治县",
            parentCode: "511100",
            level: 3,
          },
          {
            id: 2458,
            regionCode: "511181",
            regionName: "峨眉山市",
            parentCode: "511100",
            level: 3,
          },
        ],
      },
      {
        id: 2459,
        regionCode: "511300",
        regionName: "南充市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2460,
            regionCode: "511302",
            regionName: "顺庆区",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2461,
            regionCode: "511303",
            regionName: "高坪区",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2462,
            regionCode: "511304",
            regionName: "嘉陵区",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2463,
            regionCode: "511321",
            regionName: "南部县",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2464,
            regionCode: "511322",
            regionName: "营山县",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2465,
            regionCode: "511323",
            regionName: "蓬安县",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2466,
            regionCode: "511324",
            regionName: "仪陇县",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2467,
            regionCode: "511325",
            regionName: "西充县",
            parentCode: "511300",
            level: 3,
          },
          {
            id: 2468,
            regionCode: "511381",
            regionName: "阆中市",
            parentCode: "511300",
            level: 3,
          },
        ],
      },
      {
        id: 2469,
        regionCode: "511400",
        regionName: "眉山市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2470,
            regionCode: "511402",
            regionName: "东坡区",
            parentCode: "511400",
            level: 3,
          },
          {
            id: 2471,
            regionCode: "511403",
            regionName: "彭山区",
            parentCode: "511400",
            level: 3,
          },
          {
            id: 2472,
            regionCode: "511421",
            regionName: "仁寿县",
            parentCode: "511400",
            level: 3,
          },
          {
            id: 2473,
            regionCode: "511423",
            regionName: "洪雅县",
            parentCode: "511400",
            level: 3,
          },
          {
            id: 2474,
            regionCode: "511424",
            regionName: "丹棱县",
            parentCode: "511400",
            level: 3,
          },
          {
            id: 2475,
            regionCode: "511425",
            regionName: "青神县",
            parentCode: "511400",
            level: 3,
          },
        ],
      },
      {
        id: 2476,
        regionCode: "511500",
        regionName: "宜宾市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2477,
            regionCode: "511502",
            regionName: "翠屏区",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2478,
            regionCode: "511503",
            regionName: "南溪区",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2479,
            regionCode: "511521",
            regionName: "宜宾县",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2480,
            regionCode: "511523",
            regionName: "江安县",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2481,
            regionCode: "511524",
            regionName: "长宁县",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2482,
            regionCode: "511525",
            regionName: "高县",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2483,
            regionCode: "511526",
            regionName: "珙县",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2484,
            regionCode: "511527",
            regionName: "筠连县",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2485,
            regionCode: "511528",
            regionName: "兴文县",
            parentCode: "511500",
            level: 3,
          },
          {
            id: 2486,
            regionCode: "511529",
            regionName: "屏山县",
            parentCode: "511500",
            level: 3,
          },
        ],
      },
      {
        id: 2487,
        regionCode: "511600",
        regionName: "广安市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2488,
            regionCode: "511602",
            regionName: "广安区",
            parentCode: "511600",
            level: 3,
          },
          {
            id: 2489,
            regionCode: "511603",
            regionName: "前锋区",
            parentCode: "511600",
            level: 3,
          },
          {
            id: 2490,
            regionCode: "511621",
            regionName: "岳池县",
            parentCode: "511600",
            level: 3,
          },
          {
            id: 2491,
            regionCode: "511622",
            regionName: "武胜县",
            parentCode: "511600",
            level: 3,
          },
          {
            id: 2492,
            regionCode: "511623",
            regionName: "邻水县",
            parentCode: "511600",
            level: 3,
          },
          {
            id: 2493,
            regionCode: "511681",
            regionName: "华蓥市",
            parentCode: "511600",
            level: 3,
          },
        ],
      },
      {
        id: 2494,
        regionCode: "511700",
        regionName: "达州市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2495,
            regionCode: "511702",
            regionName: "通川区",
            parentCode: "511700",
            level: 3,
          },
          {
            id: 2496,
            regionCode: "511703",
            regionName: "达川区",
            parentCode: "511700",
            level: 3,
          },
          {
            id: 2497,
            regionCode: "511722",
            regionName: "宣汉县",
            parentCode: "511700",
            level: 3,
          },
          {
            id: 2498,
            regionCode: "511723",
            regionName: "开江县",
            parentCode: "511700",
            level: 3,
          },
          {
            id: 2499,
            regionCode: "511724",
            regionName: "大竹县",
            parentCode: "511700",
            level: 3,
          },
          {
            id: 2500,
            regionCode: "511725",
            regionName: "渠县",
            parentCode: "511700",
            level: 3,
          },
          {
            id: 2501,
            regionCode: "511781",
            regionName: "万源市",
            parentCode: "511700",
            level: 3,
          },
        ],
      },
      {
        id: 2502,
        regionCode: "511800",
        regionName: "雅安市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2503,
            regionCode: "511802",
            regionName: "雨城区",
            parentCode: "511800",
            level: 3,
          },
          {
            id: 2504,
            regionCode: "511803",
            regionName: "名山区",
            parentCode: "511800",
            level: 3,
          },
          {
            id: 2505,
            regionCode: "511822",
            regionName: "荥经县",
            parentCode: "511800",
            level: 3,
          },
          {
            id: 2506,
            regionCode: "511823",
            regionName: "汉源县",
            parentCode: "511800",
            level: 3,
          },
          {
            id: 2507,
            regionCode: "511824",
            regionName: "石棉县",
            parentCode: "511800",
            level: 3,
          },
          {
            id: 2508,
            regionCode: "511825",
            regionName: "天全县",
            parentCode: "511800",
            level: 3,
          },
          {
            id: 2509,
            regionCode: "511826",
            regionName: "芦山县",
            parentCode: "511800",
            level: 3,
          },
          {
            id: 2510,
            regionCode: "511827",
            regionName: "宝兴县",
            parentCode: "511800",
            level: 3,
          },
        ],
      },
      {
        id: 2511,
        regionCode: "511900",
        regionName: "巴中市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2512,
            regionCode: "511902",
            regionName: "巴州区",
            parentCode: "511900",
            level: 3,
          },
          {
            id: 2513,
            regionCode: "511903",
            regionName: "恩阳区",
            parentCode: "511900",
            level: 3,
          },
          {
            id: 2514,
            regionCode: "511921",
            regionName: "通江县",
            parentCode: "511900",
            level: 3,
          },
          {
            id: 2515,
            regionCode: "511922",
            regionName: "南江县",
            parentCode: "511900",
            level: 3,
          },
          {
            id: 2516,
            regionCode: "511923",
            regionName: "平昌县",
            parentCode: "511900",
            level: 3,
          },
        ],
      },
      {
        id: 2517,
        regionCode: "512000",
        regionName: "资阳市",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2518,
            regionCode: "512002",
            regionName: "雁江区",
            parentCode: "512000",
            level: 3,
          },
          {
            id: 2519,
            regionCode: "512021",
            regionName: "安岳县",
            parentCode: "512000",
            level: 3,
          },
          {
            id: 2520,
            regionCode: "512022",
            regionName: "乐至县",
            parentCode: "512000",
            level: 3,
          },
          {
            id: 2521,
            regionCode: "512081",
            regionName: "简阳市",
            parentCode: "512000",
            level: 3,
          },
        ],
      },
      {
        id: 2522,
        regionCode: "513200",
        regionName: "阿坝藏族羌族自治州",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2523,
            regionCode: "513221",
            regionName: "汶川县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2524,
            regionCode: "513222",
            regionName: "理县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2525,
            regionCode: "513223",
            regionName: "茂县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2526,
            regionCode: "513224",
            regionName: "松潘县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2527,
            regionCode: "513225",
            regionName: "九寨沟县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2528,
            regionCode: "513226",
            regionName: "金川县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2529,
            regionCode: "513227",
            regionName: "小金县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2530,
            regionCode: "513228",
            regionName: "黑水县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2531,
            regionCode: "513229",
            regionName: "马尔康县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2532,
            regionCode: "513230",
            regionName: "壤塘县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2533,
            regionCode: "513231",
            regionName: "阿坝县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2534,
            regionCode: "513232",
            regionName: "若尔盖县",
            parentCode: "513200",
            level: 3,
          },
          {
            id: 2535,
            regionCode: "513233",
            regionName: "红原县",
            parentCode: "513200",
            level: 3,
          },
        ],
      },
      {
        id: 2536,
        regionCode: "513300",
        regionName: "甘孜藏族自治州",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2537,
            regionCode: "513321",
            regionName: "康定县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2538,
            regionCode: "513322",
            regionName: "泸定县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2539,
            regionCode: "513323",
            regionName: "丹巴县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2540,
            regionCode: "513324",
            regionName: "九龙县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2541,
            regionCode: "513325",
            regionName: "雅江县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2542,
            regionCode: "513326",
            regionName: "道孚县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2543,
            regionCode: "513327",
            regionName: "炉霍县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2544,
            regionCode: "513328",
            regionName: "甘孜县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2545,
            regionCode: "513329",
            regionName: "新龙县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2546,
            regionCode: "513330",
            regionName: "德格县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2547,
            regionCode: "513331",
            regionName: "白玉县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2548,
            regionCode: "513332",
            regionName: "石渠县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2549,
            regionCode: "513333",
            regionName: "色达县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2550,
            regionCode: "513334",
            regionName: "理塘县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2551,
            regionCode: "513335",
            regionName: "巴塘县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2552,
            regionCode: "513336",
            regionName: "乡城县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2553,
            regionCode: "513337",
            regionName: "稻城县",
            parentCode: "513300",
            level: 3,
          },
          {
            id: 2554,
            regionCode: "513338",
            regionName: "得荣县",
            parentCode: "513300",
            level: 3,
          },
        ],
      },
      {
        id: 2555,
        regionCode: "513400",
        regionName: "凉山彝族自治州",
        parentCode: "510000",
        level: 2,
        children: [
          {
            id: 2556,
            regionCode: "513401",
            regionName: "西昌市",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2557,
            regionCode: "513422",
            regionName: "木里藏族自治县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2558,
            regionCode: "513423",
            regionName: "盐源县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2559,
            regionCode: "513424",
            regionName: "德昌县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2560,
            regionCode: "513425",
            regionName: "会理县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2561,
            regionCode: "513426",
            regionName: "会东县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2562,
            regionCode: "513427",
            regionName: "宁南县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2563,
            regionCode: "513428",
            regionName: "普格县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2564,
            regionCode: "513429",
            regionName: "布拖县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2565,
            regionCode: "513430",
            regionName: "金阳县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2566,
            regionCode: "513431",
            regionName: "昭觉县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2567,
            regionCode: "513432",
            regionName: "喜德县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2568,
            regionCode: "513433",
            regionName: "冕宁县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2569,
            regionCode: "513434",
            regionName: "越西县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2570,
            regionCode: "513435",
            regionName: "甘洛县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2571,
            regionCode: "513436",
            regionName: "美姑县",
            parentCode: "513400",
            level: 3,
          },
          {
            id: 2572,
            regionCode: "513437",
            regionName: "雷波县",
            parentCode: "513400",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2573,
    regionCode: "520000",
    regionName: "贵州省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2574,
        regionCode: "520100",
        regionName: "贵阳市",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2575,
            regionCode: "520102",
            regionName: "南明区",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2576,
            regionCode: "520103",
            regionName: "云岩区",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2577,
            regionCode: "520111",
            regionName: "花溪区",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2578,
            regionCode: "520112",
            regionName: "乌当区",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2579,
            regionCode: "520113",
            regionName: "白云区",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2580,
            regionCode: "520115",
            regionName: "观山湖区",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2581,
            regionCode: "520121",
            regionName: "开阳县",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2582,
            regionCode: "520122",
            regionName: "息烽县",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2583,
            regionCode: "520123",
            regionName: "修文县",
            parentCode: "520100",
            level: 3,
          },
          {
            id: 2584,
            regionCode: "520181",
            regionName: "清镇市",
            parentCode: "520100",
            level: 3,
          },
        ],
      },
      {
        id: 2585,
        regionCode: "520200",
        regionName: "六盘水市",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2586,
            regionCode: "520201",
            regionName: "钟山区",
            parentCode: "520200",
            level: 3,
          },
          {
            id: 2587,
            regionCode: "520203",
            regionName: "六枝特区",
            parentCode: "520200",
            level: 3,
          },
          {
            id: 2588,
            regionCode: "520221",
            regionName: "水城县",
            parentCode: "520200",
            level: 3,
          },
          {
            id: 2589,
            regionCode: "520222",
            regionName: "盘县",
            parentCode: "520200",
            level: 3,
          },
        ],
      },
      {
        id: 2590,
        regionCode: "520300",
        regionName: "遵义市",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2591,
            regionCode: "520302",
            regionName: "红花岗区",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2592,
            regionCode: "520303",
            regionName: "汇川区",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2593,
            regionCode: "520321",
            regionName: "遵义县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2594,
            regionCode: "520322",
            regionName: "桐梓县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2595,
            regionCode: "520323",
            regionName: "绥阳县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2596,
            regionCode: "520324",
            regionName: "正安县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2597,
            regionCode: "520325",
            regionName: "道真仡佬族苗族自治县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2598,
            regionCode: "520326",
            regionName: "务川仡佬族苗族自治县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2599,
            regionCode: "520327",
            regionName: "凤冈县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2600,
            regionCode: "520328",
            regionName: "湄潭县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2601,
            regionCode: "520329",
            regionName: "余庆县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2602,
            regionCode: "520330",
            regionName: "习水县",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2603,
            regionCode: "520381",
            regionName: "赤水市",
            parentCode: "520300",
            level: 3,
          },
          {
            id: 2604,
            regionCode: "520382",
            regionName: "仁怀市",
            parentCode: "520300",
            level: 3,
          },
        ],
      },
      {
        id: 2605,
        regionCode: "520400",
        regionName: "安顺市",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2606,
            regionCode: "520402",
            regionName: "西秀区",
            parentCode: "520400",
            level: 3,
          },
          {
            id: 2607,
            regionCode: "520421",
            regionName: "平坝区",
            parentCode: "520400",
            level: 3,
          },
          {
            id: 2608,
            regionCode: "520422",
            regionName: "普定县",
            parentCode: "520400",
            level: 3,
          },
          {
            id: 2609,
            regionCode: "520423",
            regionName: "镇宁布依族苗族自治县",
            parentCode: "520400",
            level: 3,
          },
          {
            id: 2610,
            regionCode: "520424",
            regionName: "关岭布依族苗族自治县",
            parentCode: "520400",
            level: 3,
          },
          {
            id: 2611,
            regionCode: "520425",
            regionName: "紫云苗族布依族自治县",
            parentCode: "520400",
            level: 3,
          },
        ],
      },
      {
        id: 2612,
        regionCode: "520500",
        regionName: "毕节市",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2613,
            regionCode: "520502",
            regionName: "七星关区",
            parentCode: "520500",
            level: 3,
          },
          {
            id: 2614,
            regionCode: "520521",
            regionName: "大方县",
            parentCode: "520500",
            level: 3,
          },
          {
            id: 2615,
            regionCode: "520522",
            regionName: "黔西县",
            parentCode: "520500",
            level: 3,
          },
          {
            id: 2616,
            regionCode: "520523",
            regionName: "金沙县",
            parentCode: "520500",
            level: 3,
          },
          {
            id: 2617,
            regionCode: "520524",
            regionName: "织金县",
            parentCode: "520500",
            level: 3,
          },
          {
            id: 2618,
            regionCode: "520525",
            regionName: "纳雍县",
            parentCode: "520500",
            level: 3,
          },
          {
            id: 2619,
            regionCode: "520526",
            regionName: "威宁彝族回族苗族自治县",
            parentCode: "520500",
            level: 3,
          },
          {
            id: 2620,
            regionCode: "520527",
            regionName: "赫章县",
            parentCode: "520500",
            level: 3,
          },
        ],
      },
      {
        id: 2621,
        regionCode: "520600",
        regionName: "铜仁市",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2622,
            regionCode: "520602",
            regionName: "碧江区",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2623,
            regionCode: "520603",
            regionName: "万山区",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2624,
            regionCode: "520621",
            regionName: "江口县",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2625,
            regionCode: "520622",
            regionName: "玉屏侗族自治县",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2626,
            regionCode: "520623",
            regionName: "石阡县",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2627,
            regionCode: "520624",
            regionName: "思南县",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2628,
            regionCode: "520625",
            regionName: "印江土家族苗族自治县",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2629,
            regionCode: "520626",
            regionName: "德江县",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2630,
            regionCode: "520627",
            regionName: "沿河土家族自治县",
            parentCode: "520600",
            level: 3,
          },
          {
            id: 2631,
            regionCode: "520628",
            regionName: "松桃苗族自治县",
            parentCode: "520600",
            level: 3,
          },
        ],
      },
      {
        id: 2632,
        regionCode: "522300",
        regionName: "黔西南布依族苗族自治州",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2633,
            regionCode: "522301",
            regionName: "兴义市 ",
            parentCode: "522300",
            level: 3,
          },
          {
            id: 2634,
            regionCode: "522322",
            regionName: "兴仁县",
            parentCode: "522300",
            level: 3,
          },
          {
            id: 2635,
            regionCode: "522323",
            regionName: "普安县",
            parentCode: "522300",
            level: 3,
          },
          {
            id: 2636,
            regionCode: "522324",
            regionName: "晴隆县",
            parentCode: "522300",
            level: 3,
          },
          {
            id: 2637,
            regionCode: "522325",
            regionName: "贞丰县",
            parentCode: "522300",
            level: 3,
          },
          {
            id: 2638,
            regionCode: "522326",
            regionName: "望谟县",
            parentCode: "522300",
            level: 3,
          },
          {
            id: 2639,
            regionCode: "522327",
            regionName: "册亨县",
            parentCode: "522300",
            level: 3,
          },
          {
            id: 2640,
            regionCode: "522328",
            regionName: "安龙县",
            parentCode: "522300",
            level: 3,
          },
        ],
      },
      {
        id: 2641,
        regionCode: "522600",
        regionName: "黔东南苗族侗族自治州",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2642,
            regionCode: "522601",
            regionName: "凯里市",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2643,
            regionCode: "522622",
            regionName: "黄平县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2644,
            regionCode: "522623",
            regionName: "施秉县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2645,
            regionCode: "522624",
            regionName: "三穗县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2646,
            regionCode: "522625",
            regionName: "镇远县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2647,
            regionCode: "522626",
            regionName: "岑巩县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2648,
            regionCode: "522627",
            regionName: "天柱县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2649,
            regionCode: "522628",
            regionName: "锦屏县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2650,
            regionCode: "522629",
            regionName: "剑河县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2651,
            regionCode: "522630",
            regionName: "台江县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2652,
            regionCode: "522631",
            regionName: "黎平县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2653,
            regionCode: "522632",
            regionName: "榕江县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2654,
            regionCode: "522633",
            regionName: "从江县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2655,
            regionCode: "522634",
            regionName: "雷山县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2656,
            regionCode: "522635",
            regionName: "麻江县",
            parentCode: "522600",
            level: 3,
          },
          {
            id: 2657,
            regionCode: "522636",
            regionName: "丹寨县",
            parentCode: "522600",
            level: 3,
          },
        ],
      },
      {
        id: 2658,
        regionCode: "522700",
        regionName: "黔南布依族苗族自治州",
        parentCode: "520000",
        level: 2,
        children: [
          {
            id: 2659,
            regionCode: "522701",
            regionName: "都匀市",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2660,
            regionCode: "522702",
            regionName: "福泉市",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2661,
            regionCode: "522722",
            regionName: "荔波县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2662,
            regionCode: "522723",
            regionName: "贵定县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2663,
            regionCode: "522725",
            regionName: "瓮安县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2664,
            regionCode: "522726",
            regionName: "独山县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2665,
            regionCode: "522727",
            regionName: "平塘县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2666,
            regionCode: "522728",
            regionName: "罗甸县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2667,
            regionCode: "522729",
            regionName: "长顺县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2668,
            regionCode: "522730",
            regionName: "龙里县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2669,
            regionCode: "522731",
            regionName: "惠水县",
            parentCode: "522700",
            level: 3,
          },
          {
            id: 2670,
            regionCode: "522732",
            regionName: "三都水族自治县",
            parentCode: "522700",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2671,
    regionCode: "530000",
    regionName: "云南省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2672,
        regionCode: "530100",
        regionName: "昆明市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2673,
            regionCode: "530102",
            regionName: "五华区",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2674,
            regionCode: "530103",
            regionName: "盘龙区",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2675,
            regionCode: "530111",
            regionName: "官渡区",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2676,
            regionCode: "530112",
            regionName: "西山区",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2677,
            regionCode: "530113",
            regionName: "东川区",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2678,
            regionCode: "530114",
            regionName: "呈贡区",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2679,
            regionCode: "530122",
            regionName: "晋宁县",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2680,
            regionCode: "530124",
            regionName: "富民县",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2681,
            regionCode: "530125",
            regionName: "宜良县",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2682,
            regionCode: "530126",
            regionName: "石林彝族自治县",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2683,
            regionCode: "530127",
            regionName: "嵩明县",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2684,
            regionCode: "530128",
            regionName: "禄劝彝族苗族自治县",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2685,
            regionCode: "530129",
            regionName: "寻甸回族彝族自治县 ",
            parentCode: "530100",
            level: 3,
          },
          {
            id: 2686,
            regionCode: "530181",
            regionName: "安宁市",
            parentCode: "530100",
            level: 3,
          },
        ],
      },
      {
        id: 2687,
        regionCode: "530300",
        regionName: "曲靖市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2688,
            regionCode: "530302",
            regionName: "麒麟区",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2689,
            regionCode: "530321",
            regionName: "马龙县",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2690,
            regionCode: "530322",
            regionName: "陆良县",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2691,
            regionCode: "530323",
            regionName: "师宗县",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2692,
            regionCode: "530324",
            regionName: "罗平县",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2693,
            regionCode: "530325",
            regionName: "富源县",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2694,
            regionCode: "530326",
            regionName: "会泽县",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2695,
            regionCode: "530328",
            regionName: "沾益县",
            parentCode: "530300",
            level: 3,
          },
          {
            id: 2696,
            regionCode: "530381",
            regionName: "宣威市",
            parentCode: "530300",
            level: 3,
          },
        ],
      },
      {
        id: 2697,
        regionCode: "530400",
        regionName: "玉溪市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2698,
            regionCode: "530402",
            regionName: "红塔区",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2699,
            regionCode: "530421",
            regionName: "江川县",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2700,
            regionCode: "530422",
            regionName: "澄江县",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2701,
            regionCode: "530423",
            regionName: "通海县",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2702,
            regionCode: "530424",
            regionName: "华宁县",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2703,
            regionCode: "530425",
            regionName: "易门县",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2704,
            regionCode: "530426",
            regionName: "峨山彝族自治县",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2705,
            regionCode: "530427",
            regionName: "新平彝族傣族自治县",
            parentCode: "530400",
            level: 3,
          },
          {
            id: 2706,
            regionCode: "530428",
            regionName: "元江哈尼族彝族傣族自治县",
            parentCode: "530400",
            level: 3,
          },
        ],
      },
      {
        id: 2707,
        regionCode: "530500",
        regionName: "保山市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2708,
            regionCode: "530502",
            regionName: "隆阳区",
            parentCode: "530500",
            level: 3,
          },
          {
            id: 2709,
            regionCode: "530521",
            regionName: "施甸县",
            parentCode: "530500",
            level: 3,
          },
          {
            id: 2710,
            regionCode: "530522",
            regionName: "腾冲县",
            parentCode: "530500",
            level: 3,
          },
          {
            id: 2711,
            regionCode: "530523",
            regionName: "龙陵县",
            parentCode: "530500",
            level: 3,
          },
          {
            id: 2712,
            regionCode: "530524",
            regionName: "昌宁县",
            parentCode: "530500",
            level: 3,
          },
        ],
      },
      {
        id: 2713,
        regionCode: "530600",
        regionName: "昭通市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2714,
            regionCode: "530602",
            regionName: "昭阳区",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2715,
            regionCode: "530621",
            regionName: "鲁甸县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2716,
            regionCode: "530622",
            regionName: "巧家县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2717,
            regionCode: "530623",
            regionName: "盐津县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2718,
            regionCode: "530624",
            regionName: "大关县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2719,
            regionCode: "530625",
            regionName: "永善县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2720,
            regionCode: "530626",
            regionName: "绥江县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2721,
            regionCode: "530627",
            regionName: "镇雄县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2722,
            regionCode: "530628",
            regionName: "彝良县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2723,
            regionCode: "530629",
            regionName: "威信县",
            parentCode: "530600",
            level: 3,
          },
          {
            id: 2724,
            regionCode: "530630",
            regionName: "水富县",
            parentCode: "530600",
            level: 3,
          },
        ],
      },
      {
        id: 2725,
        regionCode: "530700",
        regionName: "丽江市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2726,
            regionCode: "530702",
            regionName: "古城区",
            parentCode: "530700",
            level: 3,
          },
          {
            id: 2727,
            regionCode: "530721",
            regionName: "玉龙纳西族自治县",
            parentCode: "530700",
            level: 3,
          },
          {
            id: 2728,
            regionCode: "530722",
            regionName: "永胜县",
            parentCode: "530700",
            level: 3,
          },
          {
            id: 2729,
            regionCode: "530723",
            regionName: "华坪县",
            parentCode: "530700",
            level: 3,
          },
          {
            id: 2730,
            regionCode: "530724",
            regionName: "宁蒗彝族自治县",
            parentCode: "530700",
            level: 3,
          },
        ],
      },
      {
        id: 2731,
        regionCode: "530800",
        regionName: "普洱市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2732,
            regionCode: "530802",
            regionName: "思茅区",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2733,
            regionCode: "530821",
            regionName: "宁洱哈尼族彝族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2734,
            regionCode: "530822",
            regionName: "墨江哈尼族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2735,
            regionCode: "530823",
            regionName: "景东彝族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2736,
            regionCode: "530824",
            regionName: "景谷傣族彝族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2737,
            regionCode: "530825",
            regionName: "镇沅彝族哈尼族拉祜族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2738,
            regionCode: "530826",
            regionName: "江城哈尼族彝族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2739,
            regionCode: "530827",
            regionName: "孟连傣族拉祜族佤族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2740,
            regionCode: "530828",
            regionName: "澜沧拉祜族自治县",
            parentCode: "530800",
            level: 3,
          },
          {
            id: 2741,
            regionCode: "530829",
            regionName: "西盟佤族自治县",
            parentCode: "530800",
            level: 3,
          },
        ],
      },
      {
        id: 2742,
        regionCode: "530900",
        regionName: "临沧市",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2743,
            regionCode: "530902",
            regionName: "临翔区",
            parentCode: "530900",
            level: 3,
          },
          {
            id: 2744,
            regionCode: "530921",
            regionName: "凤庆县",
            parentCode: "530900",
            level: 3,
          },
          {
            id: 2745,
            regionCode: "530922",
            regionName: "云县",
            parentCode: "530900",
            level: 3,
          },
          {
            id: 2746,
            regionCode: "530923",
            regionName: "永德县",
            parentCode: "530900",
            level: 3,
          },
          {
            id: 2747,
            regionCode: "530924",
            regionName: "镇康县",
            parentCode: "530900",
            level: 3,
          },
          {
            id: 2748,
            regionCode: "530925",
            regionName: "双江拉祜族佤族布朗族傣族自治县",
            parentCode: "530900",
            level: 3,
          },
          {
            id: 2749,
            regionCode: "530926",
            regionName: "耿马傣族佤族自治县",
            parentCode: "530900",
            level: 3,
          },
          {
            id: 2750,
            regionCode: "530927",
            regionName: "沧源佤族自治县",
            parentCode: "530900",
            level: 3,
          },
        ],
      },
      {
        id: 2751,
        regionCode: "532300",
        regionName: "楚雄彝族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2752,
            regionCode: "532301",
            regionName: "楚雄市",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2753,
            regionCode: "532322",
            regionName: "双柏县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2754,
            regionCode: "532323",
            regionName: "牟定县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2755,
            regionCode: "532324",
            regionName: "南华县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2756,
            regionCode: "532325",
            regionName: "姚安县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2757,
            regionCode: "532326",
            regionName: "大姚县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2758,
            regionCode: "532327",
            regionName: "永仁县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2759,
            regionCode: "532328",
            regionName: "元谋县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2760,
            regionCode: "532329",
            regionName: "武定县",
            parentCode: "532300",
            level: 3,
          },
          {
            id: 2761,
            regionCode: "532331",
            regionName: "禄丰县",
            parentCode: "532300",
            level: 3,
          },
        ],
      },
      {
        id: 2762,
        regionCode: "532500",
        regionName: "红河哈尼族彝族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2763,
            regionCode: "532501",
            regionName: "个旧市",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2764,
            regionCode: "532502",
            regionName: "开远市",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2765,
            regionCode: "532503",
            regionName: "蒙自市",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2766,
            regionCode: "532504",
            regionName: "弥勒市",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2767,
            regionCode: "532523",
            regionName: "屏边苗族自治县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2768,
            regionCode: "532524",
            regionName: "建水县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2769,
            regionCode: "532525",
            regionName: "石屏县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2770,
            regionCode: "532527",
            regionName: "泸西县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2771,
            regionCode: "532528",
            regionName: "元阳县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2772,
            regionCode: "532529",
            regionName: "红河县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2773,
            regionCode: "532530",
            regionName: "金平苗族瑶族傣族自治县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2774,
            regionCode: "532531",
            regionName: "绿春县",
            parentCode: "532500",
            level: 3,
          },
          {
            id: 2775,
            regionCode: "532532",
            regionName: "河口瑶族自治县",
            parentCode: "532500",
            level: 3,
          },
        ],
      },
      {
        id: 2776,
        regionCode: "532600",
        regionName: "文山壮族苗族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2777,
            regionCode: "532601",
            regionName: "文山市",
            parentCode: "532600",
            level: 3,
          },
          {
            id: 2778,
            regionCode: "532622",
            regionName: "砚山县",
            parentCode: "532600",
            level: 3,
          },
          {
            id: 2779,
            regionCode: "532623",
            regionName: "西畴县",
            parentCode: "532600",
            level: 3,
          },
          {
            id: 2780,
            regionCode: "532624",
            regionName: "麻栗坡县",
            parentCode: "532600",
            level: 3,
          },
          {
            id: 2781,
            regionCode: "532625",
            regionName: "马关县",
            parentCode: "532600",
            level: 3,
          },
          {
            id: 2782,
            regionCode: "532626",
            regionName: "丘北县",
            parentCode: "532600",
            level: 3,
          },
          {
            id: 2783,
            regionCode: "532627",
            regionName: "广南县",
            parentCode: "532600",
            level: 3,
          },
          {
            id: 2784,
            regionCode: "532628",
            regionName: "富宁县",
            parentCode: "532600",
            level: 3,
          },
        ],
      },
      {
        id: 2785,
        regionCode: "532800",
        regionName: "西双版纳傣族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2786,
            regionCode: "532801",
            regionName: "景洪市",
            parentCode: "532800",
            level: 3,
          },
          {
            id: 2787,
            regionCode: "532822",
            regionName: "勐海县",
            parentCode: "532800",
            level: 3,
          },
          {
            id: 2788,
            regionCode: "532823",
            regionName: "勐腊县",
            parentCode: "532800",
            level: 3,
          },
        ],
      },
      {
        id: 2789,
        regionCode: "532900",
        regionName: "大理白族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2790,
            regionCode: "532901",
            regionName: "大理市",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2791,
            regionCode: "532922",
            regionName: "漾濞彝族自治县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2792,
            regionCode: "532923",
            regionName: "祥云县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2793,
            regionCode: "532924",
            regionName: "宾川县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2794,
            regionCode: "532925",
            regionName: "弥渡县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2795,
            regionCode: "532926",
            regionName: "南涧彝族自治县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2796,
            regionCode: "532927",
            regionName: "巍山彝族回族自治县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2797,
            regionCode: "532928",
            regionName: "永平县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2798,
            regionCode: "532929",
            regionName: "云龙县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2799,
            regionCode: "532930",
            regionName: "洱源县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2800,
            regionCode: "532931",
            regionName: "剑川县",
            parentCode: "532900",
            level: 3,
          },
          {
            id: 2801,
            regionCode: "532932",
            regionName: "鹤庆县",
            parentCode: "532900",
            level: 3,
          },
        ],
      },
      {
        id: 2802,
        regionCode: "533100",
        regionName: "德宏傣族景颇族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2803,
            regionCode: "533102",
            regionName: "瑞丽市",
            parentCode: "533100",
            level: 3,
          },
          {
            id: 2804,
            regionCode: "533103",
            regionName: "芒市",
            parentCode: "533100",
            level: 3,
          },
          {
            id: 2805,
            regionCode: "533122",
            regionName: "梁河县",
            parentCode: "533100",
            level: 3,
          },
          {
            id: 2806,
            regionCode: "533123",
            regionName: "盈江县",
            parentCode: "533100",
            level: 3,
          },
          {
            id: 2807,
            regionCode: "533124",
            regionName: "陇川县",
            parentCode: "533100",
            level: 3,
          },
        ],
      },
      {
        id: 2808,
        regionCode: "533300",
        regionName: "怒江傈僳族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2809,
            regionCode: "533321",
            regionName: "泸水县",
            parentCode: "533300",
            level: 3,
          },
          {
            id: 2810,
            regionCode: "533323",
            regionName: "福贡县",
            parentCode: "533300",
            level: 3,
          },
          {
            id: 2811,
            regionCode: "533324",
            regionName: "贡山独龙族怒族自治县",
            parentCode: "533300",
            level: 3,
          },
          {
            id: 2812,
            regionCode: "533325",
            regionName: "兰坪白族普米族自治县",
            parentCode: "533300",
            level: 3,
          },
        ],
      },
      {
        id: 2813,
        regionCode: "533400",
        regionName: "迪庆藏族自治州",
        parentCode: "530000",
        level: 2,
        children: [
          {
            id: 2814,
            regionCode: "533421",
            regionName: "香格里拉市",
            parentCode: "533400",
            level: 3,
          },
          {
            id: 2815,
            regionCode: "533422",
            regionName: "德钦县",
            parentCode: "533400",
            level: 3,
          },
          {
            id: 2816,
            regionCode: "533423",
            regionName: "维西傈僳族自治县",
            parentCode: "533400",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2817,
    regionCode: "540000",
    regionName: "西藏自治区",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2818,
        regionCode: "540100",
        regionName: "拉萨市",
        parentCode: "540000",
        level: 2,
        children: [
          {
            id: 2819,
            regionCode: "540102",
            regionName: "城关区",
            parentCode: "540100",
            level: 3,
          },
          {
            id: 2820,
            regionCode: "540121",
            regionName: "林周县",
            parentCode: "540100",
            level: 3,
          },
          {
            id: 2821,
            regionCode: "540122",
            regionName: "当雄县",
            parentCode: "540100",
            level: 3,
          },
          {
            id: 2822,
            regionCode: "540123",
            regionName: "尼木县",
            parentCode: "540100",
            level: 3,
          },
          {
            id: 2823,
            regionCode: "540124",
            regionName: "曲水县",
            parentCode: "540100",
            level: 3,
          },
          {
            id: 2824,
            regionCode: "540125",
            regionName: "堆龙德庆县",
            parentCode: "540100",
            level: 3,
          },
          {
            id: 2825,
            regionCode: "540126",
            regionName: "达孜县",
            parentCode: "540100",
            level: 3,
          },
          {
            id: 2826,
            regionCode: "540127",
            regionName: "墨竹工卡县",
            parentCode: "540100",
            level: 3,
          },
        ],
      },
      {
        id: 2827,
        regionCode: "540200",
        regionName: "日喀则市",
        parentCode: "540000",
        level: 2,
        children: [
          {
            id: 2828,
            regionCode: "540202",
            regionName: "桑珠孜区",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2829,
            regionCode: "540221",
            regionName: "南木林县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2830,
            regionCode: "540222",
            regionName: "江孜县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2831,
            regionCode: "540223",
            regionName: "定日县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2832,
            regionCode: "540224",
            regionName: "萨迦县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2833,
            regionCode: "540225",
            regionName: "拉孜县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2834,
            regionCode: "540226",
            regionName: "昂仁县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2835,
            regionCode: "540227",
            regionName: "谢通门县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2836,
            regionCode: "540228",
            regionName: "白朗县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2837,
            regionCode: "540229",
            regionName: "仁布县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2838,
            regionCode: "540230",
            regionName: "康马县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2839,
            regionCode: "540231",
            regionName: "定结县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2840,
            regionCode: "540232",
            regionName: "仲巴县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2841,
            regionCode: "540233",
            regionName: "亚东县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2842,
            regionCode: "540234",
            regionName: "吉隆县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2843,
            regionCode: "540235",
            regionName: "聂拉木县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2844,
            regionCode: "540236",
            regionName: "萨嘎县",
            parentCode: "540200",
            level: 3,
          },
          {
            id: 2845,
            regionCode: "540237",
            regionName: "岗巴县",
            parentCode: "540200",
            level: 3,
          },
        ],
      },
      {
        id: 2846,
        regionCode: "540300",
        regionName: "昌都市",
        parentCode: "540000",
        level: 2,
        children: [
          {
            id: 2847,
            regionCode: "540302",
            regionName: "卡若区",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2848,
            regionCode: "540321",
            regionName: "江达县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2849,
            regionCode: "540322",
            regionName: "贡觉县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2850,
            regionCode: "540323",
            regionName: "类乌齐县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2851,
            regionCode: "540324",
            regionName: "丁青县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2852,
            regionCode: "540325",
            regionName: "察雅县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2853,
            regionCode: "540326",
            regionName: "八宿县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2854,
            regionCode: "540327",
            regionName: "左贡县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2855,
            regionCode: "540328",
            regionName: "芒康县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2856,
            regionCode: "540329",
            regionName: "洛隆县",
            parentCode: "540300",
            level: 3,
          },
          {
            id: 2857,
            regionCode: "540330",
            regionName: "边坝县",
            parentCode: "540300",
            level: 3,
          },
        ],
      },
      {
        id: 2858,
        regionCode: "542200",
        regionName: "山南地区",
        parentCode: "540000",
        level: 2,
        children: [
          {
            id: 2859,
            regionCode: "542221",
            regionName: "乃东县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2860,
            regionCode: "542222",
            regionName: "扎囊县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2861,
            regionCode: "542223",
            regionName: "贡嘎县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2862,
            regionCode: "542224",
            regionName: "桑日县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2863,
            regionCode: "542225",
            regionName: "琼结县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2864,
            regionCode: "542226",
            regionName: "曲松县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2865,
            regionCode: "542227",
            regionName: "措美县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2866,
            regionCode: "542228",
            regionName: "洛扎县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2867,
            regionCode: "542229",
            regionName: "加查县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2868,
            regionCode: "542231",
            regionName: "隆子县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2869,
            regionCode: "542232",
            regionName: "错那县",
            parentCode: "542200",
            level: 3,
          },
          {
            id: 2870,
            regionCode: "542233",
            regionName: "浪卡子县",
            parentCode: "542200",
            level: 3,
          },
        ],
      },
      {
        id: 2871,
        regionCode: "542400",
        regionName: "那曲地区",
        parentCode: "540000",
        level: 2,
        children: [
          {
            id: 2872,
            regionCode: "542421",
            regionName: "那曲县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2873,
            regionCode: "542422",
            regionName: "嘉黎县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2874,
            regionCode: "542423",
            regionName: "比如县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2875,
            regionCode: "542424",
            regionName: "聂荣县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2876,
            regionCode: "542425",
            regionName: "安多县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2877,
            regionCode: "542426",
            regionName: "申扎县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2878,
            regionCode: "542427",
            regionName: "索县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2879,
            regionCode: "542428",
            regionName: "班戈县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2880,
            regionCode: "542429",
            regionName: "巴青县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2881,
            regionCode: "542430",
            regionName: "尼玛县",
            parentCode: "542400",
            level: 3,
          },
          {
            id: 2882,
            regionCode: "542431",
            regionName: "双湖县",
            parentCode: "542400",
            level: 3,
          },
        ],
      },
      {
        id: 2883,
        regionCode: "542500",
        regionName: "阿里地区",
        parentCode: "540000",
        level: 2,
        children: [
          {
            id: 2884,
            regionCode: "542521",
            regionName: "普兰县",
            parentCode: "542500",
            level: 3,
          },
          {
            id: 2885,
            regionCode: "542522",
            regionName: "札达县",
            parentCode: "542500",
            level: 3,
          },
          {
            id: 2886,
            regionCode: "542523",
            regionName: "噶尔县",
            parentCode: "542500",
            level: 3,
          },
          {
            id: 2887,
            regionCode: "542524",
            regionName: "日土县",
            parentCode: "542500",
            level: 3,
          },
          {
            id: 2888,
            regionCode: "542525",
            regionName: "革吉县",
            parentCode: "542500",
            level: 3,
          },
          {
            id: 2889,
            regionCode: "542526",
            regionName: "改则县",
            parentCode: "542500",
            level: 3,
          },
          {
            id: 2890,
            regionCode: "542527",
            regionName: "措勤县",
            parentCode: "542500",
            level: 3,
          },
        ],
      },
      {
        id: 2891,
        regionCode: "542600",
        regionName: "林芝地区",
        parentCode: "540000",
        level: 2,
        children: [
          {
            id: 2892,
            regionCode: "542621",
            regionName: "林芝县",
            parentCode: "542600",
            level: 3,
          },
          {
            id: 2893,
            regionCode: "542622",
            regionName: "工布江达县",
            parentCode: "542600",
            level: 3,
          },
          {
            id: 2894,
            regionCode: "542623",
            regionName: "米林县",
            parentCode: "542600",
            level: 3,
          },
          {
            id: 2895,
            regionCode: "542624",
            regionName: "墨脱县",
            parentCode: "542600",
            level: 3,
          },
          {
            id: 2896,
            regionCode: "542625",
            regionName: "波密县",
            parentCode: "542600",
            level: 3,
          },
          {
            id: 2897,
            regionCode: "542626",
            regionName: "察隅县",
            parentCode: "542600",
            level: 3,
          },
          {
            id: 2898,
            regionCode: "542627",
            regionName: "朗县",
            parentCode: "542600",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 2899,
    regionCode: "610000",
    regionName: "陕西省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 2900,
        regionCode: "610100",
        regionName: "西安市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2901,
            regionCode: "610102",
            regionName: "新城区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2902,
            regionCode: "610103",
            regionName: "碑林区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2903,
            regionCode: "610104",
            regionName: "莲湖区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2904,
            regionCode: "610111",
            regionName: "灞桥区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2905,
            regionCode: "610112",
            regionName: "未央区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2906,
            regionCode: "610113",
            regionName: "雁塔区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2907,
            regionCode: "610114",
            regionName: "阎良区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2908,
            regionCode: "610115",
            regionName: "临潼区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2909,
            regionCode: "610116",
            regionName: "长安区",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2910,
            regionCode: "610122",
            regionName: "蓝田县",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2911,
            regionCode: "610124",
            regionName: "周至县",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2912,
            regionCode: "610125",
            regionName: "户县",
            parentCode: "610100",
            level: 3,
          },
          {
            id: 2913,
            regionCode: "610126",
            regionName: "高陵区",
            parentCode: "610100",
            level: 3,
          },
        ],
      },
      {
        id: 2914,
        regionCode: "610200",
        regionName: "铜川市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2915,
            regionCode: "610202",
            regionName: "王益区",
            parentCode: "610200",
            level: 3,
          },
          {
            id: 2916,
            regionCode: "610203",
            regionName: "印台区",
            parentCode: "610200",
            level: 3,
          },
          {
            id: 2917,
            regionCode: "610204",
            regionName: "耀州区",
            parentCode: "610200",
            level: 3,
          },
          {
            id: 2918,
            regionCode: "610222",
            regionName: "宜君县",
            parentCode: "610200",
            level: 3,
          },
        ],
      },
      {
        id: 2919,
        regionCode: "610300",
        regionName: "宝鸡市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2920,
            regionCode: "610302",
            regionName: "渭滨区",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2921,
            regionCode: "610303",
            regionName: "金台区",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2922,
            regionCode: "610304",
            regionName: "陈仓区",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2923,
            regionCode: "610322",
            regionName: "凤翔县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2924,
            regionCode: "610323",
            regionName: "岐山县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2925,
            regionCode: "610324",
            regionName: "扶风县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2926,
            regionCode: "610326",
            regionName: "眉县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2927,
            regionCode: "610327",
            regionName: "陇县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2928,
            regionCode: "610328",
            regionName: "千阳县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2929,
            regionCode: "610329",
            regionName: "麟游县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2930,
            regionCode: "610330",
            regionName: "凤县",
            parentCode: "610300",
            level: 3,
          },
          {
            id: 2931,
            regionCode: "610331",
            regionName: "太白县",
            parentCode: "610300",
            level: 3,
          },
        ],
      },
      {
        id: 2932,
        regionCode: "610400",
        regionName: "咸阳市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2933,
            regionCode: "610402",
            regionName: "秦都区",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2934,
            regionCode: "610403",
            regionName: "杨陵区",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2935,
            regionCode: "610404",
            regionName: "渭城区",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2936,
            regionCode: "610422",
            regionName: "三原县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2937,
            regionCode: "610423",
            regionName: "泾阳县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2938,
            regionCode: "610424",
            regionName: "乾县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2939,
            regionCode: "610425",
            regionName: "礼泉县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2940,
            regionCode: "610426",
            regionName: "永寿县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2941,
            regionCode: "610427",
            regionName: "彬县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2942,
            regionCode: "610428",
            regionName: "长武县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2943,
            regionCode: "610429",
            regionName: "旬邑县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2944,
            regionCode: "610430",
            regionName: "淳化县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2945,
            regionCode: "610431",
            regionName: "武功县",
            parentCode: "610400",
            level: 3,
          },
          {
            id: 2946,
            regionCode: "610481",
            regionName: "兴平市",
            parentCode: "610400",
            level: 3,
          },
        ],
      },
      {
        id: 2947,
        regionCode: "610500",
        regionName: "渭南市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2948,
            regionCode: "610502",
            regionName: "临渭区",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2949,
            regionCode: "610521",
            regionName: "华县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2950,
            regionCode: "610522",
            regionName: "潼关县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2951,
            regionCode: "610523",
            regionName: "大荔县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2952,
            regionCode: "610524",
            regionName: "合阳县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2953,
            regionCode: "610525",
            regionName: "澄城县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2954,
            regionCode: "610526",
            regionName: "蒲城县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2955,
            regionCode: "610527",
            regionName: "白水县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2956,
            regionCode: "610528",
            regionName: "富平县",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2957,
            regionCode: "610581",
            regionName: "韩城市",
            parentCode: "610500",
            level: 3,
          },
          {
            id: 2958,
            regionCode: "610582",
            regionName: "华阴市",
            parentCode: "610500",
            level: 3,
          },
        ],
      },
      {
        id: 2959,
        regionCode: "610600",
        regionName: "延安市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2960,
            regionCode: "610602",
            regionName: "宝塔区",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2961,
            regionCode: "610621",
            regionName: "延长县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2962,
            regionCode: "610622",
            regionName: "延川县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2963,
            regionCode: "610623",
            regionName: "子长县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2964,
            regionCode: "610624",
            regionName: "安塞县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2965,
            regionCode: "610625",
            regionName: "志丹县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2966,
            regionCode: "610626",
            regionName: "吴起县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2967,
            regionCode: "610627",
            regionName: "甘泉县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2968,
            regionCode: "610628",
            regionName: "富县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2969,
            regionCode: "610629",
            regionName: "洛川县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2970,
            regionCode: "610630",
            regionName: "宜川县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2971,
            regionCode: "610631",
            regionName: "黄龙县",
            parentCode: "610600",
            level: 3,
          },
          {
            id: 2972,
            regionCode: "610632",
            regionName: "黄陵县",
            parentCode: "610600",
            level: 3,
          },
        ],
      },
      {
        id: 2973,
        regionCode: "610700",
        regionName: "汉中市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2974,
            regionCode: "610702",
            regionName: "汉台区",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2975,
            regionCode: "610721",
            regionName: "南郑县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2976,
            regionCode: "610722",
            regionName: "城固县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2977,
            regionCode: "610723",
            regionName: "洋县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2978,
            regionCode: "610724",
            regionName: "西乡县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2979,
            regionCode: "610725",
            regionName: "勉县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2980,
            regionCode: "610726",
            regionName: "宁强县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2981,
            regionCode: "610727",
            regionName: "略阳县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2982,
            regionCode: "610728",
            regionName: "镇巴县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2983,
            regionCode: "610729",
            regionName: "留坝县",
            parentCode: "610700",
            level: 3,
          },
          {
            id: 2984,
            regionCode: "610730",
            regionName: "佛坪县",
            parentCode: "610700",
            level: 3,
          },
        ],
      },
      {
        id: 2985,
        regionCode: "610800",
        regionName: "榆林市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2986,
            regionCode: "610802",
            regionName: "榆阳区",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2987,
            regionCode: "610821",
            regionName: "神木县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2988,
            regionCode: "610822",
            regionName: "府谷县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2989,
            regionCode: "610823",
            regionName: "横山县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2990,
            regionCode: "610824",
            regionName: "靖边县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2991,
            regionCode: "610825",
            regionName: "定边县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2992,
            regionCode: "610826",
            regionName: "绥德县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2993,
            regionCode: "610827",
            regionName: "米脂县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2994,
            regionCode: "610828",
            regionName: "佳县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2995,
            regionCode: "610829",
            regionName: "吴堡县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2996,
            regionCode: "610830",
            regionName: "清涧县",
            parentCode: "610800",
            level: 3,
          },
          {
            id: 2997,
            regionCode: "610831",
            regionName: "子洲县",
            parentCode: "610800",
            level: 3,
          },
        ],
      },
      {
        id: 2998,
        regionCode: "610900",
        regionName: "安康市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 2999,
            regionCode: "610902",
            regionName: "汉滨区",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3000,
            regionCode: "610921",
            regionName: "汉阴县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3001,
            regionCode: "610922",
            regionName: "石泉县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3002,
            regionCode: "610923",
            regionName: "宁陕县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3003,
            regionCode: "610924",
            regionName: "紫阳县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3004,
            regionCode: "610925",
            regionName: "岚皋县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3005,
            regionCode: "610926",
            regionName: "平利县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3006,
            regionCode: "610927",
            regionName: "镇坪县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3007,
            regionCode: "610928",
            regionName: "旬阳县",
            parentCode: "610900",
            level: 3,
          },
          {
            id: 3008,
            regionCode: "610929",
            regionName: "白河县",
            parentCode: "610900",
            level: 3,
          },
        ],
      },
      {
        id: 3009,
        regionCode: "611000",
        regionName: "商洛市",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 3010,
            regionCode: "611002",
            regionName: "商州区",
            parentCode: "611000",
            level: 3,
          },
          {
            id: 3011,
            regionCode: "611021",
            regionName: "洛南县",
            parentCode: "611000",
            level: 3,
          },
          {
            id: 3012,
            regionCode: "611022",
            regionName: "丹凤县",
            parentCode: "611000",
            level: 3,
          },
          {
            id: 3013,
            regionCode: "611023",
            regionName: "商南县",
            parentCode: "611000",
            level: 3,
          },
          {
            id: 3014,
            regionCode: "611024",
            regionName: "山阳县",
            parentCode: "611000",
            level: 3,
          },
          {
            id: 3015,
            regionCode: "611025",
            regionName: "镇安县",
            parentCode: "611000",
            level: 3,
          },
          {
            id: 3016,
            regionCode: "611026",
            regionName: "柞水县",
            parentCode: "611000",
            level: 3,
          },
        ],
      },
      {
        id: 3017,
        regionCode: "611100",
        regionName: "西咸新区",
        parentCode: "610000",
        level: 2,
        children: [
          {
            id: 3018,
            regionCode: "611101",
            regionName: "空港新城",
            parentCode: "611100",
            level: 3,
          },
          {
            id: 3019,
            regionCode: "611102",
            regionName: "沣东新城",
            parentCode: "611100",
            level: 3,
          },
          {
            id: 3020,
            regionCode: "611103",
            regionName: "秦汉新城",
            parentCode: "611100",
            level: 3,
          },
          {
            id: 3021,
            regionCode: "611104",
            regionName: "沣西新城",
            parentCode: "611100",
            level: 3,
          },
          {
            id: 3022,
            regionCode: "611105",
            regionName: "泾河新城",
            parentCode: "611100",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3023,
    regionCode: "620000",
    regionName: "甘肃省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3024,
        regionCode: "620100",
        regionName: "兰州市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3025,
            regionCode: "620102",
            regionName: "城关区",
            parentCode: "620100",
            level: 3,
          },
          {
            id: 3026,
            regionCode: "620103",
            regionName: "七里河区",
            parentCode: "620100",
            level: 3,
          },
          {
            id: 3027,
            regionCode: "620104",
            regionName: "西固区",
            parentCode: "620100",
            level: 3,
          },
          {
            id: 3028,
            regionCode: "620105",
            regionName: "安宁区",
            parentCode: "620100",
            level: 3,
          },
          {
            id: 3029,
            regionCode: "620111",
            regionName: "红古区",
            parentCode: "620100",
            level: 3,
          },
          {
            id: 3030,
            regionCode: "620121",
            regionName: "永登县",
            parentCode: "620100",
            level: 3,
          },
          {
            id: 3031,
            regionCode: "620122",
            regionName: "皋兰县",
            parentCode: "620100",
            level: 3,
          },
          {
            id: 3032,
            regionCode: "620123",
            regionName: "榆中县",
            parentCode: "620100",
            level: 3,
          },
        ],
      },
      {
        id: 3033,
        regionCode: "620200",
        regionName: "嘉峪关市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3034,
            regionCode: "620201",
            regionName: "雄关区",
            parentCode: "620200",
            level: 3,
          },
          {
            id: 3035,
            regionCode: "620202",
            regionName: "长城区",
            parentCode: "620200",
            level: 3,
          },
          {
            id: 3036,
            regionCode: "620203",
            regionName: "镜铁区",
            parentCode: "620200",
            level: 3,
          },
        ],
      },
      {
        id: 3037,
        regionCode: "620300",
        regionName: "金昌市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3038,
            regionCode: "620302",
            regionName: "金川区",
            parentCode: "620300",
            level: 3,
          },
          {
            id: 3039,
            regionCode: "620321",
            regionName: "永昌县",
            parentCode: "620300",
            level: 3,
          },
        ],
      },
      {
        id: 3040,
        regionCode: "620400",
        regionName: "白银市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3041,
            regionCode: "620402",
            regionName: "白银区",
            parentCode: "620400",
            level: 3,
          },
          {
            id: 3042,
            regionCode: "620403",
            regionName: "平川区",
            parentCode: "620400",
            level: 3,
          },
          {
            id: 3043,
            regionCode: "620421",
            regionName: "靖远县",
            parentCode: "620400",
            level: 3,
          },
          {
            id: 3044,
            regionCode: "620422",
            regionName: "会宁县",
            parentCode: "620400",
            level: 3,
          },
          {
            id: 3045,
            regionCode: "620423",
            regionName: "景泰县",
            parentCode: "620400",
            level: 3,
          },
        ],
      },
      {
        id: 3046,
        regionCode: "620500",
        regionName: "天水市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3047,
            regionCode: "620502",
            regionName: "秦州区",
            parentCode: "620500",
            level: 3,
          },
          {
            id: 3048,
            regionCode: "620503",
            regionName: "麦积区",
            parentCode: "620500",
            level: 3,
          },
          {
            id: 3049,
            regionCode: "620521",
            regionName: "清水县",
            parentCode: "620500",
            level: 3,
          },
          {
            id: 3050,
            regionCode: "620522",
            regionName: "秦安县",
            parentCode: "620500",
            level: 3,
          },
          {
            id: 3051,
            regionCode: "620523",
            regionName: "甘谷县",
            parentCode: "620500",
            level: 3,
          },
          {
            id: 3052,
            regionCode: "620524",
            regionName: "武山县",
            parentCode: "620500",
            level: 3,
          },
          {
            id: 3053,
            regionCode: "620525",
            regionName: "张家川回族自治县",
            parentCode: "620500",
            level: 3,
          },
        ],
      },
      {
        id: 3054,
        regionCode: "620600",
        regionName: "武威市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3055,
            regionCode: "620602",
            regionName: "凉州区",
            parentCode: "620600",
            level: 3,
          },
          {
            id: 3056,
            regionCode: "620621",
            regionName: "民勤县",
            parentCode: "620600",
            level: 3,
          },
          {
            id: 3057,
            regionCode: "620622",
            regionName: "古浪县",
            parentCode: "620600",
            level: 3,
          },
          {
            id: 3058,
            regionCode: "620623",
            regionName: "天祝藏族自治县",
            parentCode: "620600",
            level: 3,
          },
        ],
      },
      {
        id: 3059,
        regionCode: "620700",
        regionName: "张掖市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3060,
            regionCode: "620702",
            regionName: "甘州区",
            parentCode: "620700",
            level: 3,
          },
          {
            id: 3061,
            regionCode: "620721",
            regionName: "肃南裕固族自治县",
            parentCode: "620700",
            level: 3,
          },
          {
            id: 3062,
            regionCode: "620722",
            regionName: "民乐县",
            parentCode: "620700",
            level: 3,
          },
          {
            id: 3063,
            regionCode: "620723",
            regionName: "临泽县",
            parentCode: "620700",
            level: 3,
          },
          {
            id: 3064,
            regionCode: "620724",
            regionName: "高台县",
            parentCode: "620700",
            level: 3,
          },
          {
            id: 3065,
            regionCode: "620725",
            regionName: "山丹县",
            parentCode: "620700",
            level: 3,
          },
        ],
      },
      {
        id: 3066,
        regionCode: "620800",
        regionName: "平凉市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3067,
            regionCode: "620802",
            regionName: "崆峒区",
            parentCode: "620800",
            level: 3,
          },
          {
            id: 3068,
            regionCode: "620821",
            regionName: "泾川县",
            parentCode: "620800",
            level: 3,
          },
          {
            id: 3069,
            regionCode: "620822",
            regionName: "灵台县",
            parentCode: "620800",
            level: 3,
          },
          {
            id: 3070,
            regionCode: "620823",
            regionName: "崇信县",
            parentCode: "620800",
            level: 3,
          },
          {
            id: 3071,
            regionCode: "620824",
            regionName: "华亭县",
            parentCode: "620800",
            level: 3,
          },
          {
            id: 3072,
            regionCode: "620825",
            regionName: "庄浪县",
            parentCode: "620800",
            level: 3,
          },
          {
            id: 3073,
            regionCode: "620826",
            regionName: "静宁县",
            parentCode: "620800",
            level: 3,
          },
        ],
      },
      {
        id: 3074,
        regionCode: "620900",
        regionName: "酒泉市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3075,
            regionCode: "620902",
            regionName: "肃州区",
            parentCode: "620900",
            level: 3,
          },
          {
            id: 3076,
            regionCode: "620921",
            regionName: "金塔县",
            parentCode: "620900",
            level: 3,
          },
          {
            id: 3077,
            regionCode: "620922",
            regionName: "瓜州县",
            parentCode: "620900",
            level: 3,
          },
          {
            id: 3078,
            regionCode: "620923",
            regionName: "肃北蒙古族自治县",
            parentCode: "620900",
            level: 3,
          },
          {
            id: 3079,
            regionCode: "620924",
            regionName: "阿克塞哈萨克族自治县",
            parentCode: "620900",
            level: 3,
          },
          {
            id: 3080,
            regionCode: "620981",
            regionName: "玉门市",
            parentCode: "620900",
            level: 3,
          },
          {
            id: 3081,
            regionCode: "620982",
            regionName: "敦煌市",
            parentCode: "620900",
            level: 3,
          },
        ],
      },
      {
        id: 3082,
        regionCode: "621000",
        regionName: "庆阳市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3083,
            regionCode: "621002",
            regionName: "西峰区",
            parentCode: "621000",
            level: 3,
          },
          {
            id: 3084,
            regionCode: "621021",
            regionName: "庆城县",
            parentCode: "621000",
            level: 3,
          },
          {
            id: 3085,
            regionCode: "621022",
            regionName: "环县",
            parentCode: "621000",
            level: 3,
          },
          {
            id: 3086,
            regionCode: "621023",
            regionName: "华池县",
            parentCode: "621000",
            level: 3,
          },
          {
            id: 3087,
            regionCode: "621024",
            regionName: "合水县",
            parentCode: "621000",
            level: 3,
          },
          {
            id: 3088,
            regionCode: "621025",
            regionName: "正宁县",
            parentCode: "621000",
            level: 3,
          },
          {
            id: 3089,
            regionCode: "621026",
            regionName: "宁县",
            parentCode: "621000",
            level: 3,
          },
          {
            id: 3090,
            regionCode: "621027",
            regionName: "镇原县",
            parentCode: "621000",
            level: 3,
          },
        ],
      },
      {
        id: 3091,
        regionCode: "621100",
        regionName: "定西市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3092,
            regionCode: "621102",
            regionName: "安定区",
            parentCode: "621100",
            level: 3,
          },
          {
            id: 3093,
            regionCode: "621121",
            regionName: "通渭县",
            parentCode: "621100",
            level: 3,
          },
          {
            id: 3094,
            regionCode: "621122",
            regionName: "陇西县",
            parentCode: "621100",
            level: 3,
          },
          {
            id: 3095,
            regionCode: "621123",
            regionName: "渭源县",
            parentCode: "621100",
            level: 3,
          },
          {
            id: 3096,
            regionCode: "621124",
            regionName: "临洮县",
            parentCode: "621100",
            level: 3,
          },
          {
            id: 3097,
            regionCode: "621125",
            regionName: "漳县",
            parentCode: "621100",
            level: 3,
          },
          {
            id: 3098,
            regionCode: "621126",
            regionName: "岷县",
            parentCode: "621100",
            level: 3,
          },
        ],
      },
      {
        id: 3099,
        regionCode: "621200",
        regionName: "陇南市",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3100,
            regionCode: "621202",
            regionName: "武都区",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3101,
            regionCode: "621221",
            regionName: "成县",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3102,
            regionCode: "621222",
            regionName: "文县",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3103,
            regionCode: "621223",
            regionName: "宕昌县",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3104,
            regionCode: "621224",
            regionName: "康县",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3105,
            regionCode: "621225",
            regionName: "西和县",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3106,
            regionCode: "621226",
            regionName: "礼县",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3107,
            regionCode: "621227",
            regionName: "徽县",
            parentCode: "621200",
            level: 3,
          },
          {
            id: 3108,
            regionCode: "621228",
            regionName: "两当县",
            parentCode: "621200",
            level: 3,
          },
        ],
      },
      {
        id: 3109,
        regionCode: "622900",
        regionName: "临夏回族自治州",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3110,
            regionCode: "622901",
            regionName: "临夏市",
            parentCode: "622900",
            level: 3,
          },
          {
            id: 3111,
            regionCode: "622921",
            regionName: "临夏县",
            parentCode: "622900",
            level: 3,
          },
          {
            id: 3112,
            regionCode: "622922",
            regionName: "康乐县",
            parentCode: "622900",
            level: 3,
          },
          {
            id: 3113,
            regionCode: "622923",
            regionName: "永靖县",
            parentCode: "622900",
            level: 3,
          },
          {
            id: 3114,
            regionCode: "622924",
            regionName: "广河县",
            parentCode: "622900",
            level: 3,
          },
          {
            id: 3115,
            regionCode: "622925",
            regionName: "和政县",
            parentCode: "622900",
            level: 3,
          },
          {
            id: 3116,
            regionCode: "622926",
            regionName: "东乡族自治县",
            parentCode: "622900",
            level: 3,
          },
          {
            id: 3117,
            regionCode: "622927",
            regionName: "积石山保安族东乡族撒拉族自治县",
            parentCode: "622900",
            level: 3,
          },
        ],
      },
      {
        id: 3118,
        regionCode: "623000",
        regionName: "甘南藏族自治州",
        parentCode: "620000",
        level: 2,
        children: [
          {
            id: 3119,
            regionCode: "623001",
            regionName: "合作市",
            parentCode: "623000",
            level: 3,
          },
          {
            id: 3120,
            regionCode: "623021",
            regionName: "临潭县",
            parentCode: "623000",
            level: 3,
          },
          {
            id: 3121,
            regionCode: "623022",
            regionName: "卓尼县",
            parentCode: "623000",
            level: 3,
          },
          {
            id: 3122,
            regionCode: "623023",
            regionName: "舟曲县",
            parentCode: "623000",
            level: 3,
          },
          {
            id: 3123,
            regionCode: "623024",
            regionName: "迭部县",
            parentCode: "623000",
            level: 3,
          },
          {
            id: 3124,
            regionCode: "623025",
            regionName: "玛曲县",
            parentCode: "623000",
            level: 3,
          },
          {
            id: 3125,
            regionCode: "623026",
            regionName: "碌曲县",
            parentCode: "623000",
            level: 3,
          },
          {
            id: 3126,
            regionCode: "623027",
            regionName: "夏河县",
            parentCode: "623000",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3127,
    regionCode: "630000",
    regionName: "青海省",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3128,
        regionCode: "630100",
        regionName: "西宁市",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3129,
            regionCode: "630102",
            regionName: "城东区",
            parentCode: "630100",
            level: 3,
          },
          {
            id: 3130,
            regionCode: "630103",
            regionName: "城中区",
            parentCode: "630100",
            level: 3,
          },
          {
            id: 3131,
            regionCode: "630104",
            regionName: "城西区",
            parentCode: "630100",
            level: 3,
          },
          {
            id: 3132,
            regionCode: "630105",
            regionName: "城北区",
            parentCode: "630100",
            level: 3,
          },
          {
            id: 3133,
            regionCode: "630121",
            regionName: "大通回族土族自治县",
            parentCode: "630100",
            level: 3,
          },
          {
            id: 3134,
            regionCode: "630122",
            regionName: "湟中县",
            parentCode: "630100",
            level: 3,
          },
          {
            id: 3135,
            regionCode: "630123",
            regionName: "湟源县",
            parentCode: "630100",
            level: 3,
          },
        ],
      },
      {
        id: 3136,
        regionCode: "630200",
        regionName: "海东市",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3137,
            regionCode: "630202",
            regionName: "乐都区",
            parentCode: "630200",
            level: 3,
          },
          {
            id: 3138,
            regionCode: "630221",
            regionName: "平安县",
            parentCode: "630200",
            level: 3,
          },
          {
            id: 3139,
            regionCode: "630222",
            regionName: "民和回族土族自治县",
            parentCode: "630200",
            level: 3,
          },
          {
            id: 3140,
            regionCode: "630223",
            regionName: "互助土族自治县",
            parentCode: "630200",
            level: 3,
          },
          {
            id: 3141,
            regionCode: "630224",
            regionName: "化隆回族自治县",
            parentCode: "630200",
            level: 3,
          },
          {
            id: 3142,
            regionCode: "630225",
            regionName: "循化撒拉族自治县",
            parentCode: "630200",
            level: 3,
          },
        ],
      },
      {
        id: 3143,
        regionCode: "632200",
        regionName: "海北藏族自治州",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3144,
            regionCode: "632221",
            regionName: "门源回族自治县",
            parentCode: "632200",
            level: 3,
          },
          {
            id: 3145,
            regionCode: "632222",
            regionName: "祁连县",
            parentCode: "632200",
            level: 3,
          },
          {
            id: 3146,
            regionCode: "632223",
            regionName: "海晏县",
            parentCode: "632200",
            level: 3,
          },
          {
            id: 3147,
            regionCode: "632224",
            regionName: "刚察县",
            parentCode: "632200",
            level: 3,
          },
        ],
      },
      {
        id: 3148,
        regionCode: "632300",
        regionName: "黄南藏族自治州",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3149,
            regionCode: "632321",
            regionName: "同仁县",
            parentCode: "632300",
            level: 3,
          },
          {
            id: 3150,
            regionCode: "632322",
            regionName: "尖扎县",
            parentCode: "632300",
            level: 3,
          },
          {
            id: 3151,
            regionCode: "632323",
            regionName: "泽库县",
            parentCode: "632300",
            level: 3,
          },
          {
            id: 3152,
            regionCode: "632324",
            regionName: "河南蒙古族自治县",
            parentCode: "632300",
            level: 3,
          },
        ],
      },
      {
        id: 3153,
        regionCode: "632500",
        regionName: "海南藏族自治州",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3154,
            regionCode: "632521",
            regionName: "共和县",
            parentCode: "632500",
            level: 3,
          },
          {
            id: 3155,
            regionCode: "632522",
            regionName: "同德县",
            parentCode: "632500",
            level: 3,
          },
          {
            id: 3156,
            regionCode: "632523",
            regionName: "贵德县",
            parentCode: "632500",
            level: 3,
          },
          {
            id: 3157,
            regionCode: "632524",
            regionName: "兴海县",
            parentCode: "632500",
            level: 3,
          },
          {
            id: 3158,
            regionCode: "632525",
            regionName: "贵南县",
            parentCode: "632500",
            level: 3,
          },
        ],
      },
      {
        id: 3159,
        regionCode: "632600",
        regionName: "果洛藏族自治州",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3160,
            regionCode: "632621",
            regionName: "玛沁县",
            parentCode: "632600",
            level: 3,
          },
          {
            id: 3161,
            regionCode: "632622",
            regionName: "班玛县",
            parentCode: "632600",
            level: 3,
          },
          {
            id: 3162,
            regionCode: "632623",
            regionName: "甘德县",
            parentCode: "632600",
            level: 3,
          },
          {
            id: 3163,
            regionCode: "632624",
            regionName: "达日县",
            parentCode: "632600",
            level: 3,
          },
          {
            id: 3164,
            regionCode: "632625",
            regionName: "久治县",
            parentCode: "632600",
            level: 3,
          },
          {
            id: 3165,
            regionCode: "632626",
            regionName: "玛多县",
            parentCode: "632600",
            level: 3,
          },
        ],
      },
      {
        id: 3166,
        regionCode: "632700",
        regionName: "玉树藏族自治州",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3167,
            regionCode: "632701",
            regionName: "玉树市",
            parentCode: "632700",
            level: 3,
          },
          {
            id: 3168,
            regionCode: "632722",
            regionName: "杂多县",
            parentCode: "632700",
            level: 3,
          },
          {
            id: 3169,
            regionCode: "632723",
            regionName: "称多县",
            parentCode: "632700",
            level: 3,
          },
          {
            id: 3170,
            regionCode: "632724",
            regionName: "治多县",
            parentCode: "632700",
            level: 3,
          },
          {
            id: 3171,
            regionCode: "632725",
            regionName: "囊谦县",
            parentCode: "632700",
            level: 3,
          },
          {
            id: 3172,
            regionCode: "632726",
            regionName: "曲麻莱县",
            parentCode: "632700",
            level: 3,
          },
        ],
      },
      {
        id: 3173,
        regionCode: "632800",
        regionName: "海西蒙古族藏族自治州",
        parentCode: "630000",
        level: 2,
        children: [
          {
            id: 3174,
            regionCode: "632801",
            regionName: "格尔木市",
            parentCode: "632800",
            level: 3,
          },
          {
            id: 3175,
            regionCode: "632802",
            regionName: "德令哈市",
            parentCode: "632800",
            level: 3,
          },
          {
            id: 3176,
            regionCode: "632821",
            regionName: "乌兰县",
            parentCode: "632800",
            level: 3,
          },
          {
            id: 3177,
            regionCode: "632822",
            regionName: "都兰县",
            parentCode: "632800",
            level: 3,
          },
          {
            id: 3178,
            regionCode: "632823",
            regionName: "天峻县",
            parentCode: "632800",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3179,
    regionCode: "640000",
    regionName: "宁夏回族自治区",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3180,
        regionCode: "640100",
        regionName: "银川市",
        parentCode: "640000",
        level: 2,
        children: [
          {
            id: 3181,
            regionCode: "640104",
            regionName: "兴庆区",
            parentCode: "640100",
            level: 3,
          },
          {
            id: 3182,
            regionCode: "640105",
            regionName: "西夏区",
            parentCode: "640100",
            level: 3,
          },
          {
            id: 3183,
            regionCode: "640106",
            regionName: "金凤区",
            parentCode: "640100",
            level: 3,
          },
          {
            id: 3184,
            regionCode: "640121",
            regionName: "永宁县",
            parentCode: "640100",
            level: 3,
          },
          {
            id: 3185,
            regionCode: "640122",
            regionName: "贺兰县",
            parentCode: "640100",
            level: 3,
          },
          {
            id: 3186,
            regionCode: "640181",
            regionName: "灵武市",
            parentCode: "640100",
            level: 3,
          },
        ],
      },
      {
        id: 3187,
        regionCode: "640200",
        regionName: "石嘴山市",
        parentCode: "640000",
        level: 2,
        children: [
          {
            id: 3188,
            regionCode: "640202",
            regionName: "大武口区",
            parentCode: "640200",
            level: 3,
          },
          {
            id: 3189,
            regionCode: "640205",
            regionName: "惠农区",
            parentCode: "640200",
            level: 3,
          },
          {
            id: 3190,
            regionCode: "640221",
            regionName: "平罗县",
            parentCode: "640200",
            level: 3,
          },
        ],
      },
      {
        id: 3191,
        regionCode: "640300",
        regionName: "吴忠市",
        parentCode: "640000",
        level: 2,
        children: [
          {
            id: 3192,
            regionCode: "640302",
            regionName: "利通区",
            parentCode: "640300",
            level: 3,
          },
          {
            id: 3193,
            regionCode: "640303",
            regionName: "红寺堡区",
            parentCode: "640300",
            level: 3,
          },
          {
            id: 3194,
            regionCode: "640323",
            regionName: "盐池县",
            parentCode: "640300",
            level: 3,
          },
          {
            id: 3195,
            regionCode: "640324",
            regionName: "同心县",
            parentCode: "640300",
            level: 3,
          },
          {
            id: 3196,
            regionCode: "640381",
            regionName: "青铜峡市",
            parentCode: "640300",
            level: 3,
          },
        ],
      },
      {
        id: 3197,
        regionCode: "640400",
        regionName: "固原市",
        parentCode: "640000",
        level: 2,
        children: [
          {
            id: 3198,
            regionCode: "640402",
            regionName: "原州区",
            parentCode: "640400",
            level: 3,
          },
          {
            id: 3199,
            regionCode: "640422",
            regionName: "西吉县",
            parentCode: "640400",
            level: 3,
          },
          {
            id: 3200,
            regionCode: "640423",
            regionName: "隆德县",
            parentCode: "640400",
            level: 3,
          },
          {
            id: 3201,
            regionCode: "640424",
            regionName: "泾源县",
            parentCode: "640400",
            level: 3,
          },
          {
            id: 3202,
            regionCode: "640425",
            regionName: "彭阳县",
            parentCode: "640400",
            level: 3,
          },
        ],
      },
      {
        id: 3203,
        regionCode: "640500",
        regionName: "中卫市",
        parentCode: "640000",
        level: 2,
        children: [
          {
            id: 3204,
            regionCode: "640502",
            regionName: "沙坡头区",
            parentCode: "640500",
            level: 3,
          },
          {
            id: 3205,
            regionCode: "640521",
            regionName: "中宁县",
            parentCode: "640500",
            level: 3,
          },
          {
            id: 3206,
            regionCode: "640522",
            regionName: "海原县",
            parentCode: "640500",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3207,
    regionCode: "650000",
    regionName: "新疆维吾尔自治区",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3208,
        regionCode: "650100",
        regionName: "乌鲁木齐市",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3209,
            regionCode: "650102",
            regionName: "天山区",
            parentCode: "650100",
            level: 3,
          },
          {
            id: 3210,
            regionCode: "650103",
            regionName: "沙依巴克区",
            parentCode: "650100",
            level: 3,
          },
          {
            id: 3211,
            regionCode: "650104",
            regionName: "新市区",
            parentCode: "650100",
            level: 3,
          },
          {
            id: 3212,
            regionCode: "650105",
            regionName: "水磨沟区",
            parentCode: "650100",
            level: 3,
          },
          {
            id: 3213,
            regionCode: "650106",
            regionName: "头屯河区",
            parentCode: "650100",
            level: 3,
          },
          {
            id: 3214,
            regionCode: "650107",
            regionName: "达坂城区",
            parentCode: "650100",
            level: 3,
          },
          {
            id: 3215,
            regionCode: "650109",
            regionName: "米东区",
            parentCode: "650100",
            level: 3,
          },
          {
            id: 3216,
            regionCode: "650121",
            regionName: "乌鲁木齐县",
            parentCode: "650100",
            level: 3,
          },
        ],
      },
      {
        id: 3217,
        regionCode: "650200",
        regionName: "克拉玛依市",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3218,
            regionCode: "650202",
            regionName: "独山子区",
            parentCode: "650200",
            level: 3,
          },
          {
            id: 3219,
            regionCode: "650203",
            regionName: "克拉玛依区",
            parentCode: "650200",
            level: 3,
          },
          {
            id: 3220,
            regionCode: "650204",
            regionName: "白碱滩区",
            parentCode: "650200",
            level: 3,
          },
          {
            id: 3221,
            regionCode: "650205",
            regionName: "乌尔禾区",
            parentCode: "650200",
            level: 3,
          },
        ],
      },
      {
        id: 3222,
        regionCode: "652100",
        regionName: "吐鲁番地区",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3223,
            regionCode: "652101",
            regionName: "吐鲁番市",
            parentCode: "652100",
            level: 3,
          },
          {
            id: 3224,
            regionCode: "652122",
            regionName: "鄯善县",
            parentCode: "652100",
            level: 3,
          },
          {
            id: 3225,
            regionCode: "652123",
            regionName: "托克逊县",
            parentCode: "652100",
            level: 3,
          },
        ],
      },
      {
        id: 3226,
        regionCode: "652200",
        regionName: "哈密地区",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3227,
            regionCode: "652201",
            regionName: "哈密市",
            parentCode: "652200",
            level: 3,
          },
          {
            id: 3228,
            regionCode: "652222",
            regionName: "巴里坤哈萨克自治县",
            parentCode: "652200",
            level: 3,
          },
          {
            id: 3229,
            regionCode: "652223",
            regionName: "伊吾县",
            parentCode: "652200",
            level: 3,
          },
        ],
      },
      {
        id: 3230,
        regionCode: "652300",
        regionName: "昌吉回族自治州",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3231,
            regionCode: "652301",
            regionName: "昌吉市",
            parentCode: "652300",
            level: 3,
          },
          {
            id: 3232,
            regionCode: "652302",
            regionName: "阜康市",
            parentCode: "652300",
            level: 3,
          },
          {
            id: 3233,
            regionCode: "652323",
            regionName: "呼图壁县",
            parentCode: "652300",
            level: 3,
          },
          {
            id: 3234,
            regionCode: "652324",
            regionName: "玛纳斯县",
            parentCode: "652300",
            level: 3,
          },
          {
            id: 3235,
            regionCode: "652325",
            regionName: "奇台县",
            parentCode: "652300",
            level: 3,
          },
          {
            id: 3236,
            regionCode: "652327",
            regionName: "吉木萨尔县",
            parentCode: "652300",
            level: 3,
          },
          {
            id: 3237,
            regionCode: "652328",
            regionName: "木垒哈萨克自治县",
            parentCode: "652300",
            level: 3,
          },
        ],
      },
      {
        id: 3238,
        regionCode: "652700",
        regionName: "博尔塔拉蒙古自治州",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3239,
            regionCode: "652701",
            regionName: "博乐市",
            parentCode: "652700",
            level: 3,
          },
          {
            id: 3240,
            regionCode: "652702",
            regionName: "阿拉山口市",
            parentCode: "652700",
            level: 3,
          },
          {
            id: 3241,
            regionCode: "652722",
            regionName: "精河县",
            parentCode: "652700",
            level: 3,
          },
          {
            id: 3242,
            regionCode: "652723",
            regionName: "温泉县",
            parentCode: "652700",
            level: 3,
          },
        ],
      },
      {
        id: 3243,
        regionCode: "652800",
        regionName: "巴音郭楞蒙古自治州",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3244,
            regionCode: "652801",
            regionName: "库尔勒市",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3245,
            regionCode: "652822",
            regionName: "轮台县",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3246,
            regionCode: "652823",
            regionName: "尉犁县",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3247,
            regionCode: "652824",
            regionName: "若羌县",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3248,
            regionCode: "652825",
            regionName: "且末县",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3249,
            regionCode: "652826",
            regionName: "焉耆回族自治县",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3250,
            regionCode: "652827",
            regionName: "和静县",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3251,
            regionCode: "652828",
            regionName: "和硕县",
            parentCode: "652800",
            level: 3,
          },
          {
            id: 3252,
            regionCode: "652829",
            regionName: "博湖县",
            parentCode: "652800",
            level: 3,
          },
        ],
      },
      {
        id: 3253,
        regionCode: "652900",
        regionName: "阿克苏地区",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3254,
            regionCode: "652901",
            regionName: "阿克苏市",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3255,
            regionCode: "652922",
            regionName: "温宿县",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3256,
            regionCode: "652923",
            regionName: "库车县",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3257,
            regionCode: "652924",
            regionName: "沙雅县",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3258,
            regionCode: "652925",
            regionName: "新和县",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3259,
            regionCode: "652926",
            regionName: "拜城县",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3260,
            regionCode: "652927",
            regionName: "乌什县",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3261,
            regionCode: "652928",
            regionName: "阿瓦提县",
            parentCode: "652900",
            level: 3,
          },
          {
            id: 3262,
            regionCode: "652929",
            regionName: "柯坪县",
            parentCode: "652900",
            level: 3,
          },
        ],
      },
      {
        id: 3263,
        regionCode: "653000",
        regionName: "克孜勒苏柯尔克孜自治州",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3264,
            regionCode: "653001",
            regionName: "阿图什市",
            parentCode: "653000",
            level: 3,
          },
          {
            id: 3265,
            regionCode: "653022",
            regionName: "阿克陶县",
            parentCode: "653000",
            level: 3,
          },
          {
            id: 3266,
            regionCode: "653023",
            regionName: "阿合奇县",
            parentCode: "653000",
            level: 3,
          },
          {
            id: 3267,
            regionCode: "653024",
            regionName: "乌恰县",
            parentCode: "653000",
            level: 3,
          },
        ],
      },
      {
        id: 3268,
        regionCode: "653100",
        regionName: "喀什地区",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3269,
            regionCode: "653101",
            regionName: "喀什市",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3270,
            regionCode: "653121",
            regionName: "疏附县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3271,
            regionCode: "653122",
            regionName: "疏勒县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3272,
            regionCode: "653123",
            regionName: "英吉沙县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3273,
            regionCode: "653124",
            regionName: "泽普县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3274,
            regionCode: "653125",
            regionName: "莎车县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3275,
            regionCode: "653126",
            regionName: "叶城县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3276,
            regionCode: "653127",
            regionName: "麦盖提县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3277,
            regionCode: "653128",
            regionName: "岳普湖县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3278,
            regionCode: "653129",
            regionName: "伽师县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3279,
            regionCode: "653130",
            regionName: "巴楚县",
            parentCode: "653100",
            level: 3,
          },
          {
            id: 3280,
            regionCode: "653131",
            regionName: "塔什库尔干塔吉克自治县",
            parentCode: "653100",
            level: 3,
          },
        ],
      },
      {
        id: 3281,
        regionCode: "653200",
        regionName: "和田地区",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3282,
            regionCode: "653201",
            regionName: "和田市",
            parentCode: "653200",
            level: 3,
          },
          {
            id: 3283,
            regionCode: "653221",
            regionName: "和田县",
            parentCode: "653200",
            level: 3,
          },
          {
            id: 3284,
            regionCode: "653222",
            regionName: "墨玉县",
            parentCode: "653200",
            level: 3,
          },
          {
            id: 3285,
            regionCode: "653223",
            regionName: "皮山县",
            parentCode: "653200",
            level: 3,
          },
          {
            id: 3286,
            regionCode: "653224",
            regionName: "洛浦县",
            parentCode: "653200",
            level: 3,
          },
          {
            id: 3287,
            regionCode: "653225",
            regionName: "策勒县",
            parentCode: "653200",
            level: 3,
          },
          {
            id: 3288,
            regionCode: "653226",
            regionName: "于田县",
            parentCode: "653200",
            level: 3,
          },
          {
            id: 3289,
            regionCode: "653227",
            regionName: "民丰县",
            parentCode: "653200",
            level: 3,
          },
        ],
      },
      {
        id: 3290,
        regionCode: "654000",
        regionName: "伊犁哈萨克自治州",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3291,
            regionCode: "654002",
            regionName: "伊宁市",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3292,
            regionCode: "654003",
            regionName: "奎屯市",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3293,
            regionCode: "654004",
            regionName: "霍尔果斯市",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3294,
            regionCode: "654021",
            regionName: "伊宁县",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3295,
            regionCode: "654022",
            regionName: "察布查尔锡伯自治县",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3296,
            regionCode: "654023",
            regionName: "霍城县",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3297,
            regionCode: "654024",
            regionName: "巩留县",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3298,
            regionCode: "654025",
            regionName: "新源县",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3299,
            regionCode: "654026",
            regionName: "昭苏县",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3300,
            regionCode: "654027",
            regionName: "特克斯县",
            parentCode: "654000",
            level: 3,
          },
          {
            id: 3301,
            regionCode: "654028",
            regionName: "尼勒克县",
            parentCode: "654000",
            level: 3,
          },
        ],
      },
      {
        id: 3302,
        regionCode: "654200",
        regionName: "塔城地区",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3303,
            regionCode: "654201",
            regionName: "塔城市",
            parentCode: "654200",
            level: 3,
          },
          {
            id: 3304,
            regionCode: "654202",
            regionName: "乌苏市",
            parentCode: "654200",
            level: 3,
          },
          {
            id: 3305,
            regionCode: "654221",
            regionName: "额敏县",
            parentCode: "654200",
            level: 3,
          },
          {
            id: 3306,
            regionCode: "654223",
            regionName: "沙湾县",
            parentCode: "654200",
            level: 3,
          },
          {
            id: 3307,
            regionCode: "654224",
            regionName: "托里县",
            parentCode: "654200",
            level: 3,
          },
          {
            id: 3308,
            regionCode: "654225",
            regionName: "裕民县",
            parentCode: "654200",
            level: 3,
          },
          {
            id: 3309,
            regionCode: "654226",
            regionName: "和布克赛尔蒙古自治县",
            parentCode: "654200",
            level: 3,
          },
        ],
      },
      {
        id: 3310,
        regionCode: "654300",
        regionName: "阿勒泰地区",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3311,
            regionCode: "654301",
            regionName: "阿勒泰市",
            parentCode: "654300",
            level: 3,
          },
          {
            id: 3312,
            regionCode: "654321",
            regionName: "布尔津县",
            parentCode: "654300",
            level: 3,
          },
          {
            id: 3313,
            regionCode: "654322",
            regionName: "富蕴县",
            parentCode: "654300",
            level: 3,
          },
          {
            id: 3314,
            regionCode: "654323",
            regionName: "福海县",
            parentCode: "654300",
            level: 3,
          },
          {
            id: 3315,
            regionCode: "654324",
            regionName: "哈巴河县",
            parentCode: "654300",
            level: 3,
          },
          {
            id: 3316,
            regionCode: "654325",
            regionName: "青河县",
            parentCode: "654300",
            level: 3,
          },
          {
            id: 3317,
            regionCode: "654326",
            regionName: "吉木乃县",
            parentCode: "654300",
            level: 3,
          },
        ],
      },
      {
        id: 3318,
        regionCode: "659000",
        regionName: "直辖县级",
        parentCode: "650000",
        level: 2,
        children: [
          {
            id: 3319,
            regionCode: "659001",
            regionName: "石河子市",
            parentCode: "659000",
            level: 3,
          },
          {
            id: 3320,
            regionCode: "659002",
            regionName: "阿拉尔市",
            parentCode: "659000",
            level: 3,
          },
          {
            id: 3321,
            regionCode: "659003",
            regionName: "图木舒克市",
            parentCode: "659000",
            level: 3,
          },
          {
            id: 3322,
            regionCode: "659004",
            regionName: "五家渠市",
            parentCode: "659000",
            level: 3,
          },
          {
            id: 3323,
            regionCode: "659005",
            regionName: "北屯市",
            parentCode: "659000",
            level: 3,
          },
          {
            id: 3324,
            regionCode: "659006",
            regionName: "铁门关市",
            parentCode: "659000",
            level: 3,
          },
          {
            id: 3325,
            regionCode: "659007",
            regionName: "双河市",
            parentCode: "659000",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3326,
    regionCode: "710000",
    regionName: "台湾",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3327,
        regionCode: "710100",
        regionName: "台北市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3328,
            regionCode: "710101",
            regionName: "松山区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3329,
            regionCode: "710102",
            regionName: "信义区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3330,
            regionCode: "710103",
            regionName: "大安区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3331,
            regionCode: "710104",
            regionName: "中山区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3332,
            regionCode: "710105",
            regionName: "中正区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3333,
            regionCode: "710106",
            regionName: "大同区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3334,
            regionCode: "710107",
            regionName: "万华区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3335,
            regionCode: "710108",
            regionName: "文山区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3336,
            regionCode: "710109",
            regionName: "南港区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3337,
            regionCode: "710110",
            regionName: "内湖区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3338,
            regionCode: "710111",
            regionName: "士林区",
            parentCode: "710100",
            level: 3,
          },
          {
            id: 3339,
            regionCode: "710112",
            regionName: "北投区",
            parentCode: "710100",
            level: 3,
          },
        ],
      },
      {
        id: 3340,
        regionCode: "710200",
        regionName: "高雄市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3341,
            regionCode: "710201",
            regionName: "盐埕区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3342,
            regionCode: "710202",
            regionName: "鼓山区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3343,
            regionCode: "710203",
            regionName: "左营区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3344,
            regionCode: "710204",
            regionName: "楠梓区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3345,
            regionCode: "710205",
            regionName: "三民区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3346,
            regionCode: "710206",
            regionName: "新兴区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3347,
            regionCode: "710207",
            regionName: "前金区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3348,
            regionCode: "710208",
            regionName: "苓雅区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3349,
            regionCode: "710209",
            regionName: "前镇区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3350,
            regionCode: "710210",
            regionName: "旗津区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3351,
            regionCode: "710211",
            regionName: "小港区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3352,
            regionCode: "710212",
            regionName: "凤山区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3353,
            regionCode: "710213",
            regionName: "林园区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3354,
            regionCode: "710214",
            regionName: "大寮区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3355,
            regionCode: "710215",
            regionName: "大树区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3356,
            regionCode: "710216",
            regionName: "大社区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3357,
            regionCode: "710217",
            regionName: "仁武区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3358,
            regionCode: "710218",
            regionName: "鸟松区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3359,
            regionCode: "710219",
            regionName: "冈山区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3360,
            regionCode: "710220",
            regionName: "桥头区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3361,
            regionCode: "710221",
            regionName: "燕巢区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3362,
            regionCode: "710222",
            regionName: "田寮区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3363,
            regionCode: "710223",
            regionName: "阿莲区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3364,
            regionCode: "710224",
            regionName: "路竹区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3365,
            regionCode: "710225",
            regionName: "湖内区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3366,
            regionCode: "710226",
            regionName: "茄萣区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3367,
            regionCode: "710227",
            regionName: "永安区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3368,
            regionCode: "710228",
            regionName: "弥陀区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3369,
            regionCode: "710229",
            regionName: "梓官区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3370,
            regionCode: "710230",
            regionName: "旗山区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3371,
            regionCode: "710231",
            regionName: "美浓区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3372,
            regionCode: "710232",
            regionName: "六龟区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3373,
            regionCode: "710233",
            regionName: "甲仙区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3374,
            regionCode: "710234",
            regionName: "杉林区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3375,
            regionCode: "710235",
            regionName: "内门区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3376,
            regionCode: "710236",
            regionName: "茂林区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3377,
            regionCode: "710237",
            regionName: "桃源区",
            parentCode: "710200",
            level: 3,
          },
          {
            id: 3378,
            regionCode: "710238",
            regionName: "那玛夏区",
            parentCode: "710200",
            level: 3,
          },
        ],
      },
      {
        id: 3379,
        regionCode: "710300",
        regionName: "基隆市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3380,
            regionCode: "710301",
            regionName: "中正区",
            parentCode: "710300",
            level: 3,
          },
          {
            id: 3381,
            regionCode: "710302",
            regionName: "七堵区",
            parentCode: "710300",
            level: 3,
          },
          {
            id: 3382,
            regionCode: "710303",
            regionName: "暖暖区",
            parentCode: "710300",
            level: 3,
          },
          {
            id: 3383,
            regionCode: "710304",
            regionName: "仁爱区",
            parentCode: "710300",
            level: 3,
          },
          {
            id: 3384,
            regionCode: "710305",
            regionName: "中山区",
            parentCode: "710300",
            level: 3,
          },
          {
            id: 3385,
            regionCode: "710306",
            regionName: "安乐区",
            parentCode: "710300",
            level: 3,
          },
          {
            id: 3386,
            regionCode: "710307",
            regionName: "信义区",
            parentCode: "710300",
            level: 3,
          },
        ],
      },
      {
        id: 3387,
        regionCode: "710400",
        regionName: "台中市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3388,
            regionCode: "710401",
            regionName: "中区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3389,
            regionCode: "710402",
            regionName: "东区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3390,
            regionCode: "710403",
            regionName: "南区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3391,
            regionCode: "710404",
            regionName: "西区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3392,
            regionCode: "710405",
            regionName: "北区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3393,
            regionCode: "710406",
            regionName: "西屯区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3394,
            regionCode: "710407",
            regionName: "南屯区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3395,
            regionCode: "710408",
            regionName: "北屯区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3396,
            regionCode: "710409",
            regionName: "丰原区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3397,
            regionCode: "710410",
            regionName: "东势区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3398,
            regionCode: "710411",
            regionName: "大甲区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3399,
            regionCode: "710412",
            regionName: "清水区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3400,
            regionCode: "710413",
            regionName: "沙鹿区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3401,
            regionCode: "710414",
            regionName: "梧栖区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3402,
            regionCode: "710415",
            regionName: "后里区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3403,
            regionCode: "710416",
            regionName: "神冈区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3404,
            regionCode: "710417",
            regionName: "潭子区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3405,
            regionCode: "710418",
            regionName: "大雅区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3406,
            regionCode: "710419",
            regionName: "新社区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3407,
            regionCode: "710420",
            regionName: "石冈区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3408,
            regionCode: "710421",
            regionName: "外埔区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3409,
            regionCode: "710422",
            regionName: "大安区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3410,
            regionCode: "710423",
            regionName: "乌日区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3411,
            regionCode: "710424",
            regionName: "大肚区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3412,
            regionCode: "710425",
            regionName: "龙井区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3413,
            regionCode: "710426",
            regionName: "雾峰区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3414,
            regionCode: "710427",
            regionName: "太平区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3415,
            regionCode: "710428",
            regionName: "大里区",
            parentCode: "710400",
            level: 3,
          },
          {
            id: 3416,
            regionCode: "710429",
            regionName: "和平区",
            parentCode: "710400",
            level: 3,
          },
        ],
      },
      {
        id: 3417,
        regionCode: "710500",
        regionName: "台南市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3418,
            regionCode: "710501",
            regionName: "东区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3419,
            regionCode: "710502",
            regionName: "南区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3420,
            regionCode: "710504",
            regionName: "北区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3421,
            regionCode: "710506",
            regionName: "安南区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3422,
            regionCode: "710507",
            regionName: "安平区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3423,
            regionCode: "710508",
            regionName: "中西区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3424,
            regionCode: "710509",
            regionName: "新营区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3425,
            regionCode: "710510",
            regionName: "盐水区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3426,
            regionCode: "710511",
            regionName: "白河区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3427,
            regionCode: "710512",
            regionName: "柳营区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3428,
            regionCode: "710513",
            regionName: "后壁区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3429,
            regionCode: "710514",
            regionName: "东山区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3430,
            regionCode: "710515",
            regionName: "麻豆区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3431,
            regionCode: "710516",
            regionName: "下营区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3432,
            regionCode: "710517",
            regionName: "六甲区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3433,
            regionCode: "710518",
            regionName: "官田区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3434,
            regionCode: "710519",
            regionName: "大内区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3435,
            regionCode: "710520",
            regionName: "佳里区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3436,
            regionCode: "710521",
            regionName: "学甲区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3437,
            regionCode: "710522",
            regionName: "西港区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3438,
            regionCode: "710523",
            regionName: "七股区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3439,
            regionCode: "710524",
            regionName: "将军区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3440,
            regionCode: "710525",
            regionName: "北门区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3441,
            regionCode: "710526",
            regionName: "新化区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3442,
            regionCode: "710527",
            regionName: "善化区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3443,
            regionCode: "710528",
            regionName: "新市区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3444,
            regionCode: "710529",
            regionName: "安定区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3445,
            regionCode: "710530",
            regionName: "山上区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3446,
            regionCode: "710531",
            regionName: "玉井区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3447,
            regionCode: "710532",
            regionName: "楠西区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3448,
            regionCode: "710533",
            regionName: "南化区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3449,
            regionCode: "710534",
            regionName: "左镇区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3450,
            regionCode: "710535",
            regionName: "仁德区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3451,
            regionCode: "710536",
            regionName: "归仁区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3452,
            regionCode: "710537",
            regionName: "关庙区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3453,
            regionCode: "710538",
            regionName: "龙崎区",
            parentCode: "710500",
            level: 3,
          },
          {
            id: 3454,
            regionCode: "710539",
            regionName: "永康区",
            parentCode: "710500",
            level: 3,
          },
        ],
      },
      {
        id: 3455,
        regionCode: "710600",
        regionName: "新竹市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3456,
            regionCode: "710601",
            regionName: "东区",
            parentCode: "710600",
            level: 3,
          },
          {
            id: 3457,
            regionCode: "710602",
            regionName: "北区",
            parentCode: "710600",
            level: 3,
          },
          {
            id: 3458,
            regionCode: "710603",
            regionName: "香山区",
            parentCode: "710600",
            level: 3,
          },
        ],
      },
      {
        id: 3459,
        regionCode: "710700",
        regionName: "嘉义市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3460,
            regionCode: "710701",
            regionName: "东区",
            parentCode: "710700",
            level: 3,
          },
          {
            id: 3461,
            regionCode: "710702",
            regionName: "西区",
            parentCode: "710700",
            level: 3,
          },
        ],
      },
      {
        id: 3462,
        regionCode: "710800",
        regionName: "新北市",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3463,
            regionCode: "710801",
            regionName: "板桥区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3464,
            regionCode: "710802",
            regionName: "三重区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3465,
            regionCode: "710803",
            regionName: "中和区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3466,
            regionCode: "710804",
            regionName: "永和区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3467,
            regionCode: "710805",
            regionName: "新庄区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3468,
            regionCode: "710806",
            regionName: "新店区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3469,
            regionCode: "710807",
            regionName: "树林区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3470,
            regionCode: "710808",
            regionName: "莺歌区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3471,
            regionCode: "710809",
            regionName: "三峡区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3472,
            regionCode: "710810",
            regionName: "淡水区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3473,
            regionCode: "710811",
            regionName: "汐止区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3474,
            regionCode: "710812",
            regionName: "瑞芳区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3475,
            regionCode: "710813",
            regionName: "土城区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3476,
            regionCode: "710814",
            regionName: "芦洲区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3477,
            regionCode: "710815",
            regionName: "五股区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3478,
            regionCode: "710816",
            regionName: "泰山区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3479,
            regionCode: "710817",
            regionName: "林口区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3480,
            regionCode: "710818",
            regionName: "深坑区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3481,
            regionCode: "710819",
            regionName: "石碇区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3482,
            regionCode: "710820",
            regionName: "坪林区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3483,
            regionCode: "710821",
            regionName: "三芝区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3484,
            regionCode: "710822",
            regionName: "石门区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3485,
            regionCode: "710823",
            regionName: "八里区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3486,
            regionCode: "710824",
            regionName: "平溪区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3487,
            regionCode: "710825",
            regionName: "双溪区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3488,
            regionCode: "710826",
            regionName: "贡寮区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3489,
            regionCode: "710827",
            regionName: "金山区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3490,
            regionCode: "710828",
            regionName: "万里区",
            parentCode: "710800",
            level: 3,
          },
          {
            id: 3491,
            regionCode: "710829",
            regionName: "乌来区",
            parentCode: "710800",
            level: 3,
          },
        ],
      },
      {
        id: 3492,
        regionCode: "712200",
        regionName: "宜兰县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3493,
            regionCode: "712201",
            regionName: "宜兰市",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3494,
            regionCode: "712221",
            regionName: "罗东镇",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3495,
            regionCode: "712222",
            regionName: "苏澳镇",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3496,
            regionCode: "712223",
            regionName: "头城镇",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3497,
            regionCode: "712224",
            regionName: "礁溪乡",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3498,
            regionCode: "712225",
            regionName: "壮围乡",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3499,
            regionCode: "712226",
            regionName: "员山乡",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3500,
            regionCode: "712227",
            regionName: "冬山乡",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3501,
            regionCode: "712228",
            regionName: "五结乡",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3502,
            regionCode: "712229",
            regionName: "三星乡",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3503,
            regionCode: "712230",
            regionName: "大同乡",
            parentCode: "712200",
            level: 3,
          },
          {
            id: 3504,
            regionCode: "712231",
            regionName: "南澳乡",
            parentCode: "712200",
            level: 3,
          },
        ],
      },
      {
        id: 3505,
        regionCode: "712300",
        regionName: "桃园县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3506,
            regionCode: "712301",
            regionName: "桃园市",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3507,
            regionCode: "712302",
            regionName: "中坜市",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3508,
            regionCode: "712303",
            regionName: "平镇市",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3509,
            regionCode: "712304",
            regionName: "八德市",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3510,
            regionCode: "712305",
            regionName: "杨梅市",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3511,
            regionCode: "712306",
            regionName: "芦竹市",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3512,
            regionCode: "712321",
            regionName: "大溪镇",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3513,
            regionCode: "712324",
            regionName: "大园乡",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3514,
            regionCode: "712325",
            regionName: "龟山乡",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3515,
            regionCode: "712327",
            regionName: "龙潭乡",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3516,
            regionCode: "712329",
            regionName: "新屋乡",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3517,
            regionCode: "712330",
            regionName: "观音乡",
            parentCode: "712300",
            level: 3,
          },
          {
            id: 3518,
            regionCode: "712331",
            regionName: "复兴乡",
            parentCode: "712300",
            level: 3,
          },
        ],
      },
      {
        id: 3519,
        regionCode: "712400",
        regionName: "新竹县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3520,
            regionCode: "712401",
            regionName: "竹北市",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3521,
            regionCode: "712421",
            regionName: "竹东镇",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3522,
            regionCode: "712422",
            regionName: "新埔镇",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3523,
            regionCode: "712423",
            regionName: "关西镇",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3524,
            regionCode: "712424",
            regionName: "湖口乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3525,
            regionCode: "712425",
            regionName: "新丰乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3526,
            regionCode: "712426",
            regionName: "芎林乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3527,
            regionCode: "712427",
            regionName: "横山乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3528,
            regionCode: "712428",
            regionName: "北埔乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3529,
            regionCode: "712429",
            regionName: "宝山乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3530,
            regionCode: "712430",
            regionName: "峨眉乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3531,
            regionCode: "712431",
            regionName: "尖石乡",
            parentCode: "712400",
            level: 3,
          },
          {
            id: 3532,
            regionCode: "712432",
            regionName: "五峰乡",
            parentCode: "712400",
            level: 3,
          },
        ],
      },
      {
        id: 3533,
        regionCode: "712500",
        regionName: "苗栗县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3534,
            regionCode: "712501",
            regionName: "苗栗市",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3535,
            regionCode: "712521",
            regionName: "苑里镇",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3536,
            regionCode: "712522",
            regionName: "通霄镇",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3537,
            regionCode: "712523",
            regionName: "竹南镇",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3538,
            regionCode: "712524",
            regionName: "头份镇",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3539,
            regionCode: "712525",
            regionName: "后龙镇",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3540,
            regionCode: "712526",
            regionName: "卓兰镇",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3541,
            regionCode: "712527",
            regionName: "大湖乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3542,
            regionCode: "712528",
            regionName: "公馆乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3543,
            regionCode: "712529",
            regionName: "铜锣乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3544,
            regionCode: "712530",
            regionName: "南庄乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3545,
            regionCode: "712531",
            regionName: "头屋乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3546,
            regionCode: "712532",
            regionName: "三义乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3547,
            regionCode: "712533",
            regionName: "西湖乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3548,
            regionCode: "712534",
            regionName: "造桥乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3549,
            regionCode: "712535",
            regionName: "三湾乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3550,
            regionCode: "712536",
            regionName: "狮潭乡",
            parentCode: "712500",
            level: 3,
          },
          {
            id: 3551,
            regionCode: "712537",
            regionName: "泰安乡",
            parentCode: "712500",
            level: 3,
          },
        ],
      },
      {
        id: 3552,
        regionCode: "712700",
        regionName: "彰化县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3553,
            regionCode: "712701",
            regionName: "彰化市",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3554,
            regionCode: "712721",
            regionName: "鹿港镇",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3555,
            regionCode: "712722",
            regionName: "和美镇",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3556,
            regionCode: "712723",
            regionName: "线西乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3557,
            regionCode: "712724",
            regionName: "伸港乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3558,
            regionCode: "712725",
            regionName: "福兴乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3559,
            regionCode: "712726",
            regionName: "秀水乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3560,
            regionCode: "712727",
            regionName: "花坛乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3561,
            regionCode: "712728",
            regionName: "芬园乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3562,
            regionCode: "712729",
            regionName: "员林镇",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3563,
            regionCode: "712730",
            regionName: "溪湖镇",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3564,
            regionCode: "712731",
            regionName: "田中镇",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3565,
            regionCode: "712732",
            regionName: "大村乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3566,
            regionCode: "712733",
            regionName: "埔盐乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3567,
            regionCode: "712734",
            regionName: "埔心乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3568,
            regionCode: "712735",
            regionName: "永靖乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3569,
            regionCode: "712736",
            regionName: "社头乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3570,
            regionCode: "712737",
            regionName: "二水乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3571,
            regionCode: "712738",
            regionName: "北斗镇",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3572,
            regionCode: "712739",
            regionName: "二林镇",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3573,
            regionCode: "712740",
            regionName: "田尾乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3574,
            regionCode: "712741",
            regionName: "埤头乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3575,
            regionCode: "712742",
            regionName: "芳苑乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3576,
            regionCode: "712743",
            regionName: "大城乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3577,
            regionCode: "712744",
            regionName: "竹塘乡",
            parentCode: "712700",
            level: 3,
          },
          {
            id: 3578,
            regionCode: "712745",
            regionName: "溪州乡",
            parentCode: "712700",
            level: 3,
          },
        ],
      },
      {
        id: 3579,
        regionCode: "712800",
        regionName: "南投县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3580,
            regionCode: "712801",
            regionName: "南投市",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3581,
            regionCode: "712821",
            regionName: "埔里镇",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3582,
            regionCode: "712822",
            regionName: "草屯镇",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3583,
            regionCode: "712823",
            regionName: "竹山镇",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3584,
            regionCode: "712824",
            regionName: "集集镇",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3585,
            regionCode: "712825",
            regionName: "名间乡",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3586,
            regionCode: "712826",
            regionName: "鹿谷乡",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3587,
            regionCode: "712827",
            regionName: "中寮乡",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3588,
            regionCode: "712828",
            regionName: "鱼池乡",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3589,
            regionCode: "712829",
            regionName: "国姓乡",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3590,
            regionCode: "712830",
            regionName: "水里乡",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3591,
            regionCode: "712831",
            regionName: "信义乡",
            parentCode: "712800",
            level: 3,
          },
          {
            id: 3592,
            regionCode: "712832",
            regionName: "仁爱乡",
            parentCode: "712800",
            level: 3,
          },
        ],
      },
      {
        id: 3593,
        regionCode: "712900",
        regionName: "云林县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3594,
            regionCode: "712901",
            regionName: "斗六市",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3595,
            regionCode: "712921",
            regionName: "斗南镇",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3596,
            regionCode: "712922",
            regionName: "虎尾镇",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3597,
            regionCode: "712923",
            regionName: "西螺镇",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3598,
            regionCode: "712924",
            regionName: "土库镇",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3599,
            regionCode: "712925",
            regionName: "北港镇",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3600,
            regionCode: "712926",
            regionName: "古坑乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3601,
            regionCode: "712927",
            regionName: "大埤乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3602,
            regionCode: "712928",
            regionName: "莿桐乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3603,
            regionCode: "712929",
            regionName: "林内乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3604,
            regionCode: "712930",
            regionName: "二仑乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3605,
            regionCode: "712931",
            regionName: "仑背乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3606,
            regionCode: "712932",
            regionName: "麦寮乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3607,
            regionCode: "712933",
            regionName: "东势乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3608,
            regionCode: "712934",
            regionName: "褒忠乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3609,
            regionCode: "712935",
            regionName: "台西乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3610,
            regionCode: "712936",
            regionName: "元长乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3611,
            regionCode: "712937",
            regionName: "四湖乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3612,
            regionCode: "712938",
            regionName: "口湖乡",
            parentCode: "712900",
            level: 3,
          },
          {
            id: 3613,
            regionCode: "712939",
            regionName: "水林乡",
            parentCode: "712900",
            level: 3,
          },
        ],
      },
      {
        id: 3614,
        regionCode: "713000",
        regionName: "嘉义县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3615,
            regionCode: "713001",
            regionName: "太保市",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3616,
            regionCode: "713002",
            regionName: "朴子市",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3617,
            regionCode: "713023",
            regionName: "布袋镇",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3618,
            regionCode: "713024",
            regionName: "大林镇",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3619,
            regionCode: "713025",
            regionName: "民雄乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3620,
            regionCode: "713026",
            regionName: "溪口乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3621,
            regionCode: "713027",
            regionName: "新港乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3622,
            regionCode: "713028",
            regionName: "六脚乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3623,
            regionCode: "713029",
            regionName: "东石乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3624,
            regionCode: "713030",
            regionName: "义竹乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3625,
            regionCode: "713031",
            regionName: "鹿草乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3626,
            regionCode: "713032",
            regionName: "水上乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3627,
            regionCode: "713033",
            regionName: "中埔乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3628,
            regionCode: "713034",
            regionName: "竹崎乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3629,
            regionCode: "713035",
            regionName: "梅山乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3630,
            regionCode: "713036",
            regionName: "番路乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3631,
            regionCode: "713037",
            regionName: "大埔乡",
            parentCode: "713000",
            level: 3,
          },
          {
            id: 3632,
            regionCode: "713038",
            regionName: "阿里山乡",
            parentCode: "713000",
            level: 3,
          },
        ],
      },
      {
        id: 3633,
        regionCode: "713300",
        regionName: "屏东县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3634,
            regionCode: "713301",
            regionName: "屏东市",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3635,
            regionCode: "713321",
            regionName: "潮州镇",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3636,
            regionCode: "713322",
            regionName: "东港镇",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3637,
            regionCode: "713323",
            regionName: "恒春镇",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3638,
            regionCode: "713324",
            regionName: "万丹乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3639,
            regionCode: "713325",
            regionName: "长治乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3640,
            regionCode: "713326",
            regionName: "麟洛乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3641,
            regionCode: "713327",
            regionName: "九如乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3642,
            regionCode: "713328",
            regionName: "里港乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3643,
            regionCode: "713329",
            regionName: "盐埔乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3644,
            regionCode: "713330",
            regionName: "高树乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3645,
            regionCode: "713331",
            regionName: "万峦乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3646,
            regionCode: "713332",
            regionName: "内埔乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3647,
            regionCode: "713333",
            regionName: "竹田乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3648,
            regionCode: "713334",
            regionName: "新埤乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3649,
            regionCode: "713335",
            regionName: "枋寮乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3650,
            regionCode: "713336",
            regionName: "新园乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3651,
            regionCode: "713337",
            regionName: "崁顶乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3652,
            regionCode: "713338",
            regionName: "林边乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3653,
            regionCode: "713339",
            regionName: "南州乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3654,
            regionCode: "713340",
            regionName: "佳冬乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3655,
            regionCode: "713341",
            regionName: "琉球乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3656,
            regionCode: "713342",
            regionName: "车城乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3657,
            regionCode: "713343",
            regionName: "满州乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3658,
            regionCode: "713344",
            regionName: "枋山乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3659,
            regionCode: "713345",
            regionName: "三地门乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3660,
            regionCode: "713346",
            regionName: "雾台乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3661,
            regionCode: "713347",
            regionName: "玛家乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3662,
            regionCode: "713348",
            regionName: "泰武乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3663,
            regionCode: "713349",
            regionName: "来义乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3664,
            regionCode: "713350",
            regionName: "春日乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3665,
            regionCode: "713351",
            regionName: "狮子乡",
            parentCode: "713300",
            level: 3,
          },
          {
            id: 3666,
            regionCode: "713352",
            regionName: "牡丹乡",
            parentCode: "713300",
            level: 3,
          },
        ],
      },
      {
        id: 3667,
        regionCode: "713400",
        regionName: "台东县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3668,
            regionCode: "713401",
            regionName: "台东市",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3669,
            regionCode: "713421",
            regionName: "成功镇",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3670,
            regionCode: "713422",
            regionName: "关山镇",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3671,
            regionCode: "713423",
            regionName: "卑南乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3672,
            regionCode: "713424",
            regionName: "鹿野乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3673,
            regionCode: "713425",
            regionName: "池上乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3674,
            regionCode: "713426",
            regionName: "东河乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3675,
            regionCode: "713427",
            regionName: "长滨乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3676,
            regionCode: "713428",
            regionName: "太麻里乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3677,
            regionCode: "713429",
            regionName: "大武乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3678,
            regionCode: "713430",
            regionName: "绿岛乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3679,
            regionCode: "713431",
            regionName: "海端乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3680,
            regionCode: "713432",
            regionName: "延平乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3681,
            regionCode: "713433",
            regionName: "金峰乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3682,
            regionCode: "713434",
            regionName: "达仁乡",
            parentCode: "713400",
            level: 3,
          },
          {
            id: 3683,
            regionCode: "713435",
            regionName: "兰屿乡",
            parentCode: "713400",
            level: 3,
          },
        ],
      },
      {
        id: 3684,
        regionCode: "713500",
        regionName: "花莲县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3685,
            regionCode: "713501",
            regionName: "花莲市",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3686,
            regionCode: "713521",
            regionName: "凤林镇",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3687,
            regionCode: "713522",
            regionName: "玉里镇",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3688,
            regionCode: "713523",
            regionName: "新城乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3689,
            regionCode: "713524",
            regionName: "吉安乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3690,
            regionCode: "713525",
            regionName: "寿丰乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3691,
            regionCode: "713526",
            regionName: "光复乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3692,
            regionCode: "713527",
            regionName: "丰滨乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3693,
            regionCode: "713528",
            regionName: "瑞穗乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3694,
            regionCode: "713529",
            regionName: "富里乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3695,
            regionCode: "713530",
            regionName: "秀林乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3696,
            regionCode: "713531",
            regionName: "万荣乡",
            parentCode: "713500",
            level: 3,
          },
          {
            id: 3697,
            regionCode: "713532",
            regionName: "卓溪乡",
            parentCode: "713500",
            level: 3,
          },
        ],
      },
      {
        id: 3698,
        regionCode: "713600",
        regionName: "澎湖县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3699,
            regionCode: "713601",
            regionName: "马公市",
            parentCode: "713600",
            level: 3,
          },
          {
            id: 3700,
            regionCode: "713621",
            regionName: "湖西乡",
            parentCode: "713600",
            level: 3,
          },
          {
            id: 3701,
            regionCode: "713622",
            regionName: "白沙乡",
            parentCode: "713600",
            level: 3,
          },
          {
            id: 3702,
            regionCode: "713623",
            regionName: "西屿乡",
            parentCode: "713600",
            level: 3,
          },
          {
            id: 3703,
            regionCode: "713624",
            regionName: "望安乡",
            parentCode: "713600",
            level: 3,
          },
          {
            id: 3704,
            regionCode: "713625",
            regionName: "七美乡",
            parentCode: "713600",
            level: 3,
          },
        ],
      },
      {
        id: 3705,
        regionCode: "713700",
        regionName: "金门县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3706,
            regionCode: "713701",
            regionName: "金城镇",
            parentCode: "713700",
            level: 3,
          },
          {
            id: 3707,
            regionCode: "713702",
            regionName: "金湖镇",
            parentCode: "713700",
            level: 3,
          },
          {
            id: 3708,
            regionCode: "713703",
            regionName: "金沙镇",
            parentCode: "713700",
            level: 3,
          },
          {
            id: 3709,
            regionCode: "713704",
            regionName: "金宁乡",
            parentCode: "713700",
            level: 3,
          },
          {
            id: 3710,
            regionCode: "713705",
            regionName: "烈屿乡",
            parentCode: "713700",
            level: 3,
          },
          {
            id: 3711,
            regionCode: "713706",
            regionName: "乌丘乡",
            parentCode: "713700",
            level: 3,
          },
        ],
      },
      {
        id: 3712,
        regionCode: "713800",
        regionName: "连江县",
        parentCode: "710000",
        level: 2,
        children: [
          {
            id: 3713,
            regionCode: "713801",
            regionName: "南竿乡",
            parentCode: "713800",
            level: 3,
          },
          {
            id: 3714,
            regionCode: "713802",
            regionName: "北竿乡",
            parentCode: "713800",
            level: 3,
          },
          {
            id: 3715,
            regionCode: "713803",
            regionName: "莒光乡",
            parentCode: "713800",
            level: 3,
          },
          {
            id: 3716,
            regionCode: "713804",
            regionName: "东引乡",
            parentCode: "713800",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3717,
    regionCode: "810000",
    regionName: "香港特别行政区",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3718,
        regionCode: "810100",
        regionName: "香港岛",
        parentCode: "810000",
        level: 2,
        children: [
          {
            id: 3719,
            regionCode: "810101",
            regionName: "中西区",
            parentCode: "810100",
            level: 3,
          },
          {
            id: 3720,
            regionCode: "810102",
            regionName: "湾仔区",
            parentCode: "810100",
            level: 3,
          },
          {
            id: 3721,
            regionCode: "810103",
            regionName: "东区",
            parentCode: "810100",
            level: 3,
          },
          {
            id: 3722,
            regionCode: "810104",
            regionName: "南区",
            parentCode: "810100",
            level: 3,
          },
        ],
      },
      {
        id: 3723,
        regionCode: "810200",
        regionName: "九龙",
        parentCode: "810000",
        level: 2,
        children: [
          {
            id: 3724,
            regionCode: "810201",
            regionName: "油尖旺区",
            parentCode: "810200",
            level: 3,
          },
          {
            id: 3725,
            regionCode: "810202",
            regionName: "深水埗区",
            parentCode: "810200",
            level: 3,
          },
          {
            id: 3726,
            regionCode: "810203",
            regionName: "九龙城区",
            parentCode: "810200",
            level: 3,
          },
          {
            id: 3727,
            regionCode: "810204",
            regionName: "黄大仙区",
            parentCode: "810200",
            level: 3,
          },
          {
            id: 3728,
            regionCode: "810205",
            regionName: "观塘区",
            parentCode: "810200",
            level: 3,
          },
        ],
      },
      {
        id: 3729,
        regionCode: "810300",
        regionName: "新界",
        parentCode: "810000",
        level: 2,
        children: [
          {
            id: 3730,
            regionCode: "810301",
            regionName: "荃湾区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3731,
            regionCode: "810302",
            regionName: "屯门区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3732,
            regionCode: "810303",
            regionName: "元朗区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3733,
            regionCode: "810304",
            regionName: "北区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3734,
            regionCode: "810305",
            regionName: "大埔区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3735,
            regionCode: "810306",
            regionName: "西贡区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3736,
            regionCode: "810307",
            regionName: "沙田区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3737,
            regionCode: "810308",
            regionName: "葵青区",
            parentCode: "810300",
            level: 3,
          },
          {
            id: 3738,
            regionCode: "810309",
            regionName: "离岛区",
            parentCode: "810300",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3739,
    regionCode: "820000",
    regionName: "澳门特别行政区",
    parentCode: "100000",
    level: 1,
    children: [
      {
        id: 3740,
        regionCode: "820100",
        regionName: "澳门半岛",
        parentCode: "820000",
        level: 2,
        children: [
          {
            id: 3741,
            regionCode: "820101",
            regionName: "花地玛堂区",
            parentCode: "820100",
            level: 3,
          },
          {
            id: 3742,
            regionCode: "820102",
            regionName: "圣安多尼堂区",
            parentCode: "820100",
            level: 3,
          },
          {
            id: 3743,
            regionCode: "820103",
            regionName: "大堂区",
            parentCode: "820100",
            level: 3,
          },
          {
            id: 3744,
            regionCode: "820104",
            regionName: "望德堂区",
            parentCode: "820100",
            level: 3,
          },
          {
            id: 3745,
            regionCode: "820105",
            regionName: "风顺堂区",
            parentCode: "820100",
            level: 3,
          },
        ],
      },
      {
        id: 3746,
        regionCode: "820200",
        regionName: "氹仔岛",
        parentCode: "820000",
        level: 2,
        children: [
          {
            id: 3747,
            regionCode: "820201",
            regionName: "嘉模堂区",
            parentCode: "820200",
            level: 3,
          },
        ],
      },
      {
        id: 3748,
        regionCode: "820300",
        regionName: "路环岛",
        parentCode: "820000",
        level: 2,
        children: [
          {
            id: 3749,
            regionCode: "820301",
            regionName: "圣方济各堂区",
            parentCode: "820300",
            level: 3,
          },
        ],
      },
    ],
  },
  {
    id: 3750,
    regionCode: "900000",
    regionName: "钓鱼岛",
    parentCode: "100000",
    level: 1,
  },
];
